{
  "common": {
    "save": "保存",
    "cancel": "取消",
    "delete": "删除",
    "edit": "编辑",
    "add": "添加",
    "search": "搜索",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功",
    "back": "返回",
    "next": "下一步",
    "previous": "上一步",
    "close": "关闭",
    "appName": "{brand}",
    "searchPlaceholder": "搜索...",
    "connectionReconnecting": "正在重新连接...",
    "connectionLostClickRetry": "连接已断开。点击重试。",
    "connectionOffline": "离线",
    "searchExpandedPlaceholder": "搜索功能或文档...",
    "searchPromptEmpty": "输入以搜索功能或相关文档",
    "searchSectionApplication": "应用",
    "searchSectionDocumentation": "文档",
    "searchNoFeatureResults": "没有与此查询匹配的功能",
    "searchNoDocResults": "没有与此查询匹配的文档",
    "description": "描述",
    "preview": "预览",
    "addTag": "添加标签...",
    "searchProjects": "搜索项目...",
    "searchModels": "搜索模型...",
    "all": "全部",
    "favorites": "收藏",
    "saveChanges": "保存更改",
    "processing": "处理中...",
    "copy": "复制",
    "copied": "已复制",
    "or": "或",
    "searchResource": "搜索{{resource}}...",
    "selectAll": "全选",
    "clearAll": "清除全部",
    "resetToDefault": "重置为默认值",
    "noOptionsAvailable": "无可用选项",
    "noMoreItems": "没有更多项目",
    "clearSearch": "清除搜索",
    "apply": "应用",
    "clear": "清除",
    "yes": "是",
    "no": "否",
    "notResource": "非{{resource}}",
    "afterDate": "在{{date}}之后",
    "beforeDate": "在{{date}}之前",
    "removeFilter": "移除 {{label}} 筛选",
    "removeFilterWithColon": "移除筛选: {{label}}",
    "showResource": "显示{{resource}}",
    "hideResource": "隐藏{{resource}}",
    "filters": "筛选",
    "searchItem": "搜索 {{item}}...",
    "searchItemAria": "搜索 {{item}}",
    "searchPrompts": "搜索提示词...",
    "showItem": "显示 {{item}}",
    "hideItem": "隐藏 {{item}}"
  },
  "productDocs": {
    "title": "产品文档",
    "lead": "入门、模型、工具、智能体工作室、可观测性与管理说明（与平台同源）。",
    "openNewTab": "在新标签页打开",
    "openSameWindow": "在此窗口打开",
    "hint": "部分登录或边缘响应会在不宜嵌入的页面上设置 X-Frame-Options: DENY，因此不在应用内使用 iframe。在新标签页或整页打开可保持点击劫持防护，并推荐阅读文档。"
  },
  "agentStore": {
    "title": "智能体商店",
    "subtitle": "发现并部署企业级 AI 智能体",
    "search": "按名称搜索智能体...",
    "manage": "管理",
    "manageTooltip": "管理智能体商店",
    "loading": "正在加载智能体...",
    "all": "全部",
    "allAgents": "全部智能体",
    "allAgentsCount": "全部智能体（{{count}}）",
    "resultsFound_other": "找到 {{count}} 个智能体",
    "view": "查看",
    "open": "打开",
    "openApp": "打开应用",
    "pending": "待处理",
    "subscribe": "订阅",
    "unnamedAgent": "智能体",
    "categoryOther": "其他",
    "noDescription": "暂无描述",
    "noAgents": "未找到智能体",
    "noAgentsInCategory": "在{{category}}中未找到智能体",
    "tryAdjusting": "请尝试调整搜索或筛选条件"
  },
  "catalogFilters": {
    "filters": "筛选",
    "filtersApplied": "筛选（已应用 {{count}} 项）",
    "clearAll": "全部清除",
    "creator": "创建者",
    "allCreators": "全部创建者",
    "searchCreators": "搜索创建者...",
    "rating": "评分",
    "allRatings": "全部评分",
    "rating5": "5 星",
    "rating4Up": "4 星及以上",
    "rating3Up": "3 星及以上",
    "allOf": "全部 {{label}}"
  },
  "nav": {
    "home": "首页",
    "ideate": "决策智能平台",
    "solutions": "解决方案",
    "agentStore": "智能体商店",
    "projects": "项目",
    "data": "数据",
    "agentStudio": "智能体工作室",
    "agentWorkflows": "智能体工作流",
    "registry": "注册表",
    "registryUnified": "注册表",
    "aiTransparency": "AI 透明度",
    "workflowStore": "工作流商店",
    "workflowRegistry": "工作流注册表",
    "agentDeployments": "智能体部署",
    "workflowDeployments": "工作流部署",
    "workflowStoreBrowse": "浏览工作流",
    "workflowStoreManage": "管理工作流商店",
    "workflowStoreAbout": "工作流详情",
    "simulations": "模拟",
    "evalsSimulations": "评估",
    "benchmarks": "基准测试",
    "monitoring": "监控",
    "cache": "缓存",
    "agentEvals": "智能体评估",
    "evalTemplates": "评估模板",
    "environments": "环境",
    "evaluations": "评估",
    "agents": "智能体",
    "models": "模型",
    "tools": "工具",
    "prompts": "提示",
    "skills": "技能",
    "knowledge": "知识库",
    "connections": "连接",
    "docs": "文档",
    "admin": "管理",
    "platformAdmin": "平台管理",
    "settings": "设置",
    "chat": "聊天",
    "goToHome": "返回首页",
    "userMenu": "用户菜单",
    "account": "账户",
    "switchRole": "切换角色",
    "tenant": "租户",
    "logout": "退出登录",
    "help": "帮助",
    "helpDocumentation": "帮助与文档",
    "themeDarkModeTitle": "深色模式",
    "themeLightModeTitle": "浅色模式",
    "themeSwitchToDarkAria": "切换到深色模式",
    "themeSwitchToLightAria": "切换到浅色模式",
    "sections": {
      "agentDevelop": "智能体开发",
      "observability": "可观测性",
      "agentOps": "智能体运维",
      "resources": "资源",
      "admin": "管理",
      "aiBlueprints": "蓝图",
      "enterpriseOntology": "企业本体"
    },
    "ontologyCanvas": "本体画布",
    "ontoEval": "本体评估",
    "dataModels": "数据模型",
    "kpiLibrary": "KPI库",
    "semanticHub": "语义中心",
    "migrationsStudio": "迁移工作室",
    "dataPipelines": "数据工作室",
    "pipelineDesigner": "机器学习工作室",
    "dataExplorer": "数据资源管理器",
    "dataObservability": "数据可观测性",
    "switchToDataflow": "{brand} 本体工作室",
    "blueprints": "蓝图",
    "autopilot": "智能决策平台",
    "brandMilkyway": "{brand}",
    "brandPlatform": "{brand} Platform",
    "switchToMilkyway": "{brand}",
    "switchToPlatform": "{brand} Platform"
  },
  "settings": {
    "title": "设置",
    "description": "管理您的账户设置和偏好",
    "profile": "用户资料",
    "appearance": "外观",
    "language": "语言",
    "languageDescription": "选择您的首选语言",
    "theme": "主题",
    "light": "浅色",
    "dark": "深色",
    "appearanceHeading": "外观",
    "appearanceSubtitle": "自定义工作区的外观",
    "colorTheme": "配色主题",
    "colorThemeDescription": "为应用选择配色方案",
    "displayModeSection": "显示模式",
    "displayModeDescription": "在浅色与深色模式之间选择",
    "themeDefaultBadge": "默认",
    "loadingAppearance": "正在加载外观设置...",
    "notifications": {
      "title": "通知"
    },
    "integrations": {
      "title": "集成"
    }
  },
  "models": {
    "title": "模型",
    "addModel": "添加模型",
    "editModel": "编辑模型",
    "modelName": "模型名称",
    "provider": "提供商",
    "baseUrl": "基础URL",
    "chat": "聊天",
    "deleteConfirm": "您确定要删除此模型吗？",
    "noModels": "未找到模型",
    "filterProvider": "提供商",
    "filterStatus": "状态",
    "filterCreator": "创建者",
    "statusActive": "活跃",
    "statusDeprecated": "已弃用",
    "columnModelName": "模型名称",
    "columnProvider": "提供商",
    "columnStatus": "状态",
    "columnAccess": "访问权限",
    "columnCreatedBy": "创建者",
    "columnCreatedAt": "创建时间",
    "columnUpdatedAt": "更新时间",
    "columnActions": "操作",
    "actionChat": "聊天",
    "actionTestConnection": "测试连接",
    "actionSetDefault": "设为默认",
    "actionRemoveDefault": "取消默认",
    "actionManageAccess": "管理访问权限",
    "actionExport": "导出",
    "actionEdit": "编辑",
    "actionDelete": "删除",
    "bulkExportSelected": "导出所选",
    "bulkDeleteSelected": "删除所选",
    "modelArena": "模型竞技场",
    "modelArenaTitle": "在模型竞技场中比较 2 个模型",
    "pricingCatalog": "定价目录",
    "pricingCatalogTitle": "查看和编辑每百万标记美元定价区间",
    "deleteModalTitle": "删除模型",
    "deleteModalMessage": "您确定要删除“{{name}}”吗？此操作无法撤销。",
    "bulkDeleteModalTitle": "删除所选模型",
    "bulkDeleteModalMessage": "您确定要删除 {{count}} 个模型吗？此操作无法撤销。",
    "bulkDeleteModalConfirm": "删除 {{count}} 个模型",
    "loadingModels": "正在加载模型...",
    "favorites": "收藏",
    "filterBarTitle": "筛选",
    "searchPlaceholder": "搜索模型...",
    "defaultModelTooltip": "默认模型",
    "pricing": {
      "title": "定价目录",
      "description": "USD/每百万标记 — 按可见模型中最便宜的输入定价排序。使用 {{endpoint}} 比较提供商。",
      "descriptionPrefix": "USD/每百万标记 — 按可见模型中最便宜的输入定价排序。使用",
      "descriptionSuffix": "比较提供商。",
      "allProviders": "所有提供商",
      "fromInput": "起价 ${{price}}/in",
      "fromInputTooltip": "起价 ${{price}} / 1M 输入 (可见模型)",
      "viewMore": "查看更多 {{count}} 项",
      "searchPlaceholder": "搜索模型或提供商…",
      "emptyMessage": "未找到模型。",
      "loadingMessage": "正在加载定价目录…",
      "loadModelsFailed": "加载模型失败",
      "harvestSuccess": "定价采集完成：{{summary}}",
      "harvestFailed": "定价采集失败",
      "modelsPriced": "{{count}} 个模型已定价",
      "modelsPriced_plural": "{{count}} 个模型已定价",
      "skippedCount": "{{count}} 项已跳过",
      "errorsCount": "{{count}} 个错误",
      "errorsCount_plural": "{{count}} 个错误",
      "viewHistory": "查看历史记录",
      "noPricing": "无定价信息",
      "live": "生效中",
      "notOpenEnded": "非开放区间",
      "notOpenEndedTooltip": "最新行为已关闭区间 — 请确保存在用于未来定价的开放区间。",
      "columns": {
        "model": "模型",
        "inputRate": "输入费率",
        "outputRate": "输出费率",
        "interval": "区间",
        "source": "来源"
      },
      "history": {
        "title": "定价历史记录",
        "subtitle": "完整定价历史。生效中的目录行排在首位；手动区间与采集费率均可编辑（采集费率的编辑将作为手动覆盖）。仅手动区间可被删除。",
        "currentCatalogRate": "当前目录费率",
        "liveOpenEnded": "生效中 (开放区间)",
        "notOpenEnded": "非开放区间",
        "notOpenEndedTooltip": "无开放区间 — 显示最近的已关闭区间作为备选。",
        "searchPlaceholder": "搜索来源、日期、费率…",
        "emptyMessage": "未找到符合该搜索条件的定价历史记录。",
        "loadingMessage": "正在加载定价历史记录…",
        "failedToLoad": "加载定价历史记录失败",
        "refresh": "刷新",
        "addManualInterval": "添加手动区间",
        "activeRate": "当前有效费率",
        "historical": "历史费率",
        "effectiveFrom": "生效日期",
        "effectiveUntil": "失效日期",
        "unit": "单位",
        "inputRate": "输入费率",
        "outputRate": "输出费率",
        "source": "来源",
        "deleteModalTitle": "删除定价区间",
        "deleteModalMessage": "您确定要删除此手动定价区间吗？此操作无法撤销。",
        "delete": "删除",
        "intervalAdded": "定价区间已添加",
        "intervalUpdated": "定价区间已更新",
        "intervalDeleted": "定价区间已删除",
        "failedToAdd": "添加定价区间失败",
        "failedToUpdate": "更新定价区间失败",
        "failedToDelete": "删除定价区间失败",
        "units": {
          "perMinute": "每分钟",
          "perMillionChars": "每100万字符",
          "perMillionTokens": "每100万标记"
        }
      },
      "modal": {
        "addTitle": "添加定价区间",
        "editTitle": "编辑定价区间",
        "model": "模型",
        "selectModel": "选择模型...",
        "effectiveFrom": "生效日期",
        "effectiveUntil": "失效日期",
        "effectiveUntilHelp": "可选 — 留空表示开放区间（当前生效定价）。",
        "unit": "单位",
        "unitOptions": {
          "tokens": "每100万标记 (LLM / 嵌入)",
          "minute": "每分钟 (STT / 音频)",
          "chars": "每100万字符 (TTS)"
        },
        "fieldLabels": {
          "usdPerMinute": "USD / 每分钟",
          "outputPriceOptional": "输出价格 (可选)",
          "inputPriceOptional": "输入价格 (可选)",
          "usdPer1MChars": "USD / 每100万字符",
          "inputUsdPer1MTokens": "输入 USD / 每100万标记",
          "outputUsdPer1MTokens": "输出 USD / 每100万标记"
        },
        "validation": {
          "selectModel": "请选择一个模型",
          "effectiveFromRequired": "生效日期为必填项",
          "effectiveFromFormat": "生效日期必须为 YYYY-MM-DD 格式",
          "effectiveUntilFormat": "失效日期必须为 YYYY-MM-DD 格式",
          "effectiveUntilAfterFrom": "失效日期必须在生效日期当天或之后",
          "inputNonNegative": "输入 USD 必须为非负数",
          "outputNonNegative": "输出 USD 必须为非负数"
        },
        "cancel": "取消",
        "save": "保存区间",
        "add": "添加区间",
        "saving": "正在保存..."
      }
    },
    "form": {
      "addTitle": "添加模型",
      "editTitle": "编辑模型",
      "loadingQuota": "正在加载配额...",
      "modelType": "模型类型",
      "cannotChangeTypeAfterCreation": "创建后无法更改 ({{type}})",
      "provider": "提供商",
      "providerTooltip": "选择 AI 提供商。显示与所选模型类型兼容的 {{count}} 个提供商。",
      "showingEmbeddingProviders": "显示 {{count}} 个支持嵌入的提供商",
      "showingTypeProviders": "显示 {{count}} 个 {{type}} 提供商",
      "providerLockedTooltip": "创建后无法更改提供商。",
      "selectModel": "选择模型",
      "optionalTemplate": "(可选模板)",
      "discoverFallbackTooltip": "优先使用上方的“发现”获取实时工作区端点；模板作为备选。",
      "availableModelsTooltip": "从可用的 {{provider}} {{type}} 模型中选择（共 {{count}} 个可用）",
      "selectAModel": "选择模型",
      "selectATypeModel": "选择 {{type}} 模型",
      "discovered": "已发现",
      "baseUrl": "基础URL",
      "baseUrlTooltip": "本地提供商（如 Ollama 或 LM Studio）必填。云提供商可留空。",
      "apiKeyRef": "API密钥引用",
      "apiKeyRefTooltip": "包含提供商 API 密钥的环境变量名称（在后端部署中配置）。",
      "displayName": "显示名称",
      "displayNameModelIdSetTooltip": "模型 ID 将根据上方选择的模型自动设置。",
      "displayNameAutoGeneratedTooltip": "如果未选择模型，模型 ID 将根据显示名称自动生成。",
      "fullModelNamePreview": "完整模型名称预览：",
      "displayNamePlaceholder": "例如：Chat Completion",
      "apiVersion": "API版本",
      "apiVersionTooltip": "网关所需的 API 版本",
      "paramProfile": "参数配置文件",
      "defaultParams": "默认参数 (JSON)",
      "defaultParamsTooltip": "可选的 JSON 对象，包含每次向模型发送请求时的默认参数（例如 temperature、max_tokens）。",
      "testSuccess": "✓ 连接测试成功",
      "testFailed": "✗ 连接测试失败",
      "modelResponse": "模型响应：",
      "testing": "正在测试...",
      "testConnection": "测试连接",
      "testConnectionTitle": "保存前测试连接",
      "addModel": "添加模型",
      "adding": "正在添加...",
      "saving": "正在保存...",
      "quotaExceeded": "模型配额已超限",
      "noChangesToSave": "没有要保存的更改",
      "selectProvider": "选择提供商"
    },
    "tags": {
      "llm": "文本",
      "image": "图像",
      "embedding": "嵌入",
      "audio": "音频",
      "video": "视频",
      "reranker": "重排序",
      "tts": "语音合成",
      "stt": "语音识别"
    },
    "tagDescriptions": {
      "llm": "文本模型为聊天和补全任务生成语言响应",
      "image": "图像模型生成、编辑或分析视觉内容",
      "embedding": "嵌入模型将文本转换为向量嵌入，用于语义搜索和相似度检索",
      "audio": "音频模型处理并生成声音和音乐",
      "video": "视频模型生成和编辑视频内容",
      "reranker": "重排序模型根据与查询的相关性对文档进行评分和排序",
      "tts": "语音模型将文本生成语音 — 不适用于聊天或文本补全",
      "stt": "转录模型将音频转换为文本 — 不适用于聊天或文本补全"
    },
    "emptyState": {
      "permissionDenied": "您没有查看模型的权限。请联系管理员以获取访问权限。",
      "noResultsSearch": "未找到符合您搜索条件的模型。",
      "default": "未找到模型。创建您的第一个模型以开始。"
    }
  },
  "chat": {
    "title": "聊天",
    "placeholder": "输入您的消息...",
    "send": "发送",
    "modelNotSelected": "未选择模型",
    "modelNotFound": "未找到模型",
    "failedToLoad": "加载模型失败",
    "failedToSend": "发送消息失败",
    "ollamaNotRunning": "无法连接到Ollama。请确保Ollama正在运行：ollama serve",
    "modelNotFoundOllama": "未找到模型或Ollama未运行。请检查您的Ollama安装。",
    "backToModels": "返回模型",
    "newChat": "新建聊天",
    "newModelArena": "新建模型竞技场",
    "activeSessionEmpty": "当前会话为空",
    "refreshSessions": "刷新会话",
    "noArenaSessions": "暂无模型竞技场会话",
    "startNewConversation": "开始新对话",
    "rename": "重命名",
    "loadingMore": "加载更多...",
    "endOfSessions": "会话结束",
    "deleteArenaSessionTitle": "删除模型竞技场会话",
    "deleteArenaSessionMessage": "您确定要删除此模型竞技场会话吗？这也将删除两个单独的模型会话。此操作无法撤销。",
    "loadMetaSessionsFailed": "加载竞技场会话失败",
    "sessionRenamed": "会话已重命名",
    "renameSessionFailed": "重命名会话失败",
    "sessionDeleted": "会话已成功删除",
    "deleteSessionFailed": "删除会话失败：{{error}}",
    "modelLocked": "聊天开始后无法更改模型",
    "noModelsAvailable": "无可用模型",
    "addAnotherModel": "添加另一个模型以进行比较",
    "selectModel": "选择模型...",
    "searchModels": "搜索模型...",
    "restoreSplitView": "恢复分屏视图",
    "expandLeftPanel": "展开左侧面板",
    "expandRightPanel": "展开右侧面板",
    "singleModelWarning": "只有一个可用模型。模型竞技场需要两个不同的模型进行比较。",
    "identicalModelWarning": "您在两侧选择了相同的模型。请选择不同的模型进行对比。",
    "startConversationBeforeRating": "请在评分前先开始对话",
    "modelTypeLocked": "聊天开始后无法更改模型类型",
    "modelTypeWithLabel": "模型类型：{{label}}",
    "configuration": "配置",
    "collapse": "折叠",
    "promptTemplate": "提示模板",
    "selectPrompt": "选择提示...",
    "searchPrompts": "搜索提示...",
    "version": "版本",
    "selectVersion": "选择版本...",
    "systemPrompt": "系统提示词",
    "hidePromptContent": "隐藏提示词内容",
    "showPromptContent": "显示提示词内容",
    "skills": "技能",
    "selectSkills": "选择技能...",
    "searchSkills": "搜索技能...",
    "maxSkillsSelected": "最多选择 {{count}} 项技能",
    "noModelSelected": "未选择模型",
    "closeExpandedView": "关闭展开视图",
    "expandToFullView": "展开为全屏视图",
    "leftModel": "左侧模型",
    "rightModel": "右侧模型",
    "left": "左侧",
    "right": "右侧",
    "startConversation": "开始对话",
    "unableToLoadMessages": "无法加载{{side}}消息。请刷新页面。",
    "noImageOrTextReturned": "未返回图像或文本",
    "noVideoReturned": "未返回视频",
    "audioNotSupported": "您的浏览器不支持音频元素。",
    "videoNotSupported": "您的浏览器不支持视频元素。",
    "stop": "停止",
    "record": "录音",
    "stopRecording": "停止录音",
    "startRecording": "开始录音",
    "uploadAudio": "上传音频",
    "recording": "正在录音...",
    "query": "查询",
    "enterSearchQuery": "输入搜索查询...",
    "documentsLabel": "文档（每行一个，至少2个）",
    "compare": "比较",
    "ttsPlaceholder": "输入要合成的文本...",
    "imagePlaceholder": "描述要生成的图像...",
    "videoPlaceholder": "描述要生成的视频...（可能需要几分钟）",
    "enterInput": "输入内容...",
    "dragToResize": "拖动以调整大小 · 双击重置",
    "selectSessionOrNew": "从侧边栏选择会话或新建会话",
    "errorLoadingModels": "加载模型出错",
    "loadingSession": "正在加载会话...",
    "loadingModels": "正在加载模型...",
    "syncedToBoth": "(已同步至双方)",
    "modelArena": {
      "title": "模型竞技场",
      "vs": "VS",
      "selectModel": "选择模型",
      "startConversation": "开始对话",
      "processing": "处理中...",
      "recording": "录音中...",
      "record": "录音",
      "stop": "停止",
      "or": "或",
      "uploadAudio": "上传音频",
      "query": "查询",
      "documents": "文档（每行一个，至少2个）",
      "compare": "比较",
      "enterInput": "输入...",
      "noImageOrText": "未返回图像或文本",
      "noVideoReturned": "未返回视频",
      "copied": "已复制",
      "copy": "复制",
      "copyResponse": "复制响应",
      "startRecording": "开始录音",
      "stopRecording": "停止录音",
      "cannotChangeModel": "开始对话后无法更改模型",
      "cannotChangeType": "开始对话后无法更改模型类型",
      "noModelsAvailable": "没有可用的模型",
      "addAnotherModel": "添加另一个模型进行比较",
      "onlyOneModelAvailable": "只有一个可用模型。模型竞技场需要两个不同的模型进行比较。",
      "sameModelSelected": "您在两侧选择了相同的模型。请选择不同的模型开始比较。",
      "startBeforeRating": "请先开始对话再评分",
      "restoreView": "恢复分屏视图",
      "expandLeft": "展开左侧面板",
      "expandRight": "展开右侧面板",
      "selectModel2": "选择模型...",
      "searchModels": "搜索模型...",
      "syncedToBoth": "{{placeholder}}（同步到两侧）",
      "placeholders": {
        "searchQuery": "输入搜索查询...",
        "rerankDocs": "文档1文本...\n文档2文本...\n文档3文本...",
        "tts": "输入要合成的文本...",
        "image": "描述要生成的图像...",
        "video": "描述要生成的视频...（可能需要几分钟）"
      },
      "types": {
        "llm": "文本",
        "image": "图像",
        "audio": "音频",
        "video": "视频",
        "reranker": "重排序",
        "tts": "语音",
        "stt": "转录"
      },
      "typeDescriptions": {
        "llm": "文本模型用于聊天和补全任务的语言响应生成",
        "image": "图像模型根据文本提示生成或编辑图像",
        "audio": "音频模型处理或生成非语音音频内容",
        "video": "视频模型生成或分析视频内容",
        "reranker": "重排序模型重新排列检索文档以提升 RAG 相关性",
        "tts": "语音模型将文本合成为语音",
        "stt": "转录模型将音频转换为文本"
      }
    },
    "newSession": "新建聊天",
    "noSessionsYet": "尚无模型竞技场会话",
    "startConversationWithModel": "与此模型开始对话",
    "collapseConfig": "收起",
    "expandConfig": "配置",
    "loadingDot": "加载中...",
    "failedToRename": "重命名会话失败",
    "failedToDelete": "删除会话失败",
    "deleteSession": "删除模型竞技场会话",
    "deleteSessionConfirm": "确定要删除此模型竞技场会话吗？这也将删除两个单独的模型会话。此操作无法撤销。",
    "delete": "删除",
    "save": "保存",
    "cancel": "取消",
    "rateSession": "评价会话",
    "rateThisSession": "评价此会话",
    "updateFeedback": "更新反馈",
    "helpful": "有帮助",
    "notHelpful": "无帮助",
    "rated": "评分: {{value}}/10",
    "feedbackProvided": "已提供反馈",
    "startBeforeRating": "在评价此会话之前开始对话",
    "selectHelpful": "提交前请选择有帮助或无帮助",
    "failedToSaveComparisonFeedback": "保存比较反馈失败",
    "feedbackSubmitted": "反馈提交成功",
    "failedToSubmitSessionFeedback": "提交会话反馈失败",
    "model": "模型",
    "sttModel": "语音转文本 (附件)",
    "knowledge": "知识",
    "tools": "工具",
    "settings": "设置"
  },
  "admin": {
    "title": "管理",
    "users": "用户",
    "roles": "角色",
    "pending": "待处理",
    "active": "活跃"
  },
  "solutions": {
    "title": "解决方案",
    "subtitle": "发现并共享代码仓库与代码，快速打开 QA、UAT 与生产环境链接。",
    "addSolution": "添加解决方案",
    "dialogTitle": "添加解决方案",
    "editDialogTitle": "编辑解决方案",
    "submit": "添加到目录",
    "submitEdit": "保存更改",
    "empty": "尚无解决方案。添加第一条以帮助团队更快找到环境。",
    "openGithub": "打开 GitHub 仓库",
    "editSolution": "编辑解决方案",
    "deleteSolution": "删除解决方案",
    "deleteSelected": "删除所选",
    "openEditor": "打开编辑器",
    "sourceGithub": "GitHub 地址",
    "sourceCode": "代码文件",
    "codeHint": "创建后将进入代码编辑器以添加和编辑文件。",
    "shortcutHint": "提示：Ctrl / ⌘ + Enter 提交表单。",
    "toast": {
      "created": "已添加到目录。",
      "updated": "解决方案已更新。",
      "deleted": "解决方案已删除。",
      "bulkDeleted": "已删除 {{deleted}} 个解决方案。已跳过 {{skipped}} 个。",
      "conflict": "此解决方案已在其他地方更改。请刷新页面以加载最新版本。"
    },
    "fields": {
      "name": "解决方案名称",
      "description": "描述",
      "githubUrl": "GitHub 仓库 URL",
      "sourceType": "来源类型",
      "tags": "标签",
      "owner": "所有者"
    },
    "placeholders": {
      "description": "简短摘要（2–3 行）"
    },
    "validation": {
      "nameRequired": "名称不能为空。",
      "nameTooLong": "名称最多 {{max}} 个字符。",
      "descriptionTooLong": "描述最多 {{max}} 个字符。",
      "githubRequired": "必须填写 GitHub URL。",
      "githubInvalid": "请输入有效的 https GitHub 仓库链接。",
      "urlInvalid": "必须是有效的 http(s) URL。"
    },
    "confirmDeleteTitle": "删除解决方案",
    "confirmDeleteMessage": "确定要删除「{{name}}」吗？将永久删除该解决方案及其所有文件。",
    "confirmBulkDeleteTitle": "删除所选解决方案",
    "confirmBulkDeleteMessage": "确定要删除 {{count}} 个解决方案吗？将永久删除这些解决方案及其所有文件。",
    "editor": {
      "explorer": "资源管理器",
      "newFile": "新建文件",
      "noFiles": "尚无文件。",
      "addFirstFile": "添加文件",
      "selectFile": "在资源管理器中选择一个文件开始编辑。",
      "noFileSelected": "未选择文件",
      "saveChanges": "保存更改",
      "saved": "已保存",
      "unsavedChanges": "未保存的更改",
      "deleteFile": "删除文件",
      "confirmDelete": "删除「{{file}}」？此操作无法撤销。",
      "delete": "删除",
      "fileExists": "已存在相同路径的文件。",
      "notFound": "未找到解决方案。",
      "backToList": "返回解决方案",
      "settings": "设置",
      "metadataTitle": "解决方案设置",
      "metadataSaved": "设置已保存。"
    }
  },
  "tenant": {
    "switch": "切换租户",
    "subdomain": "子域名:"
  },
  "home": {
    "tabs": {
      "overview": "概览",
      "agents": "智能体",
      "workflows": "工作流",
      "evals": "评估",
      "sessions": "会话",
      "cost": "成本",
      "platform": "平台"
    },
    "dateRangeAriaLabel": "仪表盘日期范围",
    "sectionInfoAriaLabel": "版块信息",
    "viewLabel": "查看{{label}}",
    "loading": "正在加载仪表盘...",
    "loadFailed": "数据加载失败",
    "retry": "重试",
    "noDataAvailable": "暂无数据",
    "noData": "无数据",
    "quickActions": {
      "createAgent": "创建智能体",
      "newWorkflow": "新建工作流",
      "runEval": "运行评估",
      "aiAgentBuilder": "AI 智能体构建器",
      "aiWorkflowsBuilder": "AI 工作流构建器",
      "agentStore": "智能体商店",
      "tools": "工具"
    },
    "activity": {
      "title": "最近活动",
      "export": "导出",
      "filterAll": "全部",
      "filterUpdate": "更新",
      "filterCreate": "创建",
      "filterDelete": "删除",
      "noActivityFound": "未找到活动记录",
      "actionCreate": "创建",
      "actionUpdate": "更新",
      "actionDelete": "删除",
      "actionRead": "读取",
      "resourceIdTitle": "资源ID",
      "viewAll": "查看全部"
    },
    "overview": {
      "kpi": {
        "totalAgents": "智能体总数",
        "totalAgentsHintDefault": "在所选时间段内创建",
        "totalAgentsHintAllTenants": "在所选时间段内创建 · 所有租户 · 不含已归档",
        "totalAgentsHintStudio": "在所选时间段内创建 · 与智能体工作室范围一致",
        "totalWorkflows": "工作流总数",
        "activeUsers": "活跃用户",
        "activeDeployments": "活跃部署",
        "activeDeploymentsHint": "在所选时间段内创建的活跃部署",
        "sessions": "会话",
        "evalRuns": "评估运行次数",
        "toolCalls": "工具调用次数",
        "archivedDelta": "已归档",
        "totalProjects": "项目总数",
        "activeProjects": "活跃项目",
        "modelsAvailable": "可用模型",
        "toolsAvailable": "可用工具",
        "activeConnections": "活跃连接",
        "pendingApprovals": "待审批",
        "actionNeeded": "需处理"
      },
      "funnel": {
        "active": "活跃",
        "deployments": "部署"
      },
      "series": {
        "agentsCreated": "已创建智能体",
        "projects": "项目",
        "sessions": "会话",
        "workflows": "工作流",
        "evals": "评估",
        "medianRuntime": "中位运行时间（毫秒）",
        "retryRate": "重试率 %",
        "slaBreaches": "SLA 违规"
      },
      "platformTrendTitle": "平台趋势",
      "platformTrendSubtitle": "平台各类实体随时间的增长与活动情况",
      "loadingPlatformTrend": "正在加载平台趋势...",
      "loadingActivity": "正在加载活动记录...",
      "quickActionsTitle": "快捷操作",
      "adoptionHealthTitle": "采用情况与健康度",
      "adoptionFunnelTitle": "采用漏斗",
      "adoptionFunnelSubtitle": "项目从创建到活跃使用的历程",
      "adoptionFunnelInfo": "展示项目如何从创建推进到活跃部署及会话使用。每个柱状条代表达到该阶段的项目数量。",
      "topRiskSignalTitle": "主要风险信号",
      "topRiskSignalSubtitle": "平台最严重的风险与健康警报",
      "topRiskSignalInfo": "根据工作流失败率和会话活动趋势，突出显示当前平台最严重的风险。图表显示 SLA 违规次数。",
      "riskSeverityWarn": "警告",
      "noActiveRiskSignal": "当前无活跃风险信号",
      "metricFallback": "指标",
      "workflowHealthTitle": "工作流健康度",
      "workflowHealthSubtitle": "执行的性能与可靠性指标",
      "workflowHealthInfo": "跟踪工作流执行的健康状况。中位运行时间反映处理速度，重试率反映可靠性问题，SLA 违规标记失败或超时的执行。",
      "actionableHighlightsTitle": "可操作要点",
      "actionableHighlightsSubtitle": "按活动和建议排名的顶级实体",
      "actionableHighlightsInfo": "按会话活动和评估覆盖率排名的重要项目。\n\n健康状态：\n• 良好：> 0 会话，> 0 评估运行\n• 警告：> 0 会话，0 评估运行\n• 不良：0 会话\n\n每行显示会话数、评估运行次数以及用于提升平台采用率或质量的建议操作。",
      "noHighlightsYet": "暂无亮点",
      "table": {
        "entity": "实体",
        "type": "类型",
        "sessions": "会话",
        "evalRuns": "评估运行次数",
        "failurePercent": "失败率 %",
        "health": "健康状态",
        "recommendedAction": "建议操作"
      }
    },
    "na": "不适用",
    "agents": {
      "kpi": {
        "draft": "草稿",
        "published": "已发布",
        "registered": "已注册",
        "deployed": "已部署",
        "storeListings": "商店上架数"
      },
      "sections": {
        "byEnvironment": "按环境划分的智能体",
        "byStatus": "智能体状态",
        "registryStatus": "注册状态",
        "deploymentPipeline": "部署流水线",
        "byProjectsTitle": "按项目划分的智能体",
        "byProjectsSubtitle": "智能体在各项目间的分布"
      },
      "barName": "智能体"
    },
    "workflows": {
      "kpi": {
        "executions": "执行次数",
        "successRate": "成功率",
        "activeSchedules": "活跃计划任务"
      },
      "sections": {
        "executionStatus": "执行状态",
        "triggerSource": "触发来源",
        "executionVolumeTitle": "执行量",
        "executionVolumeSubtitle": "所选时间段内的工作流执行总数",
        "successRateTrendTitle": "成功率趋势",
        "successRateTrendSubtitle": "成功执行的百分比随时间的变化",
        "scheduleOverview": "计划任务概览",
        "recentExecutions": "最近执行"
      },
      "noRecentExecutions": "暂无最近执行记录",
      "series": {
        "executions": "执行次数",
        "successPercent": "成功率 %"
      },
      "statusActive": "启用",
      "statusPaused": "已暂停",
      "everySeconds": "每 {{seconds}} 秒",
      "table": {
        "workflow": "工作流",
        "type": "类型",
        "schedule": "计划",
        "status": "状态",
        "nextRun": "下次运行",
        "trigger": "触发方式",
        "duration": "耗时",
        "started": "开始时间"
      }
    },
    "evals": {
      "kpi": {
        "totalEvalSessions": "评估会话总数",
        "totalEvalSessionsHint": "在所选时间段内创建的会话（遵循日期筛选条件）。",
        "avgEvalQualityScore": "平均评估质量得分",
        "avgEvalQualityScoreHint": "所选时间段内评估会话的平均汇总指标得分。",
        "passRate": "通过率",
        "passRateHint": "所选时间段内得分不低于 70% 的汇总指标占比。"
      },
      "zones": {
        "poor": "较差",
        "fair": "一般",
        "good": "良好"
      },
      "sections": {
        "averageScoreTitle": "平均评估质量得分",
        "sessionsByStatus": "按状态划分的会话",
        "sessionsTrendTitle": "评估会话趋势",
        "sessionsTrendSubtitle": "评估会话数量随时间的变化",
        "frameworkDistribution": "框架分布",
        "topEvaluatedAgents": "评估排名靠前的智能体"
      },
      "series": {
        "evalSessions": "评估会话"
      },
      "table": {
        "agent": "智能体",
        "evalSessions": "评估会话",
        "latestScore": "最新得分",
        "framework": "框架"
      }
    },
    "sessions": {
      "kpi": {
        "activeSessionsInPeriod": "活跃会话（时间段内）",
        "activeSessionsHint": "在所选时间窗口内至少有一条消息或一轮对话的会话。",
        "avgTurnsPerSession": "平均对话轮数 / 会话",
        "avgTurnsHint": "所选时间窗口内活跃会话的平均对话轮数。",
        "messages": "消息",
        "avgLatency": "平均延迟",
        "avgCostPerCall": "平均成本 / 调用",
        "avgCostPerCallHint": "与成本标签页一致（LLM 日志 + 使用事件）。"
      },
      "sections": {
        "byEnvironment": "按环境划分的会话",
        "byEnvironmentSubtitle": "活动会话在不同环境中的分布。",
        "visibilityDistribution": "可见性分布",
        "visibilityDistributionSubtitle": "按可见性级别划分的会话细分。",
        "sessionTrendTitle": "会话趋势",
        "sessionTrendSubtitle": "所选时间段内的每日会话数。",
        "messagesTrendTitle": "消息趋势",
        "messagesTrendSubtitle": "所有会话的每日消息量。",
        "tokenUsageTitle": "Token 使用量",
        "tokenUsageSubtitle": "与成本标签页的每日总量一致（LLM 日志 + 使用事件）。",
        "latencyTrendTitle": "延迟趋势",
        "latencyTrendSubtitle": "平均及各分位数响应延迟随时间的变化。",
        "topAgentsBySessions": "会话数排名靠前的智能体"
      },
      "series": {
        "tokens": "Token",
        "avgLatency": "平均延迟",
        "p90Latency": "P90 延迟",
        "p95Latency": "P95 延迟",
        "p99Latency": "P99 延迟"
      },
      "table": {
        "agent": "智能体",
        "sessions": "会话",
        "messages": "消息",
        "avgLatency": "平均延迟",
        "avgTokens": "平均 Token 数"
      }
    },
    "cost": {
      "kpi": {
        "totalTokens": "Token 总数",
        "inputTokens": "输入 Token",
        "outputTokens": "输出 Token",
        "cachedTokens": "缓存 Token",
        "estCost": "预估成本",
        "llmCalls": "LLM 调用次数",
        "avgTokensPerCall": "平均 Token 数/调用",
        "dailyAvgCost": "日均成本",
        "peakUsageDate": "峰值使用日期",
        "peakTokens": "峰值 Token 数",
        "dailyAvgTokens": "日均 Token 数",
        "avgCostPerCall": "平均成本/调用"
      },
      "sections": {
        "tokenUsageTrendTitle": "Token 使用趋势",
        "tokenUsageTrendSubtitle": "处理的 Token 量随时间的变化",
        "costTrendTitle": "成本趋势",
        "costTrendSubtitle": "预估运营成本随时间的变化",
        "tokensByServiceTitle": "按服务划分的 Token",
        "tokensByServiceSubtitle": "各系统服务的总 Token 使用量",
        "costByServiceTitle": "按服务划分的预估成本",
        "costByServiceSubtitle": "按系统服务划分的财务影响明细",
        "tokensByConsumerTitle": "按调用方划分的 Token",
        "tokensByConsumerSubtitle": "按 API 调用方划分的 Token 消耗",
        "costByConsumerTitle": "按调用方划分的预估成本",
        "costByConsumerSubtitle": "按 API 调用方划分的成本明细",
        "tokenDistByModelTitle": "按模型划分的 Token 分布",
        "tokenDistByModelSubtitle": "各 AI 模型的 Token 使用占比",
        "costByModelTitle": "按模型划分的成本估算",
        "costByModelSubtitle": "归因于各 AI 模型的预估支出",
        "tokensByProjectTitle": "按项目划分的 Token 消耗",
        "tokensByProjectSubtitle": "各注册项目使用的 Token 总量",
        "costByProjectTitle": "按项目划分的预估成本",
        "costByProjectSubtitle": "按项目划分的 AI 使用财务明细",
        "tokensByAgentTitle": "按智能体划分的 Token 消耗",
        "tokensByAgentSubtitle": "各 AI 智能体的 Token 使用量",
        "costByAgentTitle": "按智能体划分的预估成本",
        "costByAgentSubtitle": "特定 AI 智能体的财务影响",
        "tokensByWorkflowTitle": "按工作流划分的 Token 消耗",
        "tokensByWorkflowSubtitle": "自动化工作流处理的 Token 量",
        "costByWorkflowTitle": "按工作流划分的预估成本",
        "costByWorkflowSubtitle": "归因于执行 AI 工作流的成本",
        "tokensByEnvironmentTitle": "按环境划分的 Token 消耗",
        "tokensByEnvironmentSubtitle": "按部署环境划分的使用指标",
        "costByEnvironmentTitle": "按环境划分的预估成本",
        "costByEnvironmentSubtitle": "按部署环境划分的财务明细",
        "tokensByUsersTitle": "按用户划分的 Token 消耗",
        "tokensByUsersSubtitle": "各终端用户使用的 Token 量",
        "costByUsersTitle": "按用户划分的预估成本",
        "costByUsersSubtitle": "归因于特定用户的运营支出",
        "topCostDriversTitle": "主要成本驱动因素",
        "topCostDriversSubtitle": "对平台成本贡献最大的高消耗智能体和工作流"
      },
      "noDataRange": {
        "projectToken": "此时间段内暂无按项目划分的 Token 数据。",
        "projectCost": "此时间段内暂无按项目划分的成本数据。",
        "agentToken": "此时间段内暂无按智能体划分的 Token 数据。",
        "agentCost": "此时间段内暂无按智能体划分的成本数据。",
        "workflowToken": "此时间段内暂无按工作流划分的 Token 数据。",
        "workflowCost": "此时间段内暂无按工作流划分的成本数据。",
        "environmentToken": "此时间段内暂无按环境划分的 Token 数据。",
        "environmentCost": "此时间段内暂无按环境划分的成本数据。",
        "userToken": "此时间段内暂无按用户划分的 Token 数据。",
        "userCost": "此时间段内暂无按用户划分的成本数据。"
      },
      "barName": {
        "tokens": "Token",
        "usd": "美元",
        "models": "模型"
      },
      "table": {
        "driver": "驱动因素",
        "type": "类型",
        "typeAgent": "智能体",
        "typeWorkflow": "工作流",
        "totalTokens": "Token 总数",
        "inputTokens": "输入 Token",
        "outputTokens": "输出 Token",
        "estCost": "预估成本"
      }
    },
    "platform": {
      "kpi": {
        "totalTenants": "租户总数",
        "totalUsers": "用户总数",
        "rejectedUsers": "被拒绝用户"
      },
      "sections": {
        "userGrowthTitle": "用户增长",
        "usersByRoleTitle": "按角色划分的用户",
        "approvalDecisionsTitle": "审批结果",
        "userStatusDistributionTitle": "用户状态分布",
        "auditActivityTitle": "审计活动",
        "tenantOverviewTitle": "租户概览"
      },
      "series": {
        "newUsers": "新增用户",
        "approved": "已批准",
        "rejected": "已拒绝"
      },
      "table": {
        "tenant": "租户",
        "users": "用户",
        "projects": "项目",
        "agents": "智能体",
        "created": "创建时间"
      }
    }
  },
  "blueprints": {
    "common": {
      "all": "全部",
      "cancel": "取消",
      "deepThinkingDesc": "深入分析",
      "deepThinkingLabel": "深度思考",
      "delete": "删除",
      "deleteBlueprintMessage": "删除“{{name}}”？此操作无法撤销。",
      "deleteBlueprintTitle": "删除蓝图？",
      "dismiss": "关闭",
      "expressModeDesc": "快速直接生成",
      "expressModeLabel": "极速模式",
      "loading": "正在加载蓝图...",
      "modeDeep": "深度",
      "modeFast": "极速",
      "noProjectsFound": "未找到项目。请创建一个项目并选择它以继续。",
      "noProjectsFoundBusinessUser": "您的账户尚未分配任何项目。请联系管理员将您添加到项目后再继续。",
      "noSystemBlueprints": "暂无系统蓝图。",
      "proceed": "继续",
      "removeAttachedFile": "移除附件",
      "scopeLibrary": "自定义",
      "scopeSystem": "系统",
      "searchAriaLabel": "搜索蓝图",
      "searchPlaceholder": "搜索蓝图…",
      "searchSelectProjectPlaceholder": "搜索并选择一个项目...",
      "selectProjectLabel": "需要一个项目才能开始：",
      "selectProjectTitle": "选择项目",
      "selectThinkingModeTitle": "选择思考模式",
      "sourceAriaLabel": "蓝图来源",
      "stopRecording": "停止录音",
      "systemBadge": "系统",
      "systemBadgeTitle": "平台起始模板 — 只读",
      "targetAgent": "智能体",
      "targetWorkflow": "工作流",
      "thinkingModeHeader": "思考模式",
      "uploadFile": "上传文件",
      "voiceInput": "语音输入"
    },
    "list": {
      "activeBlueprintsTitle": "活跃蓝图",
      "addToSpotlight": "添加到精选",
      "archive": "归档",
      "archiveBlueprintMessage": "归档“{{name}}”？它将从活跃列表中隐藏。",
      "archiveBlueprintTitle": "归档蓝图？",
      "archivedBlueprintsTitle": "已归档蓝图",
      "backTitle": "返回",
      "cardActionsAriaLabel": "卡片操作",
      "catalogScopeTitle": "蓝图目录范围",
      "closeAriaLabel": "关闭",
      "delete": "删除",
      "done": "完成",
      "edit": "编辑",
      "errorCount": "{{count}} 个错误",
      "export": "导出",
      "filters": {
        "status": "状态",
        "draft": "草稿",
        "pendingReview": "待审核",
        "pending": "待处理",
        "approved": "已批准",
        "archived": "已归档",
        "industry": "领域",
        "creator": "创建者"
      },
      "filtersTitle": "筛选条件",
      "fork": "复刻",
      "goBackAriaLabel": "返回",
      "importAriaLabel": "导入蓝图",
      "importCompleteHeading": "导入完成",
      "importErrorSubtitle": "部分项目无法导入，详情见下方。",
      "importFinishedWithErrorsHeading": "导入完成但存在错误",
      "importSuccessSubtitle": "您的蓝图已作为草稿导入，可供审核。",
      "importTitle": "从 YAML 导入蓝图",
      "loadingMore": "正在加载更多蓝图...",
      "newBlueprint": "新建蓝图",
      "noBlueprintsMatchFilters": "没有符合筛选条件的蓝图。",
      "noBlueprintsYet": "暂无蓝图。",
      "pageSubtitle": "会话式工作流与智能体构建器的流程规范",
      "pageTitle": "蓝图",
      "refreshAriaLabel": "刷新列表",
      "refreshTitle": "刷新",
      "removeFromSpotlight": "从精选中移除",
      "spotlightBadgeTitle": "精选 {{rank}} — 首先显示在 DIP 首页（快速启动）",
      "spotlightFullTitle": "精选位已满（最多 {{max}} 个）。请先移除一个。",
      "statCreated": "已创建",
      "statFailed": "失败",
      "statSkipped": "已跳过",
      "systemCreatorFallback": "系统",
      "toasts": {
        "addedToSpotlight": "已将蓝图添加到 DIP 精选",
        "archiveFailed": "归档失败",
        "blueprintArchived": "蓝图已归档",
        "blueprintDeleted": "蓝图已删除",
        "blueprintExported": "蓝图已导出",
        "blueprintForked": "蓝图已复刻",
        "blueprintImported": "蓝图已导入",
        "blueprintUnarchived": "蓝图已取消归档",
        "couldNotAddToSpotlight": "无法添加到精选",
        "couldNotRemoveFromSpotlight": "无法从精选中移除",
        "deleteFailed": "删除失败",
        "exportFailed": "导出失败",
        "forkFailed": "复刻失败",
        "importCompletedWithErrors": "导入完成但存在错误",
        "importFailed": "导入失败",
        "importedWithWarnings": "蓝图导入完成，有 {{count}} 条警告",
        "removedFromSpotlight": "已从 DIP 精选中移除",
        "unarchiveFailed": "取消归档失败"
      },
      "typeAgent": "智能体",
      "typeTabsAriaLabel": "蓝图类型",
      "typeWorkflow": "工作流",
      "unarchive": "取消归档",
      "unarchiveBlueprintMessage": "将“{{name}}”恢复为草稿状态？",
      "unarchiveBlueprintTitle": "取消归档该蓝图？",
      "warningCount": "{{count}} 条警告"
    }
  },
  "ideate": {
    "aiPrefix": "AI",
    "backToPlatformAriaLabel": "返回决策智能平台",
    "blueprintDeletedToast": "蓝图已删除",
    "blueprintFallback": "蓝图",
    "blueprintLaunchHeader": "蓝图启动",
    "buildWithBlueprint": "使用蓝图构建",
    "buildDirectLabel": "直接构建",
    "buildDirectHint": "跳过后续问题，根据完整规格直接构建。请在附加文件之前打开。关闭时保持现有提问。",
    "chooseProjectPlaceholder": "选择一个项目…",
    "complianceAriaLabel": "合规要求",
    "complianceLabel": "合规",
    "couldNotOpenSharedSession": "无法打开共享会话",
    "deleteFailedToast": "删除失败",
    "deleteSessionMessage": "确定要删除此会话吗？此操作无法撤销。",
    "deleteSessionTitle": "删除会话",
    "deployAriaLabel": "使用 {{brand}} 部署 {{name}}",
    "deployWithDip": "使用决策智能平台部署",
    "deployWithDipAriaLabel": "使用决策智能平台部署 {{name}}",
    "deployWithTitle": "使用 {{brand}} 部署",
    "guidedLaunchDesc": "全面的网络调研、澄清与大模型验证",
    "guidedLaunchLabel": "引导式启动",
    "importHeader": "导入",
    "importN8nDesc": "将现有的 n8n JSON 导入到 AI Workflows",
    "importN8nLabel": "导入 n8n 工作流",
    "lookingForBlueprints": "正在查找该领域的蓝图…",
    "moreIndustries": "更多",
    "noBlueprintsAvailable": "暂无可用蓝图。添加蓝图后重试。",
    "noBlueprintsForFilter": "没有符合此筛选条件的蓝图。",
    "noBlueprintsForIndustry": "该领域暂无蓝图。",
    "placeholderAgent": "描述要构建的智能体...",
    "placeholderWorkflow": "描述要自动化的用例...",
    "placeholderWorkflowShort": "描述要自动化的工作流...",
    "preBuiltBlueprints": "预置蓝图",
    "quickLaunchDesc": "跳过调研；直接使用蓝图的指南和 KPI",
    "quickLaunchLabel": "快速启动",
    "requireOptTitle": "要求{{label}}",
    "spotlightBadgeTitleShort": "首先显示在 DIP 首页（快速启动）",
    "spotlightRank": "精选 {{rank}}",
    "tagline": "发现。重塑。优化。正式上线",
    "untitledSession": "未命名会话",
    "uploadDocumentOrImage": "上传文档或图片",
    "compliance": {
      "soc2": "SOC 2 / SOX",
      "gdpr": "GDPR / 数据驻留",
      "hipaa": "HIPAA",
      "pii": "需要 PII 脱敏"
    }
  },
  "ontology": {
    "canvasTitle": "本体画布",
    "canvasSubtitle": "从数据源到机器学习分析的端到端数据血缘",
    "dataModelsTitle": "数据模型",
    "dataModelsSubtitle": "跨行业的企业数据模型目录",
    "kpiLibraryTitle": "KPI 库",
    "kpiLibrarySubtitle": "业务 KPI 定义与指标目录",
    "migrationsStudioTitle": "迁移工作室",
    "migrationsStudioSubtitle": "在一个工作区中通过 AI 迁移代理、验证和血缘编排从发现到割接的全过程。",
    "pipelinesTitle": "数据工作室",
    "pipelinesSubtitle": "在一个目录中管理迁移交接、编排器工作流和与 KPI 关联的处理",
    "observabilityTitle": "数据可观测性",
    "observabilitySubtitle": "管道健康监控与数据新鲜度跟踪",
    "nodesSelected": "已选择 {{count}} 个节点",
    "overview": "概览",
    "lineage": "血缘",
    "buildTimeline": "构建时间线",
    "dataHealth": "数据健康度",
    "allFamilies": "所有系列",
    "allTypes": "所有类型",
    "mustHave": "必备",
    "goodToHave": "可选",
    "totalKpis": "KPI 总数",
    "families": "系列",
    "export": "导出为 CSV",
    "exportCard": "导出…",
    "exportCardTitleDataModel": "导出数据模型",
    "exportCardTitleOntology": "导出本体",
    "exportCardTitleKpi": "导出 KPI",
    "exportCardSubtitle": "选择文件格式，然后下载。",
    "exportCardDownload": "下载",
    "exportCardCancel": "取消",
    "exportFormatPortableJson": "可移植 JSON（通过“创建数据模型”往返导入导出）",
    "exportFormatPortableYaml": "可移植 YAML（内容与 JSON 相同）",
    "exportFormatDdl": "SQL DDL",
    "exportFormatDrawio": "Draw.io XML",
    "exportFormatTurtle": "Turtle（.ttl）",
    "exportFormatRdfXml": "RDF/XML",
    "exportFormatJsonLd": "JSON-LD",
    "version": "版本",
    "versions": "版本历史",
    "latest": "最新",
    "compareVersions": "比较",
    "neo4jGraph": "网络图",
    "diffAdded": "已添加",
    "diffRemoved": "已移除",
    "diffUnchanged": "未更改",
    "diffNoChanges": "没有变化",
    "diffSelectTwo": "请选择两个不同的版本进行比较。",
    "exportFormatCsv": "CSV（用于在另一个实例上导入）",
    "exportFormatKpiJson": "JSON 快照（备份/工具使用）",
    "exportKpiJsonNote": "CSV 与 KPI 库的 CSV 导入格式一致。JSON 用于备份或外部工具；目前尚不支持 JSON 导入。",
    "healthy": "健康",
    "degraded": "降级",
    "critical": "严重",
    "running": "运行中",
    "completed": "已完成",
    "failed": "失败",
    "scheduled": "已计划",
    "published": "已发布",
    "draft": "草稿",
    "impactAnalysis": "影响分析",
    "impactActive": "影响生效中",
    "viewDataSample": "查看数据样本",
    "resourceOverview": "资源概览",
    "pipelineDrawerCode": "代码",
    "pipelineDrawerRuns": "运行记录",
    "pipelineDrawerMetadata": "元数据",
    "pipelineDrawerNoCode": "此节点尚未注册转换代码。请连接代码仓库或从管道构建器发布。",
    "pipelineDrawerNoPipeline": "未找到与此节点关联的数据管道。",
    "pipelineDrawerNoRuns": "关联管道暂无运行历史。",
    "pipelineDrawerNoMetadata": "除转换脚本外没有其他参数。",
    "pipelineLinkedJob": "关联管道",
    "pipelineNodeParams": "参数",
    "nodeInfoSection": "节点信息",
    "unknownHealth": "未知",
    "sourceChip": "来源",
    "dataExplorer": "数据浏览器",
    "openInDataExplorerAriaLabel": "在数据浏览器中打开",
    "pipelineRunHistoryUnavailable": "后端尚未提供管道运行历史。",
    "viewSample": "查看样本",
    "metadataSectionTitle": "元数据",
    "kvOwner": "所有者",
    "kvDescription": "描述",
    "kvPipeline": "管道",
    "kvSchedule": "计划",
    "kvUpdated": "更新时间",
    "kvType": "类型",
    "kvLastUpdated": "最后更新",
    "category": {
      "data_source": "数据源",
      "data_extract": "数据抽取",
      "pipeline_builder_dataset": "管道构建器数据集",
      "python_transform": "Python 转换",
      "python_script_transform": "Python 脚本转换",
      "virtual_table": "虚拟表",
      "fusion_sync": "Fusion 同步",
      "fusion_sheet": "Fusion 表",
      "kpi_node": "KPI 节点",
      "ml_model": "机器学习模型"
    },
    "stage": {
      "source": "数据源",
      "ingestion": "摄取",
      "transformation": "转换",
      "kpi": "KPI 层",
      "ml_analytics": "机器学习与分析"
    },
    "toolbar": {
      "tools": "工具",
      "layout": "布局",
      "undo": "撤销",
      "redo": "重做",
      "clean": "清理",
      "select": "选择",
      "expand": "展开",
      "color": "颜色",
      "find": "查找",
      "remove": "移除",
      "align": "对齐",
      "flow": "流程"
    },
    "legend": {
      "categoryLegend": "类别图例",
      "closeLegend": "关闭图例"
    },
    "studio": {
      "loadingOntologies": "正在加载本体...",
      "loadingPrevOntologies": "正在加载之前的本体...",
      "loadingMoreOntologies": "正在加载更多本体...",
      "industryFilterLabel": "行业",
      "allIndustries": "所有行业",
      "domainFilterLabel": "领域",
      "allDomains": "所有领域",
      "subdomainFilterLabel": "子领域",
      "allSubdomains": "所有子领域",
      "failedToDeleteOntology": "删除本体失败",
      "ontologyImportedToast": "已导入本体“{{name}}”",
      "pageTitle": "本体工作室",
      "pageSubtitle": "浏览、导入或通过 AI 从数据模型构建 OWL/TTL 本体。分析器生成的本体会在迁移工作室完成分析后自动出现在此处。",
      "evaluateButton": "评估",
      "createOntologyButton": "创建本体",
      "ontologiesKpiLabel": "本体",
      "yourOntologiesHeading": "您的本体",
      "importTooltipBold": "导入",
      "importTooltipRest": "OWL/TTL 文件以注册新本体。分析器工作流生成的本体会自动在此注册。",
      "filtersTitle": "筛选条件",
      "searchPlaceholder": "搜索本体…",
      "clearSearchAriaLabel": "清除搜索",
      "noOntologiesMatch": "没有与您的搜索匹配的本体。您可以通过导入 OWL/TTL 或使用 AI 从数据模型构建来创建本体，或在迁移工作室中运行分析器以自动注册本体。",
      "ontologyActionsAriaLabel": "{{name}} 的本体操作",
      "renameMenuItem": "重命名",
      "industryTagsMenuItem": "行业标签",
      "deleteMenuItem": "删除",
      "owlFileBadge": "OWL 文件",
      "versionsCount": "{{count}} 个版本",
      "classesLabel": "类",
      "individualsLabel": "个体",
      "removeFromCatalogTitle": "从目录中移除",
      "removeFromCatalogMessage": "从本体工作室中移除“{{name}}”？该本体将被软删除（从目录中移除）。指向 OWL 查看器的直接链接在重新导入之前可能显示为缺失。",
      "couldNotExportOntology": "无法导出本体",
      "industryTagsUpdated": "行业标签已更新",
      "couldNotUpdateIndustryTags": "无法更新行业标签",
      "industryDialogTitle": "行业标签",
      "industryDialogSubtitle": "{{name}} 的目录筛选与徽章。",
      "unspecifiedOption": "未指定",
      "industryFieldLabel": "行业",
      "saveButton": "保存",
      "savingButton": "正在保存…",
      "closeAriaLabel": "关闭",
      "renameDialogTitle": "重命名 OWL 本体",
      "renameDialogSubtitle": "卡片和列表中显示的名称（最多 {{maxLength}} 个字符）。",
      "nameFieldLabel": "名称",
      "nameRequiredError": "名称为必填项",
      "nameMustContainLetterError": "名称必须至少包含一个字母或数字",
      "renameFailedError": "重命名失败"
    },
    "justNow": "刚刚",
    "hoursAgo": "{{hours}} 小时前",
    "daysAgo": "{{days}} 天前",
    "chooser": {
      "subtitle": "导入现有的 OWL/TTL 文件，或使用 AI 根据已注册的数据模型和能力问题构建密集本体。",
      "buildWithAiTitle": "使用 AI 构建本体",
      "buildWithAiDesc": "选择数据模型、查看能力问题、合成 OWL",
      "uploadTitle": "上传 OWL/TTL",
      "uploadDesc": "上传现有的本体文件"
    },
    "import": {
      "title": "导入 OWL/TTL 本体",
      "subtitle": "上传 Turtle（.ttl）、OWL、RDF/XML 或 JSON-LD 文件以创建本体。",
      "industryHint": "存储在目录卡片上，并与数据模型和 KPI 一起用于筛选。",
      "nameLabel": "本体名称（可选）",
      "namePlaceholder": "覆盖从文件自动检测到的标题",
      "nameHint": "显示在目录卡片上。留空则使用 OWL 文件中的标题。",
      "ontologyNameFieldLabel": "本体名称",
      "dropPrompt": "将 TTL/OWL 文件拖放到此处，或点击浏览",
      "filePreviewHeader": "文件预览",
      "importingButton": "正在导入…",
      "importButton": "导入本体",
      "importFailed": "导入失败"
    },
    "builder": {
      "backToStudioAriaLabel": "返回本体工作室",
      "pageTitle": "使用 AI 构建本体",
      "pageSubtitle": "为本体命名、选择数据模型、审查能力问题，然后合成 OWL 并将其注册到目录中。刷新安全 — 可随时重新打开会话。",
      "loadFailed": "加载数据模型失败",
      "resumeFailed": "无法恢复本体会话",
      "sessionDiscarded": "会话已丢弃",
      "discardFailed": "丢弃会话失败",
      "nameSpecialCharsError": "本体名称不能仅由特殊字符组成",
      "launchTextTooLong": "启动文本不能超过 {{max}} 个字符",
      "domainSpecialCharsError": "领域不能仅由特殊字符组成",
      "subdomainSpecialCharsError": "子领域不能仅由特殊字符组成",
      "enterNamePrompt": "请输入本体名称以继续",
      "enterDomainPrompt": "请输入领域以继续",
      "selectDataModelPrompt": "请选择数据模型以继续",
      "selectOntologyLlmPrompt": "请选择本体 LLM 以继续",
      "startFailed": "启动本体构建器失败",
      "updateCqFailed": "更新能力问题失败",
      "sendMessageFailed": "发送消息失败",
      "synthesisFailed": "合成失败",
      "registeredToast": "已注册 {{name}}",
      "ontologyFallback": "本体",
      "registrationFailed": "注册失败",
      "dataModelFilterLabel": "数据模型",
      "selectDataModelPlaceholder": "选择数据模型…",
      "noDataModelsRegistered": "暂无已注册的数据模型",
      "modeFilterLabel": "模式",
      "modeGuided": "引导式 — 逐一审查能力问题",
      "modeExpress": "极速 — 更快的接受流程",
      "ontologyLlmFilterLabel": "本体 LLM",
      "selectOntologyLlmPlaceholder": "选择本体 LLM…",
      "noChatModelsRegistered": "暂无已注册的对话模型",
      "enrichmentLlmFilterLabel": "增强 LLM",
      "selectEnrichmentLlmPlaceholder": "选择增强 LLM（可选）…",
      "stepSourceTitle": "来源",
      "stepSourceDesc": "为本体命名并选择定义您概念的数据模型",
      "stepQuestionsTitle": "问题",
      "stepQuestionsDesc": "接受、放弃或完善基于该模型的能力问题",
      "stepOntologyTitle": "本体",
      "stepOntologyDesc": "合成经过配置检查的 OWL 类、属性和公理",
      "stepRegisterTitle": "注册",
      "stepRegisterDesc": "发布到本体目录，供工作室和智能体使用",
      "sourceFormSubtitle": "为本体命名，并选择数据模型作为其概念的基础。",
      "ontologyNameLabel": "本体名称",
      "ontologyNamePlaceholder": "例如：专利领域本体",
      "domainLabel": "领域",
      "domainPlaceholder": "例如：医疗健康、知识产权",
      "subdomainLabel": "子领域",
      "subdomainPlaceholder": "例如：权利要求、专利审查",
      "loadingModels": "正在加载模型…",
      "loadingChatModels": "正在加载对话模型…",
      "enrichToggleTitle": "在 OWL 合成前丰富元数据",
      "enrichToggleDesc": "在生成类之前使用 LLM 扩展定义和标签。",
      "startBuildingButton": "开始构建",
      "backToBuilderAriaLabel": "返回“使用 AI 构建本体”",
      "ontologyBuilderFallback": "本体构建器",
      "dataModelFallback": "数据模型",
      "chatEmptyLine1": "您的本体访谈从这里开始。",
      "chatEmptyLine2": "审查建议的能力问题，然后接受业务方需要回答的内容。",
      "roleYou": "您",
      "roleAssistant": "助手",
      "workingStatus": "正在处理…",
      "startingSessionStatus": "正在启动会话…",
      "synthesizingStatus": "正在合成",
      "chatInputPlaceholder": "自由发言 — 描述业务问题，或输入：全部接受·下一步·继续…",
      "expandSidePanel": "展开侧边栏",
      "collapseSidePanel": "收起侧边栏",
      "reflectionHeading": "反思与评估",
      "scoreFallback": "得分 {{score}}",
      "addMoreQuestionsButton": "添加更多本体问题",
      "registerLead": "为本体命名并发布到目录。请在下方预览草稿图，并在注册前确认配置检查（lint）通过。",
      "graphReviewNudge": "提示：注册前请打开上方的 OntoGraf 或 Neo4j 以查看结构。",
      "industryLabel": "行业",
      "registerToCatalogButton": "注册到目录",
      "resumingSession": "正在恢复本体会话…",
      "launchTitle": "Build an ontology",
      "launchTitleLead": "构建",
      "launchTitleAccent": "业务本体",
      "launchSubtitle": "Name it, pick a data model, and chat your way to a business ontology.",
      "nameYourOntology": "Name your ontology…",
      "dataModelPill": "Data model",
      "searchDataModels": "Search data models…",
      "pickDataModelHint": "Select a data model to continue",
      "noAiModelHint": "No AI model configured. Set one up in Admin.",
      "noDataModelsYet": "No data models yet",
      "createDataModel": "Create one",
      "settingsAria": "Settings",
      "settingsLocked": "Locked for this ontology",
      "aiModelLabel": "AI model",
      "reviewStyleLabel": "How to review questions",
      "modeReviewEach": "Ask me to review each question",
      "modeFillForMe": "Fill answers for me",
      "enrichDescriptions": "Enrich descriptions",
      "enrichmentModelLabel": "Enrichment model",
      "sameModel": "Same model",
      "openingLine": "Build {{name}} from {{model}}",
      "askQuestionPlaceholder": "Ask a question your ontology should answer…",
      "askChangePlaceholder": "Ask for a change or add another question…",
      "acceptRemaining": "Accept all ({{count}})",
      "buildOntology": "Build ontology",
      "buildReadyLead": "Your questions are ready. Build the ontology from them.",
      "rebuildReadyLead": "Questions changed since the last build. Rebuild to pick them up.",
      "rebuildOntology": "Rebuild ontology",
      "send": "Send",
      "questionsIntro": "Here are {{count}} questions your ontology should answer.",
      "questionsReviewed": "{{count}} questions reviewed · {{accepted}} accepted",
      "accept": "Accept",
      "drop": "Drop",
      "collapse": "Collapse",
      "undoQuestion": "Undo",
      "answerPlaceholder": "What should the answer be?",
      "questionAccepted": "Question accepted",
      "questionDropped": "Question dropped",
      "phaseBuilding": "Building your ontology…",
      "phaseConcepts": "Designing concepts…",
      "phaseLinks": "Linking relationships…",
      "phaseWriting": "Writing the ontology…",
      "phaseQuality": "Checking quality…",
      "buildFailed": "Couldn't build the ontology",
      "buildTakesAWhile": "This usually takes a few minutes. You can keep this tab open.",
      "buildEnginePhase": "The ontology engine is building this. For a large data model it can take 15 minutes or more.",
      "tryAgain": "Try again",
      "ontologyReady": "Ontology ready · {{concepts}} concepts · {{relationships}} relationships",
      "ontologyViewLabel": "Ontology view",
      "viewGraph": "Graph",
      "viewDraftPreview": "Preview",
      "viewOwl": "OWL",
      "earlierVersion": "Earlier version",
      "qualitySkipped": "Quality check was skipped",
      "qualityViolations": "{{count}} items may need a look",
      "qualityGaps": "A few gaps are still open",
      "tryAsking": "Try asking about {{hint}}",
      "details": "Details",
      "moreDetails": "More details",
      "registeredLine": "Registered {{name}} to your catalog.",
      "registeredQuiet": "This ontology is registered",
      "openOntology": "Open ontology",
      "buildAnother": "Build another",
      "moreActions": "More actions",
      "viewDataModel": "View data model",
      "deleteSession": "Delete session",
      "close": "Close"
    },
    "viewer": {
      "loadSummaryFailed": "加载摘要失败",
      "generatingSummary": "正在生成本体摘要…",
      "retry": "重试",
      "regenerateSummaryTitle": "重新生成摘要",
      "regenerateButton": "重新生成",
      "classesLabel": "类",
      "objectPropsLabel": "对象属性",
      "dataPropsLabel": "数据属性",
      "individualsLabel": "个体",
      "aboutThisOntology": "关于此本体",
      "cachedSummary": "缓存摘要",
      "overview": "概览",
      "noSummaryYet": "暂无可用摘要。请使用“重新生成”创建一个。",
      "propertiesLabel": "属性",
      "moreCount": "还有 {{count}} 个",
      "showLess": "收起",
      "tab": {
        "about": "关于本体",
        "ontograf": "OntoGraf",
        "neo4j-graph": "网络图",
        "object-properties": "对象属性",
        "data-properties": "数据属性",
        "annotation-properties": "注释",
        "individuals": "个体",
        "compare": "比较"
      },
      "group": {
        "about": "关于",
        "explore": "探索",
        "compare": "比较"
      },
      "ontologyNotFound": "未找到本体",
      "couldNotLoadOntology": "无法加载本体",
      "backButton": "返回",
      "noGraphData": "暂无可用图数据",
      "compareNeedsTwoVersions": "版本比较需要此系列中至少有两个版本。",
      "backToOntologies": "本体列表",
      "builtWithAi": "AI 构建",
      "ontologyViewsAriaLabel": "本体视图",
      "viewGroupsAriaLabel": "视图分组",
      "exploreViewsAriaLabel": "探索视图",
      "faqTitle": "常见问题",
      "configureFaqAriaLabel": "配置常见问题",
      "exportTurtleTitle": "导出为 Turtle",
      "classHierarchyAriaLabel": "类层级",
      "expandClassHierarchy": "展开类层级",
      "showClassHierarchy": "显示类层级",
      "collapseClassHierarchy": "收起类层级",
      "collapseHierarchyPanel": "收起层级面板",
      "askOntologyTitle": "询问本体",
      "askOntologySubtitle": "查询类、属性和关系。",
      "askOntologyGreeting": "询问此本体中的类、层级或关系。",
      "loading": "加载中...",
      "name": "名称",
      "domain": "定义域",
      "range": "值域",
      "characteristics": "特征",
      "kind": {
        "object": "对象",
        "data": "数据",
        "annotation": "注释"
      },
      "noPropertiesForClass": "此类没有{{kind}}属性。",
      "noPropertiesFound": "未找到{{kind}}属性。",
      "iriLabel": "IRI",
      "unspecified": "(未指定)",
      "annotationsLabel": "注释",
      "typesLabel": "类型",
      "viewLabel": "视图",
      "groupedByClass": "按类分组",
      "flatList": "平铺列表",
      "loadingIndividuals": "正在加载个体…",
      "noIndividualsForClass": "此类没有个体。",
      "noIndividualsFound": "未找到个体。",
      "dataPropertiesLabel": "数据属性",
      "objectPropertiesLabel": "对象属性"
    },
    "dataModels": {
      "cancel": "取消",
      "close": "关闭",
      "description": "描述",
      "industryVertical": "行业领域",
      "modelName": "模型名称",
      "nameInvalidChars": "模型名称只能包含字母、数字、空格、连字符和下划线",
      "nameNeedsAlphanumeric": "模型名称必须包含字母数字字符",
      "nameRequired": "模型名称为必填项",
      "save": "保存",
      "saving": "保存中…",
      "selectIndustry": "选择行业",
      "status": {
        "draft": "草稿",
        "published": "已发布"
      },
      "createDialog": {
        "addColumn": "添加列",
        "addEntity": "添加实体",
        "back": "返回",
        "columnNamePlaceholder": "列名",
        "columns": "列",
        "continue": "继续",
        "createFailed": "无法创建数据模型",
        "createModel": "创建模型",
        "createdSummary": "{{name}} 已作为草稿创建，包含 {{count}} 个实体。",
        "createdSummaryWithColumns": "{{name}} 已作为草稿创建，包含 {{count}} 个实体和 {{columns}} 个列。",
        "createdTitle": "数据模型已创建",
        "creating": "创建中...",
        "descriptionPlaceholder": "描述此数据模型的目的和范围...",
        "dimension": "维度",
        "done": "完成",
        "duplicateEntityName": "相同的实体名称已添加",
        "enterModelName": "请输入模型名称",
        "entityNameInvalidChars": "实体名称只能包含字母、数字和下划线",
        "entityNameNeedsAlphanumeric": "实体名称必须包含字母数字字符",
        "entityNamePlaceholder": "实体名称（例如 Customer）",
        "fillOutField": "请填写此字段。",
        "foreignKey": "外键",
        "missingIndustry": "缺少行业",
        "missingModelName": "缺少模型名称",
        "modelNamePlaceholder": "例如：通用零售数据模型",
        "modelNameRequired": "模型名称 *",
        "modelSummary": "模型摘要",
        "needMoreEntities": "请至少添加 2 个实体以定义关系。",
        "noColumnsYet": "尚无列。创建时为可选项 — 您可以稍后在模型详情视图中添加。",
        "noEntitiesYet": "尚未添加实体。请在上方输入以添加表。",
        "nullable": "可为空",
        "primaryKey": "主键",
        "removeColumn": "删除列",
        "removeEntity": "删除 {{name}}",
        "selectIndustryVertical": "请选择行业领域",
        "step1Desc": "名称、行业和描述",
        "step1Label": "基本信息",
        "step2Desc": "添加表和列",
        "step2Intro": "添加实体（表），然后为每个实体定义列。",
        "step2Label": "定义实体",
        "step3Desc": "定义外键和链接",
        "step3Intro": "定义实体之间的关系。",
        "step3Label": "关系",
        "step4Desc": "验证并发布",
        "step4Label": "审核并创建",
        "subtitle": "定义新的企业数据模型",
        "summaryColumns": "列（已命名）：",
        "summaryEntities": "实体：",
        "summaryIndustry": "行业：",
        "summaryName": "名称：",
        "summaryRelationships": "关系：",
        "title": "创建数据模型",
        "typePlaceholder": "类型"
      },
      "detail": {
        "add": "添加",
        "addColumnTitle": "添加列",
        "back": "返回",
        "backToDataModels": "返回数据模型列表",
        "cardinality": "基数",
        "chooseBothTables": "请选择两个表",
        "columnNameRequired": "列名为必填项",
        "couldNotAddRelationship": "无法添加关系",
        "couldNotApplyDdl": "无法应用 DDL",
        "couldNotDeleteColumn": "无法删除列",
        "couldNotDeleteRelationship": "无法删除关系",
        "couldNotLoadDdl": "无法加载 DDL 导出",
        "couldNotSaveColumn": "无法保存列",
        "couldNotUpdateRelationship": "无法更新关系",
        "dataType": "数据类型",
        "ddlCouldNotExportYet": "-- 暂时无法导出 DDL。\n",
        "ddlUnavailableLargeModel": "-- 对于大型模型，可从导出菜单获取 DDL 导出。\n",
        "ddlValidationPassed": "DDL 验证通过",
        "deleteColumnAria": "删除列 {{name}}",
        "deleteColumnMessage": "这将从数据模型实体中删除该列。",
        "deleteColumnTitle": "删除列",
        "deleteRelationshipAria": "删除关系",
        "deleteRelationshipMessage": "从模型中删除此关系。",
        "deleteRelationshipTitle": "删除关系",
        "diagramExported": "图表已导出",
        "drawioDownloaded": "Draw.io 图表已下载",
        "drawioExportFailed": "Draw.io 导出失败",
        "editColumnAria": "编辑列 {{name}}",
        "editColumnTitle": "编辑列",
        "editRelationshipAria": "编辑关系",
        "editRelationshipTitle": "编辑关系",
        "exportFailed": "导出失败",
        "fkColumnSource": "外键列（源）",
        "foreignKeys": "外键",
        "jsonSnapshotDownloaded": "JSON 快照已下载",
        "modelNotFound": "未找到模型",
        "modelUpdatedFromDdl": "已根据 DDL 更新模型",
        "name": "名称",
        "noColumnsYet": "尚无列。添加一个以定义此实体。",
        "noDirectRelationships": "没有直接关系",
        "nothingToExport": "没有可导出的内容",
        "nullableColumns": "可为空的列",
        "optional": "可选",
        "optionalCapitalized": "可选",
        "primaryKeys": "主键",
        "recordCount": "记录数",
        "relationshipAdded": "已添加关系",
        "snapshotExportFailed": "快照导出失败",
        "svgExportFailed": "SVG 导出失败",
        "svgExported": "SVG 已导出",
        "tab": {
          "columns": "列",
          "relationships": "关系",
          "stats": "统计"
        },
        "tooManyTablesForImage": "此模型包含 {{count}} 个表 — 在浏览器中渲染为图像太大。请改用“导出为 Draw.io”。",
        "validation": "验证",
        "validationFailed": "验证失败",
        "viewMode": "查看",
        "modifyMode": "修改",
        "searchTablesPlaceholder": "搜索表和列…",
        "filterErDiagramAriaLabel": "筛选ER图",
        "exportAsPng": "导出为PNG",
        "exportAsSvg": "导出为SVG",
        "exportJsonSnapshot": "导出JSON快照",
        "exportAsDrawio": "导出为Draw.io",
        "relationshipButton": "关系",
        "modelMetricsAriaLabel": "模型指标",
        "entitiesLabel": "实体",
        "entAbbrev": "实体",
        "relationshipsLabel": "关系",
        "relAbbrev": "关系",
        "totalRecordsLabel": "总记录数",
        "recAbbrev": "记录",
        "linkedKpisLabel": "关联的KPI",
        "kpiAbbrev": "KPI",
        "noEntitiesYet": "尚无实体",
        "noEntitiesDescription": "请在左侧应用DDL或导入模型以填充此图表。",
        "askDataModelTitle": "询问数据模型",
        "askDataModelSubtitle": "查询实体、列和关系。",
        "askDataModelGreeting": "询问此数据模型中的表、列、关系或统计信息。",
        "addRelationshipTitle": "添加关系",
        "addRelationshipSubtitle": "从 → 到 · 源表上的可选外键列",
        "fromTable": "源表",
        "toTable": "目标表",
        "selectEllipsis": "选择…",
        "fkColumnOnSource": "外键列（源表）",
        "optionalLowercase": "可选",
        "ddlRefreshTitle": "从服务器导出替换编辑器内容",
        "ddlRefresh": "刷新",
        "ddlSwitchToModifyValidate": "请切换到修改模式以验证",
        "ddlValidate": "验证",
        "ddlSwitchToModifyApply": "请切换到修改模式以应用",
        "ddlApply": "应用"
      },
      "editDialog": {
        "invalidName": "模型名称无效",
        "saveChanges": "保存更改",
        "subtitle": "更新名称、行业和描述",
        "title": "编辑数据模型",
        "updateFailed": "无法更新数据模型",
        "updated": "数据模型已更新"
      },
      "importDialog": {
        "analyzing": "分析中...",
        "chooseFile": "选择文件",
        "chooseFiles": "选择文件",
        "close": "关闭",
        "createFromSampleData": "从样本数据创建",
        "createdSummary": "已创建“{{name}}”：{{entities}} 个实体，{{columns}} 个列，{{relationships}} 个关系。",
        "csvFilesLabel": "CSV 文件（每张表一个，最多 30 个）",
        "downloadSampleHint": "下载示例文件以查看预期布局",
        "excelWorkbook": "Excel 工作簿",
        "fileLabel": "文件：{{name}}（{{size}} KB）",
        "formatContent": "{{label}} 内容",
        "import": "导入",
        "importAsDataModel": "导入为数据模型",
        "importFailed": "导入失败",
        "importFailedTitle": "导入失败",
        "importFormat": "导入格式",
        "importSuccessful": "导入成功",
        "importWithVisionModel": "使用视觉模型导入",
        "importedSummary": "已导入“{{name}}”：{{entities}} 个实体，{{columns}} 个列，{{relationships}} 个关系。",
        "importing": "导入中...",
        "inferredModelNamePlaceholder": "推断模型的名称",
        "loadSample": "加载示例",
        "mediaFileTypes": "文件（PNG、JPEG、GIF、WebP、PDF、TXT、MD）",
        "mediaHelp": "上传 ER 图截图、导出的 PDF 或非结构化文本。处理过程使用 {{brand}} 平台上的租户模型；大文件可能需要几分钟。",
        "modelNameOptional": "模型名称（可选）",
        "noFormatsAvailable": "服务器未提供可用的导入格式。",
        "noImportModelConfigured": "未配置导入模型。",
        "noImportModelLlmHint": "在使用此选项卡前，请让租户管理员打开“管理 → 常规设置 → 企业本体”并选择一个 LLM。",
        "noImportModelVisionHint": "在使用此选项卡前，请让租户管理员打开“管理 → 常规设置 → 企业本体”并选择一个支持视觉的 LLM。",
        "overrideTitleNoName": "如果文件没有明确名称，则覆盖标题",
        "overrideTitlePlaceholder": "覆盖自动检测到的标题",
        "placeholderCsv": "粘贴 UTF-8 CSV 或上传 .csv 文件：可以是表格形式（第 1 行为列名；可选第 2 行为类型），也可以是数据字典网格（表名/列名/数据类型/可选主键/引用表）。",
        "placeholderDbml": "粘贴您的 DBML（表定义和 Ref 行）...",
        "placeholderDdl": "在此粘贴您的 CREATE TABLE 语句...",
        "placeholderDrawio": "粘贴您的 Draw.io XML 内容...",
        "placeholderJson": "粘贴 {{brand}} 可移植 JSON — 与“导出数据模型 → 可移植 JSON（实体 + 关系）”格式相同。",
        "placeholderJsonSchema": "粘贴包含定义的 JSON Schema...",
        "placeholderMermaid": "粘贴您的 erDiagram 代码块...",
        "placeholderPlantuml": "粘贴您的 @startuml 实体图...",
        "placeholderXlsx": "Excel 导入仅支持文件上传。每个工作表可以是一个表（标题行=列名）、数据字典网格（表/列/类型行），或 Relationships 工作表（From Table / To Table / Foreign Key Column）。",
        "sampleCsv": "示例 CSV",
        "sampleHelp": "上传一个或多个包含代表性样本数据的 CSV 文件。系统会分析列名和值以推断实体、数据类型、主键/外键以及跨表关系。",
        "sampleXlsx": "示例 XLSX",
        "subtitle": "结构化格式、图片和文档，或从样本 CSV 数据推断",
        "tabMedia": "图片和文档",
        "tabSample": "从样本数据",
        "tabStructured": "结构化格式",
        "title": "导入数据模型",
        "uploadFile": "上传文件",
        "warningPrefix": "警告：",
        "xlsxHelp": "每个可见工作表将成为一个或多个表：表格式工作表使用第 1 行作为列名；数据字典工作表（表名 + 列名 + 数据类型，可选主键/引用表/基数）将每行展开为一个逻辑列。使用 Relationships 工作表（From Table、To Table、Foreign Key Column，可选 Cardinality）定义显式边，或在字典 FK 行上填写 Referenced Table。类似说明的工作表名称（README、Template 等）以及以 _ 开头的名称将被跳过。当工作簿中存在目标表时，其余外键仍会根据列名（例如 store_sk → store）推断。"
      },
      "industryTagDialog": {
        "subtitle": "{{name}} 的目录徽章和筛选器",
        "title": "行业标签",
        "updateFailed": "无法更新行业标签",
        "updated": "行业标签已更新"
      },
      "list": {
        "actionClone": "克隆",
        "actionDelete": "删除",
        "actionEdit": "编辑",
        "actionIndustryTags": "行业标签",
        "actionPublish": "发布",
        "allCreators": "所有创建者",
        "allIndustries": "所有行业",
        "clearSearch": "清除搜索",
        "cloneFailed": "无法克隆数据模型",
        "clonedAs": "已克隆为“{{name}}”",
        "createDataModel": "创建数据模型",
        "creator": "创建者",
        "deleteDialogMessage": "这将从目录中移除该数据模型。相关的 KPI 引用可能需要更新。",
        "deleteDialogTitle": "删除数据模型",
        "deleteFailed": "无法删除数据模型",
        "deleted": "数据模型已删除",
        "emptyDescription": "创建或导入数据模型以开始使用。",
        "emptyTitle": "尚无数据模型",
        "entities": "实体",
        "exportFailed": "无法导出数据模型",
        "filters": "筛选器",
        "import": "导入",
        "industry": "行业",
        "kpis": "KPI",
        "loadFailed": "加载数据模型失败",
        "loading": "正在加载数据模型…",
        "loadingMore": "正在加载更多数据模型…",
        "loadingPrev": "正在加载先前的数据模型…",
        "noMatchDescription": "请尝试其他搜索词或行业筛选条件，或创建新模型。",
        "noMatchTitle": "没有匹配的数据模型",
        "publishFailed": "无法发布",
        "published": "数据模型已发布",
        "refresh": "刷新",
        "refreshError": "无法刷新目录",
        "refreshList": "刷新列表",
        "relationships": "关系",
        "searchPlaceholder": "搜索数据模型…",
        "statEntities": "实体",
        "statLinkedKpis": "关联 KPI",
        "statModels": "模型",
        "statPublished": "已发布",
        "unableToLoad": "无法加载目录"
      },
      "erFlow": {
        "entityType": {
          "dimension": "维度",
          "fact": "事实表",
          "bridge": "桥接表",
          "aggregate": "聚合表"
        },
        "columnsCount": "{{count}} 列",
        "loadingEllipsis": "加载中…",
        "showMore": "显示更多",
        "showLess": "收起",
        "resetViewTitle": "重置视图和高亮",
        "resetView": "重置视图",
        "hintReadOnly": "只读预览 · 滚动以平移 · 使用缩放按钮",
        "hintModify": "修改：从列的右侧点（外键侧）拖动到另一张表列的左侧点 · ",
        "hintClickTable": "点击表格以查看详情 · ",
        "hintPanZoom": "滚动以平移 · 使用缩放按钮 · 拖动以移动表格"
      }
    },
    "optional": "可选",
    "type": "类型",
    "kpiAllListView": "所有KPI",
    "kpiLibrary": {
      "all": "全部",
      "allCollections": "所有集合",
      "allDataTypes": "所有数据类型",
      "allIndustries": "所有行业",
      "andMoreErrors": "……以及另外 {{count}} 项",
      "askAboutKpis": "询问KPI",
      "backToFamilies": "返回族群",
      "browseMode": "浏览模式",
      "cardActions": "卡片操作",
      "chatGreeting": "询问KPI名称、定义、族群、数据类型或与数据模型的链接。",
      "chatSubtitleCollection": "此集合中的定义和族群。",
      "chatSubtitleFamily": "此族群中的定义。",
      "clearFiltersAndSearch": "清除筛选和搜索",
      "closeAria": "关闭",
      "collection": "集合",
      "collectionCardMenu": "集合卡片菜单",
      "collectionsView": "集合视图",
      "couldNotLoadCatalog": "无法加载目录",
      "createCollection": "创建集合",
      "createFamily": "创建族群",
      "createKpi": "创建KPI",
      "dataType": "数据类型",
      "delete": "删除",
      "dismiss": "关闭",
      "editDetails": "编辑详情",
      "editLinkedDataModel": "编辑关联的数据模型",
      "enterpriseOntology": "企业本体",
      "family": "族群",
      "familiesCount": "{{count}} 个族群",
      "filters": "筛选",
      "importCompleteLabel": "导入完成:",
      "importCreatedSkipped": "已创建 {{created}} 项，跳过 {{skipped}} 项",
      "importCsv": "导入CSV",
      "industry": "行业",
      "industryTags": "行业标签",
      "internalIdNotePrefix": "内部ID",
      "internalIdNoteSuffix": "保持不变——CSV导入和链接不会中断。",
      "kpiType": "KPI类型",
      "kpisCount": "{{count}} 个KPI",
      "legacySuffix": "{{domain}}（旧版）",
      "linkDataModel": "关联数据模型",
      "linkFamilyToModel": "将此KPI族群关联到参考数据模型",
      "linkedDataModel": "关联的数据模型",
      "linkedDataModelTooltip": "关联的数据模型：{{name}}",
      "linkedModelFallback": "关联的模型",
      "loadingLibrary": "正在加载KPI库…",
      "noCollectionsDesc": "创建一个集合或导入CSV文件即可开始。",
      "noCollectionsMatchTitle": "没有与您的搜索匹配的集合",
      "noCollectionsTitle": "暂无KPI集合",
      "noDataFound": "未找到数据",
      "noFamiliesDesc": "创建一个族群或导入CSV文件即可开始。",
      "noFamiliesMatchTitle": "没有与您的搜索匹配的族群",
      "noFamiliesTitle": "此集合中没有KPI族群",
      "noKpisMatch": "没有符合筛选条件的KPI。请尝试调整搜索或筛选条件，或导入定义。",
      "noMatchDesc": "请尝试其他搜索词或清除筛选条件。",
      "none": "无",
      "precisionYes": "精度（是）",
      "rename": "重命名",
      "rowActions": "行操作",
      "save": "保存",
      "saving": "正在保存…",
      "searchPlaceholder": "搜索集合、族群或KPI名称、定义、描述…",
      "selectCollection": "选择集合…",
      "selectFamily": "选择族群…",
      "selectIndustry": "选择行业…",
      "selectType": "选择类型…",
      "totalCollections": "集合总数",
      "viewDetails": "查看详情",
      "viewKpiDetails": "查看KPI详情",
      "columns": {
        "actions": "操作",
        "costPositive": "成本+",
        "dataType": "数据类型",
        "definition": "定义",
        "description": "描述",
        "family": "族群",
        "kpiName": "KPI名称",
        "kpiType": "KPI类型",
        "precision": "精度"
      },
      "createCollectionDialog": {
        "descriptionAlnumError": "描述必须包含有效文本，不能仅由特殊字符或表情符号组成",
        "descriptionPlaceholder": "此KPI集合的简要描述",
        "displayNameAlnumError": "显示名称必须至少包含一个字母或数字",
        "displayNameCharsError": "显示名称只能包含字母、数字、空格、连字符和下划线",
        "displayNamePlaceholder": "例如：零售KPI",
        "displayNameRequired": "显示名称 *",
        "nameAlnumError": "名称必须至少包含一个字母或数字",
        "nameCharsError": "名称只能包含字母、数字和下划线",
        "namePlaceholder": "例如：retail_kpis",
        "nameRequired": "名称 *",
        "title": "创建新集合"
      },
      "createFamilyDialog": {
        "collectionRequired": "KPI集合 *",
        "displayNamePlaceholder": "客户级KPI",
        "displayNameRequired": "显示名称 *",
        "namePlaceholder": "例如：COSMOS_CUSTOMER_LEVEL_KPIS",
        "nameRequired": "名称 *",
        "title": "创建新的KPI族群"
      },
      "createKpiDialog": {
        "collectionRequired": "集合 *",
        "costPositiveCheckbox": "成本+（是/否）",
        "create": "创建KPI",
        "dataTypePlaceholder": "string",
        "definitionPlaceholder": "技术定义或计算说明",
        "descriptionPlaceholder": "简短摘要",
        "familyRequired": "族群 *",
        "kpiNamePlaceholder": "例如：CUSTOMER_ATC_RATE",
        "kpiNameRequired": "KPI名称 *",
        "precisionCheckbox": "精度（是/否）",
        "title": "创建新KPI"
      },
      "collectionIndustryDialog": {
        "subtitle": "适用于“{{name}}”及其在KPI目录中的显示方式。",
        "title": "集合行业标签"
      },
      "deleteCollectionDialog": {
        "message": "这将删除该集合以及其中的所有KPI族群和KPI定义。任何指向此集合的迁移项目的KPI集合目标都会自动清除。",
        "title": "删除KPI集合"
      },
      "deleteFamilyDialog": {
        "message": "确定要删除“{{name}}”吗？这也会删除此族群中的所有KPI，且无法撤销。",
        "title": "删除族群"
      },
      "deleteKpiDialog": {
        "message": "确定要删除“{{name}}”吗？此操作无法撤销。",
        "title": "删除KPI"
      },
      "detailPopup": {
        "closeAria": "关闭",
        "costPositive": "成本+",
        "dataType": "数据类型",
        "definition": "定义",
        "description": "描述",
        "linkedModel": "关联的模型",
        "no": "否",
        "precision": "精度",
        "tags": "标签",
        "yes": "是"
      },
      "domainDialog": {
        "missingIndustry": "缺少行业",
        "updateFailed": "无法更新行业标签"
      },
      "editFamilyDialog": {
        "descriptionPlaceholder": "描述此KPI族群涵盖的内容…",
        "title": "编辑KPI族群",
        "titleLabel": "标题",
        "titlePlaceholder": "例如：营收KPI",
        "updateFailed": "无法更新族群"
      },
      "errors": {
        "createCollectionFailed": "创建集合失败",
        "createFamilyFailed": "创建族群失败",
        "createKpiFailed": "创建KPI失败",
        "csvImportFailed": "CSV导入失败",
        "deleteCollectionFailed": "无法删除KPI集合",
        "deleteFamilyFailed": "删除族群失败",
        "deleteKpiFailed": "删除KPI失败",
        "exportFailed": "无法导出KPI",
        "loadFailed": "无法加载KPI库。"
      },
      "familyIndustryDialog": {
        "subtitle": "适用于“{{name}}”。",
        "title": "KPI族群行业标签"
      },
      "importDialog": {
        "appliedToFamiliesNote": "应用于此次导入创建或涉及的KPI族群。",
        "chooseCsvFile": "选择CSV文件",
        "close": "关闭",
        "dataTypeHelp": "— 例如string、decimal；省略的值会根据名称和定义推断。",
        "definitionHelp": "— 技术定义；",
        "descriptionHelp": "— 简短摘要。",
        "domainHelp": "— 可选的行级域（默认为导入域）。",
        "familyCreatedNote": "导入过程中创建的族群将被放入此集合。为空时默认使用“Default”。",
        "familyDisplayHelp": "— 在创建或更新族群时显示在界面中。",
        "familyKpiHelp": "— 族群和KPI符号的稳定标识符。",
        "industryOptional": "行业（可选）",
        "kpiCollection": "KPI集合",
        "kpiTypeDefault": "（默认：必备）。",
        "linkDataModelOptional": "关联数据模型（可选）",
        "or": "或",
        "or2": "（或",
        "overridesDomainNote": "覆盖各CSV行中的域列。",
        "precisionCostHelp": "）— 是/否；如省略，两者默认均为是。",
        "requiredColumns": "必需列：",
        "title": "从CSV导入KPI"
      },
      "linkDialog": {
        "noneHint": "选择“无”可将此族群与任何ER模型解除关联。智能体工作室和蓝图使用此链接将KPI与实体对齐。",
        "referenceDataModel": "参考数据模型",
        "subtitle": "为“{{name}}”选择参考数据模型。",
        "title": "将KPI族群关联到数据模型",
        "updateFailed": "无法更新数据模型链接"
      },
      "renameCollectionDialog": {
        "displayName": "显示名称",
        "placeholder": "例如：零售KPI",
        "renameFailed": "无法重命名集合",
        "title": "重命名集合"
      },
      "toasts": {
        "collectionDeleted": "KPI集合已删除",
        "collectionRenamed": "集合已重命名",
        "dataModelLinkRemoved": "已移除数据模型链接",
        "dataModelLinked": "已关联数据模型",
        "familyUpdated": "族群已更新",
        "industryTagsUpdated": "行业标签已更新"
      },
      "createCollectionButton": "创建集合",
      "importCsvButton": "导入CSV"
    },
    "dataStudio": {
      "list": {
        "newPipeline": "新建管道",
        "typeLabel": "类型",
        "statusLabel": "状态",
        "allTypes": "所有类型",
        "allStatus": "所有状态",
        "columnPipeline": "管道",
        "columnType": "类型",
        "columnStatus": "状态",
        "columnRoute": "源 → 目标",
        "columnSchedule": "调度",
        "columnUpdated": "更新时间",
        "columnActions": "操作",
        "actionOpen": "打开",
        "actionDelete": "删除",
        "deleteDialogTitle": "删除管道",
        "deleteDialogMessage": "这将从 Data Studio 中移除该管道。此操作无法撤销。",
        "deleted": "已删除管道“{{name}}”",
        "deleteFailed": "无法删除管道",
        "migrationLinkTitle": "来自迁移：{{id}}",
        "migrationLinkText": "迁移",
        "statsPipelines": "管道",
        "emptyNoPipelines": "Data Studio 中还没有内容。管道通常从已完成的迁移项目中升级得来，或通过上方的“新建管道”创建。",
        "emptyNoMatches": "没有条目匹配筛选条件。请调整您的搜索或筛选条件。",
        "filtersTitle": "筛选",
        "searchPlaceholder": "搜索目录...",
        "loadErrorTitle": "加载 Data Studio 目录失败",
        "retry": "重试"
      },
      "status": {
        "pending": "待处理",
        "terminating": "正在终止"
      },
      "createDialog": {
        "title": "创建管道",
        "subtitleChoose": "选择一个管道类型以开始",
        "subtitleMode": "{{mode}} 管道",
        "steps": {
          "type": {
            "label": "管道类型",
            "description": "选择管道模式"
          },
          "sourceTarget": {
            "label": "源与目标",
            "description": "选择端点"
          },
          "configuration": {
            "label": "配置",
            "description": "调度与选项"
          },
          "review": {
            "label": "审核",
            "description": "确认并创建"
          }
        },
        "modes": {
          "migrate": {
            "label": "迁移",
            "description": "AI 驱动的迁移 — 打开 Migrations Studio"
          },
          "orchestrator": {
            "label": "编排工作流",
            "description": "可视化 DAG 设计器 — 部署到 Databricks、Vertex AI 或 Airflow"
          },
          "map": {
            "label": "映射",
            "description": "源与目标模式之间的字段级映射"
          },
          "transform": {
            "label": "转换",
            "description": "在传输过程中应用 SQL 或 Python 转换"
          },
          "custom": {
            "label": "自定义",
            "description": "使用代码编辑器完全可配置的管道"
          }
        },
        "createdTitle": "管道已创建",
        "createdDesc": "{{name}}（{{mode}}）已保存为草稿。",
        "pipelineNameLabel": "管道名称",
        "pipelineNamePlaceholder": "例如：{{source}} → {{target}} {{mode}}",
        "sourceSystemLabel": "源系统",
        "sourceSystemPlaceholder": "例如：Postgres prod, Snowflake DWH",
        "targetDestinationLabel": "目标地",
        "targetDestinationPlaceholder": "例如：BigQuery curated, S3 lake",
        "modeSuffix": "{{mode}} 模式",
        "change": "更改",
        "scheduleLabel": "调度",
        "scheduleSelectPlaceholder": "选择调度",
        "batchSizeLabel": "批次大小",
        "retryOnFailureLabel": "失败时重试",
        "retryEnabled": "已启用（3 次重试）",
        "retryDisabled": "已禁用",
        "transformationSqlLabel": "转换 SQL",
        "customPipelineCodeLabel": "自定义管道代码",
        "transformSqlPlaceholder": "SELECT\n  customer_id,\n  SUM(amount) as total_spend,\n  COUNT(*) as txn_count\nFROM source_table\nGROUP BY customer_id",
        "customCodePlaceholder": "# 自定义管道逻辑\nimport pandas as pd\n\ndef transform(df):\n    return df",
        "summaryTitle": "管道摘要",
        "summaryName": "名称：",
        "summaryType": "类型：",
        "summarySchedule": "调度：",
        "summaryBatchSize": "批次大小：",
        "summaryRetry": "重试：",
        "retryAttempts": "3 次尝试",
        "back": "返回",
        "done": "完成",
        "continue": "继续",
        "creating": "创建中…",
        "createPipeline": "创建管道"
      },
      "detail": {
        "configured": "已配置",
        "error": "错误",
        "start": "开始",
        "end": "结束",
        "sourceNodeType": "源",
        "targetNodeType": "目标",
        "extractNodeLabel": "提取与验证",
        "parserNodeType": "解析器",
        "notFoundTitle": "未找到管道",
        "backToPipelines": "返回管道列表",
        "typeLabel": "类型",
        "batchSizeLabel": "批次大小",
        "retryOnFailureLabel": "失败时重试",
        "updatedLabel": "更新时间",
        "yes": "是",
        "no": "否",
        "transformationSqlLabel": "转换 SQL",
        "customCodeLabel": "自定义代码"
      }
    }
  },
  "pipelineDesigner": {
    "list": {
      "searchPlaceholder": "搜索设计...",
      "emptyMessage": "暂无编排工作流",
      "newWorkflow": "新建编排工作流",
      "columnName": "名称",
      "columnDescription": "描述",
      "columnStatus": "状态",
      "columnUpdatedAt": "更新时间",
      "columnCreatedAt": "创建时间",
      "columnActions": "操作",
      "actionEdit": "编辑",
      "actionDelete": "删除",
      "createFailed": "创建设计失败",
      "deleteFailed": "删除设计失败",
      "deletedToast": "已删除设计“{{name}}”",
      "filterStatusLabel": "状态",
      "deleteDialogTitle": "删除设计",
      "deleteDialogMessage": "确定要删除“{{name}}”吗?此操作无法撤消。",
      "deleteDialogConfirm": "删除设计",
      "cancel": "取消"
    },
    "status": {
      "draft": "草稿",
      "published": "已发布",
      "pending": "待处理",
      "running": "运行中",
      "success": "成功",
      "failed": "失败",
      "cancelled": "已取消",
      "terminating": "正在终止",
      "timed_out": "已超时",
      "unknown": "未知"
    },
    "canvas": {
      "loading": "正在加载设计...",
      "tabCanvas": "画布",
      "tabRuns": "运行记录",
      "tabSettings": "设置",
      "publishButton": "发布并运行",
      "publishDisabledTitle": "请在“设置”标签页中选择编排器连接以进行发布。",
      "settingsTitle": "设计设置",
      "orchestratorRuntimeTitle": "编排器运行时",
      "orchestratorRuntimeDesc": "发布需要与目标类型匹配的租户编排器连接。凭据由连接器解析,不会存储在图中。",
      "targetOrchestratorLabel": "目标编排器",
      "saveFailed": "保存设计失败",
      "validationFailed": "设计验证失败",
      "publishFailed": "发布失败"
    },
    "createDialog": {
      "title": "新建编排工作流",
      "closeAria": "关闭对话框",
      "nameLabel": "设计名称",
      "namePlaceholder": "例如 nightly-feature-batch",
      "descriptionLabel": "描述(可选)",
      "descriptionPlaceholder": "目录中显示的简短摘要",
      "orchestratorLabel": "目标编排器",
      "orchestratorHint": "发布并运行目前使用 Databricks Workflows 的 Enterprise Ontology 发布器。Vertex AI 和 Airflow 正在规划中。",
      "cancel": "取消",
      "create": "创建",
      "creating": "创建中…"
    },
    "publishDialog": {
      "title": "发布并运行",
      "selectConnectionWarning": "发布前请在“设置”标签页中选择<1>编排器连接</1>。执行层会从该连接器解析凭据。",
      "translateJobText": "这将把 <1>{{designName}}</1> 转换为 <2>{{orchestratorType}}</2> 作业,创建后立即触发一次运行。",
      "notebookParamsLabel": "Notebook 参数(可选 JSON)",
      "cancel": "取消",
      "publish": "发布并运行",
      "publishing": "正在发布...",
      "orchestratorFallback": "编排器"
    },
    "nodeConfig": {
      "nodeTitle": "{{type}} 节点",
      "noConfigurableProps": "此节点没有可配置的属性。",
      "taskConfigTitle": "任务配置",
      "labelLabel": "标签",
      "labelPlaceholder": "任务名称",
      "notebookPathLabel": "Notebook 路径",
      "notebookPathPlaceholder": "/notebooks/my_notebook.py",
      "notebookPathHint": "相对于 Git 仓库根目录的路径。",
      "timeoutLabel": "超时(秒)",
      "maxRetriesLabel": "最大重试次数",
      "retryOnTimeoutLabel": "超时时重试"
    },
    "canvasEditor": {
      "addTask": "添加任务",
      "saveNow": "立即保存",
      "allChangesSaved": "所有更改已保存",
      "saving": "正在保存…",
      "saveFailedUseSaveNow": "保存失败 — 请使用“立即保存”",
      "unsavedWillAutoSave": "未保存 — 将自动保存",
      "delete": "删除",
      "newTaskLabel": "新任务"
    },
    "gitSource": {
      "title": "Git 源",
      "repoUrlLabel": "仓库 URL",
      "repoUrlPlaceholder": "https://github.com/org/repo",
      "providerLabel": "提供方",
      "branchLabel": "分支",
      "branchPlaceholder": "main",
      "branchError": "请输入有效的分支名称(仅限字母、数字、/、-、_、.)。"
    },
    "runs": {
      "noRuns": "暂无运行记录。发布设计以创建运行。",
      "colStatus": "状态",
      "colRunId": "运行 ID",
      "colStarted": "开始时间",
      "colDuration": "持续时间",
      "colExternal": "外部",
      "colActions": "操作",
      "runningLabel": "运行中...",
      "view": "查看",
      "cancel": "取消"
    },
    "runDetail": {
      "loading": "正在加载运行详情...",
      "title": "运行详情",
      "runId": "运行 ID",
      "externalRunId": "外部运行 ID",
      "started": "开始时间",
      "completed": "完成时间",
      "viewInOrchestrator": "在编排器中查看",
      "cancelling": "正在取消...",
      "cancelRun": "取消运行",
      "taskStates": "任务状态"
    },
    "orchestratorConnection": {
      "label": "编排器连接",
      "loadingConnections": "正在加载连接…",
      "optionalSelectToEnable": "可选 — 选择以启用发布并运行",
      "noConnections": "此编排器类型暂无连接。",
      "addOneLink": "请在“连接”→“编排器”下添加"
    },
    "nodes": {
      "start": "开始",
      "end": "结束",
      "untitledTask": "未命名任务"
    }
  },
  "agentStudio": {
    "selfHeal": {
      "llmModel": "LLM 模型",
      "llmModelPlaceholder": "选择模型",
      "llmModelEmpty": "此项目尚未配置 LLM 模型。",
      "llmModelSearch": "搜索模型",
      "analysis": {
        "engineLabel": "分析引擎",
        "engineModel": "{{model}}",
        "engineModelFallback": "所选模型",
        "engineRules": "基于规则",
        "engineFallback": "回退（基于规则）",
        "fallbackTitle": "模型不可用",
        "fallbackNotice": "模型“{{model}}”调用失败（{{reason}}）。结果已回退到标准规则分析。",
        "fallbackNoticeUnnamed": "所选模型调用失败（{{reason}}）。结果已回退到标准规则分析。",
        "reasonAuthFailed": "API 密钥被拒绝",
        "reasonRateLimited": "已达到速率限制",
        "reasonTimeout": "请求超时",
        "reasonMisconfigured": "该模型在此项目中不可用",
        "reasonInvalidModel": "模型选择无效",
        "reasonInvalidJson": "无法解析模型回复",
        "reasonUnusable": "模型未返回可用的建议",
        "reasonUnavailable": "无法连接到模型"
      }
    },
    "loading": "正在加载智能体工作室...",
    "permissionDeniedMessage": "您无权查看此页面，请联系管理员。",
    "untitledAgent": "未命名智能体",
    "fallbackAgentName": "智能体",
    "ok": "确定",
    "closeDialogAriaLabel": "关闭对话框",
    "list": {
      "columnAgentName": "智能体名称",
      "columnProject": "项目",
      "columnVersion": "版本",
      "columnStatus": "状态",
      "columnCreator": "创建者",
      "columnCreatedAt": "创建时间",
      "columnUpdatedAt": "更新时间",
      "columnActions": "操作",
      "registeredToRegistryTitle": "已注册到注册表",
      "emptyFavorites": "暂无收藏的智能体 — 在列表中点击星标进行收藏",
      "emptyArchived": "暂无已归档的智能体",
      "emptyDefault": "未找到智能体",
      "filterFavoritesTitle": "按收藏筛选",
      "allAgents": "全部智能体",
      "favorites": "收藏",
      "catalogTitle": "智能体目录",
      "activeAgentsTitle": "活跃智能体",
      "archivedAgentsTitle": "已归档智能体",
      "guidedTourTitle": "智能体工作室引导 tour",
      "autoTune": "自动调优",
      "createAgent": "创建智能体",
      "exportSelected": "导出所选",
      "archiveSelected": "归档所选",
      "exportFileName": "Agent_Studio",
      "exportFileNameArchived": "Agent_Studio_Archived"
    },
    "filters": {
      "status": "状态",
      "registryStatus": "注册表状态",
      "draft": "草稿",
      "published": "已发布",
      "registered": "已注册",
      "unregistered": "未注册",
      "project": "项目",
      "creator": "创建者"
    },
    "actions": {
      "restoreToDraft": "恢复为草稿",
      "view": "查看",
      "chat": "聊天",
      "traces": "追踪",
      "logs": "日志",
      "exportYaml": "导出 (YAML)",
      "exportJson": "导出 (JSON)",
      "evaluate": "评估",
      "viewEvaluationRuns": "查看评估运行",
      "registerToRegistry": "注册到注册表",
      "registrationPending": "注册待审批",
      "unregisterFromRegistry": "从注册表取消注册",
      "clone": "克隆",
      "archive": "归档"
    },
    "backLabels": {
      "traces": "追踪",
      "blueprint": "蓝图"
    },
    "publishDialog": {
      "title": "发布智能体",
      "confirmHeading": "确定要发布吗？",
      "confirmDescription": "发布后该智能体将可供使用。可通过归档智能体来撤销此操作。",
      "agentLabel": "智能体：",
      "frameworkLabel": "框架：",
      "nodesLabel": "节点：",
      "publishButton": "发布智能体"
    },
    "archiveDialog": {
      "title": "归档智能体",
      "publishedHeading": "此智能体已发布",
      "publishedDescription": "要归档，请先下架智能体商店列表、在监控中归档部署，如仍在注册表中则取消注册。完成这些步骤后，智能体将移至归档列表。",
      "confirmMessage": "确定要归档“{{name}}”吗？",
      "checkingDependencies": "正在检查依赖项…",
      "archiveButton": "归档智能体",
      "draftConfirmMessage": "归档“{{name}}”？它将出现在归档列表中；您可恢复为草稿或永久删除。"
    },
    "deleteDialog": {
      "title": "删除智能体",
      "confirmMessage": "永久删除“{{name}}”？这将从系统中移除该智能体且无法撤销。"
    },
    "bulkArchive": {
      "title_one": "归档智能体",
      "title_other": "归档智能体",
      "confirmMessage": "归档 {{count}} 个智能体？它们将出现在归档列表中；您可恢复为草稿或永久删除。",
      "confirmButton": "归档",
      "failureMessage": "归档智能体失败",
      "blockedMessage": "“{{name}}”存在必须先清除的依赖项才能归档。"
    },
    "blockedDialogs": {
      "cannotArchiveTitle": "暂时无法归档智能体",
      "cannotUnregisterTitle": "暂时无法从注册表移除",
      "unregisterDependenciesMessage": "请先移除智能体商店列表并归档部署，再从智能体注册表移除此智能体。",
      "dependenciesMustBeCleared": "必须先清除依赖项。"
    },
    "registerDialog": {
      "title": "注册到注册表",
      "submitHeading": "提交管理员审批",
      "submitDescription": "这将向租户管理员发送注册请求。管理员在常规设置 → 请求审批中批准后，智能体才会出现在智能体注册表中。",
      "confirmMessage": "为“{{name}}”提交注册请求？",
      "metadata": "元数据",
      "submitting": "提交中...",
      "submitRequest": "提交请求"
    },
    "deletePrerequisites": {
      "stillRegistered": "此智能体仍在智能体注册表中注册。",
      "activeStoreListing": "此智能体存在有效的智能体商店列表。",
      "nonArchivedDeployments": "存在尚未归档的智能体部署。",
      "clearBeforeArchive": "{{details}} 请先清除这些项再归档。"
    },
    "blockerMessages": {
      "registry": "归档前请先从智能体注册表取消注册此智能体。",
      "agent_store": "归档前请先下架此智能体的有效智能体商店列表。",
      "agent_deployments": "归档前请在监控中归档此智能体的所有部署。",
      "agent_store_unregister": "从智能体注册表移除前请先下架有效的智能体商店列表。",
      "agent_deployments_unregister": "从智能体注册表移除前请在监控中归档所有部署。"
    },
    "blockerNav": {
      "registry": "打开智能体注册表",
      "workflow_registry": "打开工作流注册表",
      "agent_store": "打开智能体商店（管理）",
      "agent_deployments": "打开监控 — 部署",
      "workflow_store": "打开工作流商店（管理）",
      "workflow_deployments": "打开监控 — 部署",
      "running_executions": "打开运行记录"
    }
  },
  "projects": {
    "status": {
      "active": "活跃",
      "draft": "草稿",
      "archived": "已归档",
      "error": "错误",
      "pending": "待处理"
    },
    "list": {
      "permissionDeniedMessage": "您无权查看项目。请联系您的管理员。",
      "loading": "正在加载项目...",
      "columnName": "项目名称",
      "columnMembers": "成员",
      "columnStatus": "状态",
      "columnActions": "操作",
      "filterCreatorLabel": "创建者",
      "actionOpen": "打开",
      "actionConfigure": "配置",
      "actionEdit": "编辑",
      "actionDelete": "删除",
      "bulkDeleteSelected": "删除所选项",
      "emptyMessage": "未找到项目",
      "createProject": "创建项目",
      "setupWizard": "设置向导",
      "setupWizardTooltip": "设置向导 - 导入 YAML 文件以创建项目",
      "deleteDialogTitle": "删除项目",
      "deleteDialogMessage": "确定要删除“{{name}}”吗？此操作无法撤销。",
      "fetchingDependenciesMessage": "正在获取项目依赖…",
      "forceDeleteDialogTitle": "确认强制删除",
      "forceDeleteDialogMessage": "强制删除将永久移除“{{name}}”以及所有智能体、部署、智能体商店列表、仿真、提示词、技能、工具和其他项目数据。此操作无法撤销。",
      "forceDeleteConfirmLabel": "强制删除项目",
      "bulkDeleteDialogTitle": "删除所选项目",
      "bulkDeleteConfirmMessage_other": "确定要删除 {{count}} 个项目吗？此操作无法撤销。",
      "bulkDeleteConfirmLabel_other": "删除 {{count}} 个项目",
      "forceDeleteSuccessToast": "项目“{{name}}”已被强制删除",
      "forceDeleteErrorToast": "强制删除失败。请移除剩余依赖项后重试。",
      "noProjectsSelectedWarning": "未选择任何项目",
      "bulkDeletePartialWarning": "已删除 {{deleted}} 个项目，{{skipped}} 个失败：{{errors}}",
      "bulkDeleteSuccessToast": "已成功删除 {{deleted}} 个项目",
      "bulkDeleteErrorToast": "删除项目失败",
      "andOthers": "以及其他 {{count}} 个"
    },
    "createDialog": {
      "title": "创建新项目",
      "closeAriaLabel": "关闭对话框",
      "loadingQuota": "正在加载配额...",
      "quotaLabel": "项目",
      "nameLabel": "项目名称 *",
      "namePlaceholder": "输入项目名称",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "项目的简要描述",
      "descriptionEmojiError": "描述不能包含表情符号，请仅使用纯文本。",
      "quotaExceededTitle": "项目配额已超出",
      "creating": "创建中..."
    },
    "editDialog": {
      "title": "编辑项目",
      "closeAriaLabel": "关闭对话框",
      "nameLabel": "项目名称 *",
      "descriptionLabel": "描述",
      "saving": "保存中...",
      "saveChanges": "保存更改"
    },
    "actions": {
      "view": "查看",
      "edit": "编辑",
      "chat": "聊天",
      "traces": "追踪",
      "logs": "日志",
      "evaluate": "评估",
      "viewEvaluationRuns": "查看评估运行记录",
      "cloneInAgentStudio": "在智能体工作室中克隆",
      "openInAgentStudio": "在智能体工作室中打开",
      "manageArchiveInStudio": "在 Studio 中管理归档",
      "open": "打开",
      "runs": "运行记录",
      "editCanvas": "编辑画布",
      "viewInStudio": "在 Studio 中查看",
      "testChat": "测试 / 聊天",
      "deployInRegistry": "在 Registry 中部署",
      "guardrails": "防护栏",
      "chatDetail": "聊天 / 详情",
      "runtimeSettings": "运行时设置",
      "openInMonitoring": "在 Monitoring 中打开"
    },
    "detail": {
      "notFound": "未找到项目",
      "backToProjectsButton": "返回项目",
      "backToProjectsAriaLabel": "返回项目",
      "viewOnlyBadge": "仅查看",
      "tabsAriaLabel": "项目详情标签页",
      "tabs": {
        "overview": "概览",
        "agents": "智能体",
        "workflows": "工作流",
        "registry": "注册表",
        "evals": "评估",
        "deployments": "部署"
      }
    },
    "overview": {
      "hubSubtitle": "项目中心",
      "noTabsAvailable": "您的角色没有可用的详情标签页。",
      "openInBrand": "在 {{brand}} 中打开{{label}}",
      "cards": {
        "agents": "智能体",
        "workflows": "工作流",
        "registry": "已注册",
        "evals": "评估智能体",
        "deployments": "活跃部署"
      }
    },
    "members": {
      "title": "成员",
      "refreshTooltip": "刷新成员列表",
      "addMemberButton": "添加成员",
      "selectedCount": "已选择 {{count}} 个",
      "changeRoleButton": "更改角色",
      "remove": "移除",
      "clearButton": "清除",
      "selectAllButton": "全选",
      "noMembersYet": "暂无成员",
      "selectAll": "全选",
      "deselectAll": "取消全选",
      "unknown": "未知",
      "creatorBadge": "创建者",
      "role": {
        "member": "成员",
        "admin": "管理员",
        "viewer": "查看者",
        "creator": "创建者"
      },
      "memberSince": "加入时间：{{date}}",
      "changeRoleTitle": "更改角色",
      "memberFallbackName": "成员",
      "select": "选择",
      "deselect": "取消选择",
      "removeMembersTitle": "移除成员",
      "removeMemberTitle": "移除成员",
      "removeMembersMessage": "确定要将 {{count}} 名成员从该项目中移除吗？此操作无法撤销。",
      "removeMemberMessage": "确定要将“{{name}}”从该项目中移除吗？此操作无法撤销。",
      "changeRoleForCount_other": "为 {{count}} 名成员更改角色",
      "selectNewRoleLabel": "选择新角色",
      "updating": "更新中...",
      "updateRole": "更新角色",
      "loadErrorFallback": "无法加载成员，请刷新页面。",
      "selectAtLeastOneUserError": "请至少选择一位用户",
      "addedSuccessToast_other": "已成功添加 {{count}} 名成员",
      "removedSuccessToast": "成员移除成功",
      "roleUpdatedSuccessToast": "成员角色更新成功",
      "bulkRoleUpdatedWithErrorsToast": "已更新 {{updated}} 名成员，发生 {{errorCount}} 个错误。",
      "bulkRoleUpdatedSuccessToast": "已成功更新 {{updated}} 名成员的角色",
      "bulkRemovedWithErrorsToast": "已移除 {{removed}} 名成员，发生 {{errorCount}} 个错误。",
      "bulkRemovedSuccessToast": "已成功移除 {{removed}} 名成员"
    },
    "configure": {
      "tabsAriaLabel": "项目配置标签页",
      "tabs": {
        "members": "成员",
        "orchestrators": "编排器",
        "prompts": "提示词",
        "models": "模型",
        "tools": "工具",
        "skills": "技能",
        "knowledge": "知识库",
        "graph": "图谱",
        "vector": "向量",
        "storage": "存储"
      }
    },
    "setupWizard": {
      "title": "项目设置向导",
      "projectFieldLabel": "项目",
      "projectFieldPlaceholder": "选择项目...",
      "projectFieldRequiredLabel": "项目 *",
      "projectNameFieldName": "项目名称",
      "projectNameFieldRequiredLabel": "项目名称 *",
      "projectNamePlaceholder": "我的精彩项目",
      "orDivider": "或",
      "createNewProject": "创建新项目",
      "descriptionFieldLabel": "描述",
      "descriptionPlaceholder": "简要描述...",
      "filesImportedIntoSelectedProject": "文件将导入所选项目",
      "dropzoneAriaLabel": "上传 YAML 文件。将文件拖放到此处，或点击/按 Enter 或空格键浏览。",
      "dropzoneText": "将文件拖放到此处或点击浏览",
      "dropzoneHint": ".yaml、.yml — 智能体、模型、工具、提示词、技能、知识库、连接器、IAM",
      "validFilesCount": "{{count}} 个有效文件",
      "filesWithErrorsCount": "{{count}} 个存在错误",
      "noAgentYamlWarning": "未检测到智能体 YAML。请考虑添加智能体配置。",
      "reviewStepTitle": "查看导入顺序",
      "reviewStepDescription": "文件将根据依赖关系按以下顺序导入：",
      "filesWithErrorsSkipped": "将跳过 {{count}} 个存在错误的文件",
      "importingStepTitle": "正在导入…",
      "importingProgress": "正在导入第 {{current}} 个，共 {{total}} 个：{{fileName}}",
      "importActions": {
        "created": "已创建",
        "matched": "已匹配",
        "failed": "失败"
      },
      "completeStepTitleSuccess": "设置完成！",
      "completeStepTitleWithErrors": "设置已完成，但存在错误",
      "completeStepDescription": "您的项目已使用以下实体完成设置：",
      "summaryBadges": {
        "created": "新建 {{count}} 个",
        "matched": "匹配 {{count}} 个",
        "failed": "失败 {{count}} 个"
      },
      "errorsHeading": "错误：",
      "steps": {
        "selectProject": "选择项目",
        "addFiles": "添加文件",
        "review": "查看",
        "import": "导入"
      },
      "creatingLabel": "正在创建…",
      "createAndContinue": "创建并继续",
      "continueLabel": "继续",
      "reviewImport": "查看导入",
      "startImport": "开始导入",
      "importingLabel": "正在导入…",
      "goToProject": "前往项目",
      "entityTypes": {
        "agent": "智能体",
        "model": "模型",
        "tool": "工具",
        "prompt": "提示词",
        "skill": "技能",
        "knowledge": "知识库",
        "connector": "连接器",
        "iam": "IAM",
        "bundle": "捆绑包",
        "unknown": "未知"
      },
      "toasts": {
        "dropYamlFiles": "请拖放 YAML 文件",
        "enterProjectName": "请输入项目名称",
        "projectCreated": "已创建项目“{{name}}”",
        "selectProject": "请选择一个项目",
        "projectSelected": "已选择项目“{{name}}”",
        "addAtLeastOneFile": "请至少添加一个 YAML 文件",
        "noValidYamlFiles": "未找到有效的 YAML 文件",
        "projectNotCreated": "项目未创建",
        "noValidFilesToImport": "没有可导入的有效文件",
        "importReportedFailure": "{{name}} 的导入报告失败",
        "allImportedSuccessfully": "所有实体已成功导入！",
        "importPermissionError": "由于权限不足，导入失败。请联系您的管理员。",
        "importCompletedWithErrors": "导入完成，存在 {{count}} 个错误"
      },
      "unknownProject": "未知"
    },
    "agentsTab": {
      "agentStatusTitle": "智能体状态",
      "activeAgentsTitle": "活跃智能体",
      "archivedAgentsTitle": "已归档智能体",
      "openInAgentStudio": "在智能体工作室中打开",
      "noArchivedAgents": "此项目中没有已归档的智能体。",
      "noAgents": "此项目中没有智能体。",
      "goToAgentStudio": "前往智能体工作室",
      "archiveDialogTitle": "归档 {{count}} 个智能体",
      "archiveDialogMessage": "归档 {{count}} 个智能体？它们将出现在“已归档”下；您可以在那里将其恢复为草稿或永久删除。",
      "archiveButtonLabel": "归档",
      "archivedWithSkippedToast": "已归档 {{deleted}} 个智能体，因存在活跃依赖而跳过 {{skipped}} 个。",
      "archivedToast": "已归档 {{count}} 个智能体",
      "exportSelected": "导出所选项",
      "archiveSelected": "归档所选项",
      "columns": {
        "name": "名称",
        "status": "状态",
        "framework": "框架",
        "creator": "创建者",
        "createdAt": "创建时间",
        "updatedAt": "更新时间",
        "actions": "操作"
      },
      "searchPlaceholder": "搜索智能体…"
    },
    "workflowsTab": {
      "statusPublished": "已发布",
      "columns": {
        "workflow": "工作流",
        "status": "状态",
        "schedule": "计划",
        "controls": "控制",
        "creator": "创建者",
        "runs": "运行次数",
        "createdAt": "创建时间",
        "tags": "标签",
        "actions": "操作"
      },
      "registeredToRegistryAtVersion": "已在注册表中注册为 v{{version}}",
      "registeredToRegistry": "已在注册表中注册",
      "scheduleActive": "计划已启用",
      "schedulePaused": "计划已暂停",
      "notScheduled": "未计划",
      "draftCadenceTooltip": "草稿中已保存周期 — 发布后才会启动计划（{{cadence}}）。",
      "neverRun": "从未运行",
      "lastRunTitle": "上次运行",
      "searchPlaceholder": "搜索工作流…",
      "clearSearch": "清除搜索",
      "totalWorkflows": "工作流总数 {{count}}",
      "catalogTitle": "目录",
      "activeWorkflowsTitle": "活跃工作流",
      "archivedWorkflowsTitle": "已归档工作流",
      "gridViewTitle": "网格视图",
      "listViewTitle": "列表视图",
      "openInAgentWorkflows": "在智能体工作流中打开",
      "noSearchResults": "没有与您的搜索匹配的工作流。",
      "noArchivedWorkflows": "此项目中没有已归档的工作流。",
      "noWorkflows": "此项目中没有工作流。",
      "goToAgentWorkflows": "前往智能体工作流",
      "lastRunStatusTooltip": "上次运行状态：{{status}}",
      "lastRunTooltip": "上次运行：{{time}}",
      "updatedTooltip": "更新时间：{{time}}",
      "noDescriptionProvided": "未提供描述",
      "runsCount": "{{count}} 次运行",
      "lastRunLabel": "上次运行 {{time}}",
      "pageOfTotal": "第 {{page}} 页，共 {{totalPages}} 页",
      "versionTitle": "版本"
    },
    "skillsTab": {
      "loadError": "加载技能失败",
      "requestedAccessToast": "已请求访问 {{count}} 项技能（待审批）",
      "addedToast": "已将 {{count}} 项技能添加到项目",
      "alreadyInProjectToast": "{{count}} 项技能已在项目中",
      "addFailedToast": "添加 {{count}} 项技能失败",
      "removedToast": "技能已从项目中移除",
      "bulkRemovedToast": "已成功从项目中移除 {{count}} 项技能",
      "bulkRemoveFailedToast": "移除 {{count}} 项技能失败",
      "removeFromProject": "从项目中移除",
      "pending": "待处理",
      "platform": "平台",
      "allModels": "所有模型",
      "columns": {
        "name": "技能名称",
        "category": "类别",
        "type": "类型",
        "model": "模型",
        "version": "版本",
        "added": "添加时间",
        "lastUpdated": "最后更新",
        "actions": "操作"
      },
      "errorBoundaryMessage": "无法加载技能。请刷新页面。",
      "emptyMessage": "此项目未配置任何技能",
      "addSkill": "添加技能",
      "addSkillsToProjectTitle": "将技能添加到项目",
      "showApprovedSkills": "显示已批准的技能",
      "removeDialogTitle": "移除技能",
      "removeDialogMessage": "确定要从此项目中移除“{{name}}”吗？",
      "remove": "移除",
      "bulkRemoveDialogTitle": "移除技能",
      "bulkRemoveDialogMessage": "确定要从此项目中移除所选的 {{count}} 项技能吗？"
    },
    "toolsTab": {
      "requestedAccessToast": "已请求访问 {{count}} 个工具（待审批）",
      "alreadyInProjectToast": "{{count}} 个工具已在项目中",
      "addFailedToast": "添加 {{count}} 个工具失败",
      "removedToast": "工具已从项目中移除",
      "bulkRemovedToast": "已成功从项目中移除 {{count}} 个工具",
      "bulkRemoveFailedToast": "移除 {{count}} 个工具失败：{{errors}}",
      "removeFromProject": "从项目中移除",
      "exportSelected": "导出所选",
      "pending": "待处理",
      "columns": {
        "name": "工具名称",
        "type": "类型",
        "endpoint": "端点",
        "created": "创建时间",
        "lastUpdated": "最后更新",
        "actions": "操作"
      },
      "errorBoundaryMessage": "无法加载工具。请刷新页面。",
      "emptyMessage": "此项目未配置任何工具",
      "addTool": "添加工具",
      "addToolsToProjectTitle": "将工具添加到项目",
      "showApprovedTools": "显示已批准的工具",
      "removeDialogTitle": "移除工具",
      "removeDialogMessage": "确定要从此项目中移除“{{name}}”吗？",
      "remove": "移除",
      "bulkRemoveDialogTitle": "移除工具",
      "bulkRemoveDialogMessage": "确定要从此项目中移除所选的 {{count}} 个工具吗？"
    },
    "modelsTab": {
      "requestedAccessToast": "已请求访问 {{count}} 个模型（待审批）",
      "alreadyInProjectToast": "{{count}} 个模型已在项目中",
      "addFailedToast": "{{count}} 个模型添加失败",
      "removedToast": "模型已成功移除",
      "bulkRemovedToast": "已成功从项目中移除 {{count}} 个模型",
      "bulkRemoveFailedToast": "移除 {{count}} 个模型失败：{{errors}}",
      "removeFromProject": "从项目中移除",
      "pending": "待处理",
      "columns": {
        "name": "模型名称",
        "provider": "提供商",
        "modelId": "模型ID",
        "created": "创建时间",
        "lastUpdated": "最后更新",
        "actions": "操作"
      },
      "errorBoundaryMessage": "无法加载模型。请刷新页面。",
      "emptyMessage": "此项目未配置任何模型",
      "addModel": "添加模型",
      "addModelsToProjectTitle": "将模型添加到项目",
      "showApprovedModels": "显示已批准的模型",
      "removeDialogTitle": "移除模型",
      "removeDialogMessage": "确定要从此项目中移除“{{name}}”吗？",
      "remove": "移除",
      "bulkRemoveDialogTitle": "移除模型",
      "bulkRemoveDialogMessage": "确定要从此项目中移除所选的 {{count}} 个模型吗？"
    },
    "orchestratorsTab": {
      "selectAtLeastOne": "请至少选择一个编排器",
      "requestedAccessToast": "已请求访问 {{count}} 个编排器（待审批）",
      "removedToast": "已将“{{name}}”从项目中移除",
      "bulkRemovedToast": "已成功从项目中移除 {{count}} 个编排器",
      "bulkRemoveFailedToast": "移除 {{count}} 个编排器失败：{{errors}}",
      "removeFromProject": "从项目中移除",
      "testConnection": "测试连接",
      "testConnectionSuccess": "“{{name}}”的连接测试成功",
      "testConnectionFailure": "“{{name}}”的连接测试失败：{{message}}",
      "columns": {
        "name": "名称",
        "type": "类型",
        "host": "主机",
        "status": "状态",
        "addedBy": "添加者",
        "addedAt": "添加时间",
        "actions": "操作"
      },
      "errorBoundaryMessage": "无法加载编排器。请刷新页面。",
      "emptyMessage": "此项目未配置任何编排器",
      "addOrchestrator": "添加编排器",
      "addOrchestratorsToProjectTitle": "将编排器添加到项目",
      "removeDialogTitle": "移除编排器",
      "removeDialogMessage": "确定要从此项目中移除“{{name}}”吗？",
      "remove": "移除",
      "bulkRemoveDialogTitle": "移除编排器",
      "bulkRemoveDialogMessage": "确定要从此项目中移除所选的 {{count}} 个编排器吗？"
    },
    "knowledgeTab": {
      "unknown": "未知",
      "vectorDatabase": "向量数据库",
      "vectorDbBadge": "向量数据库",
      "schemaTitle": "模式：{{schema}}",
      "searchPlaceholder": "搜索表...",
      "clearSearch": "清除搜索",
      "columns": {
        "name": "名称",
        "database": "数据库",
        "rows": "行数",
        "status": "状态",
        "creator": "创建者",
        "actions": "操作"
      },
      "status": {
        "error": "错误",
        "active": "活跃",
        "syncing": "同步中",
        "pending": "待处理"
      },
      "actions": {
        "previewData": "预览数据",
        "removeFromProject": "从项目中移除",
        "remove": "移除"
      },
      "toasts": {
        "requestedAccess": "已请求访问 {{count}} 个{{tableLabel}}{{plural}}（待批准）",
        "alreadyInProject": "{{count}} 个{{tableLabel}}{{plural}}已在项目中",
        "requestAccessFailed": "请求访问 {{count}} 个{{tableLabel}}{{plural}}失败",
        "removed": "知识表已从项目中移除",
        "bulkRemoved": "已成功从项目中移除 {{count}} 个{{typeLabel}}表{{plural}}",
        "bulkRemoveFailed": "移除 {{count}} 个{{typeLabel}}表{{plural}}失败：{{errors}}"
      },
      "removeDialogMessage": "要将“{{name}}”从此项目中移除吗？",
      "bulkRemoveDialogMessage": "确定要从此项目中移除所选的 {{count}} 个表吗？",
      "viewToggle": {
        "database": "数据库视图",
        "collection": "集合视图"
      },
      "variant": {
        "knowledge": {
          "tableLabel": "知识表",
          "typeLabel": "知识",
          "addButton": "添加知识",
          "emptyMessage": "此项目未配置知识表",
          "addModalTitle": "将知识添加到项目",
          "membershipToggleLabel": "显示已批准的表",
          "removeDialogTitle": "移除知识表",
          "removeDialogTitlePlural": "移除知识表",
          "errorBoundaryMessage": "无法加载知识表。请刷新页面。"
        },
        "graph": {
          "tableLabel": "图表",
          "typeLabel": "图",
          "addButton": "添加图",
          "emptyMessage": "此项目未配置图表",
          "addModalTitle": "将图表添加到项目",
          "membershipToggleLabel": "显示已批准的图表",
          "removeDialogTitle": "移除图表",
          "removeDialogTitlePlural": "移除图表",
          "errorBoundaryMessage": "无法加载图表。请刷新页面。"
        },
        "vector": {
          "tableLabel": "向量表",
          "typeLabel": "向量",
          "addButton": "添加向量",
          "emptyMessage": "此项目未配置向量表",
          "addModalTitle": "将向量表添加到项目",
          "membershipToggleLabel": "显示已批准的向量表",
          "removeDialogTitle": "移除向量表",
          "removeDialogTitlePlural": "移除向量表",
          "errorBoundaryMessage": "无法加载向量表。请刷新页面。"
        }
      }
    },
    "storageTab": {
      "unknown": "未知",
      "addButton": "添加存储",
      "addModalTitle": "将存储添加到项目",
      "emptyMessage": "此项目未配置存储文件夹",
      "errorBoundaryMessage": "无法加载存储文件夹。请刷新页面。",
      "membershipToggleLabel": "显示已批准的存储",
      "removeDialogTitle": "移除存储文件夹",
      "removeDialogTitlePlural": "移除存储文件夹",
      "removeDialogMessage": "要将“{{name}}”从此项目中移除吗？",
      "bulkRemoveDialogMessage": "确定要从此项目中移除所选的 {{count}} 个存储文件夹吗？",
      "columns": {
        "folder": "文件夹",
        "connector": "连接器",
        "files": "文件",
        "size": "大小",
        "status": "状态",
        "creator": "创建者",
        "actions": "操作"
      },
      "status": {
        "active": "活跃",
        "error": "错误",
        "pending": "待处理"
      },
      "actions": {
        "previewFiles": "预览文件",
        "sync": "同步",
        "syncing": "同步中...",
        "removeFromProject": "从项目中移除",
        "remove": "移除"
      },
      "toasts": {
        "requestedAccess": "已请求访问 {{count}} 个存储文件夹{{plural}}（待批准）",
        "alreadyInProject": "{{count}} 个存储文件夹{{plural}}已在项目中",
        "addFailed": "添加 {{count}} 个存储文件夹{{plural}}失败",
        "synced": "已同步“{{name}}”的元数据。",
        "removed": "存储文件夹已从项目中移除",
        "bulkRemoved": "已成功从项目中移除 {{count}} 个存储文件夹{{plural}}",
        "bulkRemoveFailed": "移除 {{count}} 个存储文件夹{{plural}}失败"
      }
    },
    "registryTab": {
      "columnAgent": "代理",
      "columnFramework": "框架",
      "columnStatus": "状态",
      "columnEnv": "环境",
      "columnOrchestrator": "编排器",
      "columnRegisteredBy": "注册者",
      "columnRegisteredAt": "注册时间",
      "columnActions": "操作",
      "columnWorkflow": "工作流",
      "actionOpenCanvas": "打开画布",
      "actionRuns": "运行",
      "registryViewsAriaLabel": "注册表视图",
      "agentRegistryTitle": "代理注册表",
      "agentsLabel": "代理",
      "workflowRegistryTitle": "工作流注册表",
      "workflowsLabel": "工作流",
      "registryStatusTitle": "注册表状态",
      "activeItemsTitle": "活跃的注册表项",
      "archivedItemsTitle": "已归档的注册表项",
      "openInRegistryTitle": "在注册表中打开",
      "emptyActiveAgents": "此项目中没有已注册的代理。",
      "emptyArchivedAgents": "此项目中没有已归档的注册代理。",
      "emptyActiveWorkflows": "此项目中没有已注册的工作流。",
      "emptyArchivedWorkflows": "此项目中没有已归档的注册工作流。",
      "goToRegistry": "前往代理注册表",
      "searchRegistryPlaceholder": "搜索注册表…",
      "searchWorkflowsPlaceholder": "搜索工作流…"
    },
    "promptsTab": {
      "columnName": "提示名称",
      "columnCategory": "类别",
      "columnDescription": "描述",
      "columnCreated": "创建时间",
      "columnLastUpdated": "最后更新",
      "columnActions": "操作",
      "noDescription": "无描述",
      "viewVersionsTitle": "查看提示版本",
      "errorBoundaryMessage": "无法加载提示。请刷新页面。",
      "emptyMessage": "此项目中没有提示。提示通过“提示”页面进行管理。",
      "dialogCloseAriaLabel": "关闭对话框",
      "categoryLabel": "类别：",
      "versionsHeading": "版本（{{count}}）",
      "loadingVersions": "正在加载版本...",
      "noVersionsFound": "未找到版本",
      "versionLabel": "版本 {{version}}",
      "latestBadge": "最新",
      "selectVersionPrompt": "选择一个版本以查看内容"
    },
    "deploymentsTab": {
      "columnAgent": "代理",
      "columnEnv": "环境",
      "columnStatus": "状态",
      "columnDeployedBy": "部署者",
      "columnDeployedAt": "部署时间",
      "columnActions": "操作",
      "columnWorkflow": "工作流",
      "actionOpen": "打开",
      "actionChat": "聊天",
      "actionRuntimeSettings": "运行时设置",
      "actionOpenInMonitoring": "在监控中打开",
      "actionManageArchive": "在监控中管理归档",
      "actionGuardrails": "护栏",
      "deploymentViewsAriaLabel": "部署视图",
      "agentDeploymentsTitle": "代理部署",
      "agentsLabel": "代理",
      "workflowDeploymentsTitle": "工作流部署",
      "workflowsLabel": "工作流",
      "deploymentStatusTitle": "部署状态",
      "activeDeploymentsTitle": "活跃部署",
      "archivedDeploymentsTitle": "已归档部署",
      "openInMonitoringTitle": "在监控中打开",
      "emptyActiveAgents": "此项目没有活跃的代理部署。",
      "emptyArchivedAgents": "此项目没有已归档的代理部署。",
      "emptyActiveWorkflows": "此项目没有活跃的工作流部署。",
      "emptyArchivedWorkflows": "此项目没有已归档的工作流部署。",
      "goToMonitoring": "前往监控",
      "searchDeploymentsPlaceholder": "搜索部署…",
      "searchWorkflowDeploymentsPlaceholder": "搜索工作流部署…"
    },
    "evalsTab": {
      "columnAgent": "代理",
      "columnLatestSession": "最新会话",
      "columnActions": "操作",
      "actionOpenEvals": "打开评估",
      "actionManageInEvals": "在评估中管理",
      "portfolioSubtitle": "此项目的评估组合",
      "openInEvalsTitle": "在评估中打开",
      "emptyMessage": "此项目没有评估数据。",
      "goToEvals": "前往评估与模拟",
      "searchAgentsPlaceholder": "搜索代理…"
    }
  },
  "prompts": {
    "exportFileName": "提示词",
    "searchPlaceholder": "搜索提示词...",
    "columns": {
      "name": "提示词名称",
      "description": "描述",
      "category": "分类",
      "model": "模型",
      "project": "项目",
      "visibility": "可见性",
      "createdBy": "创建者",
      "updatedAt": "更新时间",
      "actions": "操作"
    },
    "filters": {
      "title": "筛选",
      "visibility": "可见性",
      "category": "分类",
      "project": "项目",
      "creator": "创建者",
      "all": "全部",
      "favorites": "收藏"
    },
    "visibility": {
      "project": "项目",
      "public": "平台"
    },
    "list": {
      "uncategorized": "未分类",
      "allModels": "所有模型",
      "platformBadge": "平台",
      "platformBadgeTooltip": "代码内置的系统提示词 — 只读",
      "versionCount": "{{count}} 个版本",
      "versionCount_other": "{{count}} 个版本",
      "unknownProject": "未知",
      "emptyState": {
        "permissionDenied": "你没有查看提示词的权限。请联系管理员获取访问权限。",
        "noResultsSearch": "未找到与搜索匹配的提示词。",
        "default": "未找到提示词。创建你的第一个提示词以开始使用。"
      }
    },
    "actions": {
      "view": "查看",
      "chat": "对话",
      "exportYaml": "导出为 YAML",
      "optimize": "优化",
      "cloneForModel": "为模型克隆",
      "edit": "编辑",
      "delete": "删除",
      "exportSelected": "导出所选",
      "deleteSelected": "删除所选",
      "createPrompt": "创建提示词",
      "newPrompt": "新建提示词",
      "creating": "创建中..."
    },
    "quota": {
      "loading": "正在加载配额...",
      "label": "提示词"
    },
    "toast": {
      "projectFilterReset": "之前选择的项目已不存在，筛选条件已重置。",
      "draftInserted": "已插入提示词草稿。如有需要请编辑后再创建 — 保存后可在提示词编辑器中运行优化。",
      "clonedForModel": "已为模型“{{model}}”克隆提示词",
      "bulkDeletePartial": "已删除 {{deleted}} 个提示词，{{skipped}} 个失败：{{errors}}",
      "bulkDeleteSuccess": "已成功删除 {{count}} 个提示词",
      "platformDeleteBlocked": "平台提示词不能删除"
    },
    "form": {
      "modelAgnostic": "不限模型（所有模型）",
      "selectProjectFirst": "请先选择一个项目。",
      "selectProjectModel": "请选择分配给该项目的 LLM 模型。",
      "selectModel": "请选择一个 LLM 模型。",
      "minBusinessContext": "请输入至少 10 个字符的业务背景。",
      "selectProjectAndModelFirst": "请先选择项目和模型",
      "selectModelFirst": "请先选择模型",
      "minCharsRequired": "至少需要 10 个字符",
      "selectProjectFirstPlaceholder": "请先选择一个项目",
      "loadingModels": "正在加载模型…",
      "noLlmForProject": "该项目未分配 LLM",
      "noLlmAvailable": "没有可用的 LLM",
      "nameAlreadyExists": "已存在同名的提示词",
      "promptNameLabel": "提示词名称 *",
      "promptNamePlaceholder": "例如：客户支持助手",
      "categoryLabel": "分类",
      "categoryPlaceholder": "例如：支持、销售",
      "targetModelLabel": "目标模型",
      "targetModelRequiredLabel": "目标模型 *",
      "selectModelPlaceholder": "选择模型...",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "简要描述此提示词的用途",
      "charCount": "{{count}}/{{max}} 字符",
      "modelLabel": "模型",
      "selectAiModelPlaceholder": "选择 AI 模型",
      "generating": "生成中…",
      "generate": "生成",
      "businessContextPlaceholder": "受众、语气、任务、限制条件 — 模型将据此为你起草提示词。生成至少需要 10 个字符。",
      "aiGenerateHint": "生成后，你将切换到手动模式以查看和编辑提示词，然后再创建。",
      "contentPlaceholderPrefix": "你是一个乐于助人的助手，会...\n\n在此处编写你的系统提示词。使用 ",
      "contentPlaceholderSuffix": " 引用将在运行时解析的状态变量。",
      "variableNamePlaceholder": "variable_name",
      "addVariable": "添加变量",
      "nameLabel": "名称 *",
      "fixValidationErrors": "保存前请修正校验错误",
      "saving": "保存中...",
      "saveChanges": "保存更改",
      "quotaExceeded": "提示词配额已超出",
      "fillRequiredFields": "请填写所有必填字段",
      "cloning": "克隆中..."
    },
    "modal": {
      "detailsHeader": "详情",
      "describePromptHeader": "描述你希望提示词完成的任务",
      "promptDetailsHeader": "提示词详情",
      "createTitle": "创建新提示词",
      "creationModeAriaLabel": "提示词创建模式",
      "modeManual": "手动",
      "modeAi": "AI",
      "editorSectionsAriaLabel": "提示词编辑器区域",
      "tabPrompt": "提示词",
      "tabState": "状态",
      "editorHintPrefix": "使用",
      "editorHintSuffix": "表示状态变量",
      "aiGeneratedNote": "AI 生成 — 如有需要请编辑。可使用优化功能进一步调整。",
      "loadingEditor": "正在加载提示词编辑器...",
      "stateVariablesHintPrefix": "定义要在提示词中与",
      "stateVariablesHintSuffix": "一起使用的状态变量。提示词中引用的每个变量都必须在此列出。",
      "noStateVariables": "尚未定义状态变量。",
      "stateVariableNameAriaLabel": "状态变量名称 {{name}}",
      "removeStateVariableAriaLabel": "移除状态变量 {{name}}",
      "newVariableFallback": "新建",
      "editTitle": "编辑提示词元数据",
      "deleteTitle": "删除提示词",
      "deleteMessage": "确定要删除“{{name}}”吗？此操作无法撤销。",
      "bulkDeleteTitle": "删除所选提示词",
      "bulkDeleteMessage": "确定要删除 {{count}} 个提示词吗？此操作无法撤销。",
      "bulkDeleteMessage_other": "确定要删除 {{count}} 个提示词吗？此操作无法撤销。",
      "bulkDeleteConfirm": "删除 {{count}} 个提示词",
      "bulkDeleteConfirm_other": "删除 {{count}} 个提示词",
      "cloneTitle": "为模型克隆",
      "cloneMessage": "将“{{name}}”的所有版本克隆到另一个模型。",
      "cloneSubmit": "克隆提示词"
    },
    "optimizeModal": {
      "header": {
        "title": "优化提示词",
        "subtitlePlaceholder": "选择一个提示词"
      },
      "stepper": {
        "configure": "配置",
        "running": "运行中",
        "result": "结果"
      },
      "framework": {
        "sectionTitle": "选择框架",
        "bestFor": "最适合：{{value}}",
        "catalog": {
          "dspy": {
            "label": "DSPy",
            "tier": "第一级",
            "desc": "声明式优化（MIPROv2、COPRO 或 bootstrap few-shot）。适合有标注示例的场景。",
            "tooltip": "将声明式程序编译为优化后的提示词。请在下方选择编译器类型（默认 MIPROv2）。",
            "bestFor": "分类、问答、抽取任务"
          },
          "cot": {
            "label": "思维链（Chain-of-Thought）",
            "tier": "第二级",
            "desc": "推理优化：逐步推理、推理轨迹质量、步骤分解。",
            "tooltip": "尝试多种 CoT 策略（例如“逐步思考”），优化推理轨迹质量和步骤分解。若需完整策略，请使用“思维链”提示词类型。",
            "bestFor": "推理、数学、多步骤任务"
          },
          "opro": {
            "label": "OPRO",
            "tier": "第二级",
            "desc": "以 LLM 作为优化器。输入（提示词，分数）历史并要求改进。",
            "tooltip": "使用 LLM 本身作为优化器——通过分析分数轨迹迭代提出更好的提示词。部署简单，无需梯度计算。",
            "bestFor": "任意任务的快速迭代"
          },
          "reflexion": {
            "label": "Reflexion",
            "tier": "第二级",
            "desc": "自我反思式语言强化学习。生成“批评 → 改写”循环。",
            "tooltip": "每次试验后生成自我批评，然后改写提示词以修复已识别的失败。结合反思与情景记忆实现持续改进。",
            "bestFor": "复杂推理、多步骤任务"
          },
          "gepa": {
            "label": "GEPA",
            "tier": "第三级",
            "desc": "上游 Genetic-Pareto 引擎，支持按样本进行帕累托选择与候选合并。",
            "tooltip": "运行参考 GEPA 引擎。为每个验证样本维护一个帕累托前沿，而非单一综合分数，因此仅对部分样本有帮助的提示词仍可存活并被组合。",
            "bestFor": "多节点智能体图、停滞的优化运行"
          },
          "gepa_legacy": {
            "label": "GEPA（旧版）",
            "tier": "第三级",
            "desc": "内部反思式进化方法，具备 LLM 驱动的失败诊断。",
            "tooltip": "之前内置的 GEPA 近似实现。在上游包不可用时作为回退保留，也用于 A/B 对比。",
            "bestFor": "没有 gepa 包的离线安装环境"
          },
          "optimize_anything": {
            "label": "optimize_anything",
            "tier": "第三级",
            "desc": "面向非提示词工件（智能体图、节点配置）的上游 GEPA 启动器。",
            "tooltip": "通过同一 Genetic-Pareto 引擎优化图 JSON 或节点配置参数。无效候选将以校验错误作为反馈得分为 0。持久化需经过显式的应用步骤。",
            "bestFor": "超越提示词的拓扑与配置搜索"
          },
          "evoprompt": {
            "label": "EvoPrompt",
            "tier": "第三级",
            "desc": "基于种群的进化方法，使用交叉与变异算子。",
            "tooltip": "维护一个提示词候选种群，并应用受遗传算法启发的交叉/变异算子。非常适合探索多样化的提示词表述。",
            "bestFor": "多样化提示词探索"
          },
          "ape": {
            "label": "APE",
            "tier": "第三级",
            "desc": "自动提示词工程师。生成 → 评分 → 重采样。",
            "tooltip": "从输入输出示例中生成大量候选指令，进行评分，然后围绕最佳结果重采样。指令发现速度快且有效。",
            "bestFor": "从示例中发现指令"
          },
          "textgrad": {
            "label": "TextGrad",
            "tier": "第四级",
            "desc": "文本反向传播。计算文本梯度以进行有针对性的修正。",
            "tooltip": "将文本“梯度”——自然语言反馈——沿提示词反向传播，精确定位需要编辑的部分。精确的外科式改进。",
            "bestFor": "长提示词的精确编辑"
          },
          "rl_tuning": {
            "label": "RL-PPO",
            "tier": "第五级",
            "desc": "使用自定义奖励函数的 PPO 风格策略优化。",
            "tooltip": "将提示词选择视为一个策略，并通过近端策略优化（PPO）进行优化。可定义自己的奖励函数，完全掌控优化目标。",
            "bestFor": "自定义奖励目标"
          },
          "rag_aware": {
            "label": "RAG 感知",
            "tier": "第六级",
            "desc": "提示词与检索流水线的联合协同优化。",
            "tooltip": "将提示词与检索配置共同优化。为 RAG 密集型工作流调整查询格式、上下文放置和指令措辞。",
            "bestFor": "检索增强生成"
          },
          "multi_obj": {
            "label": "多目标",
            "tier": "跨类别",
            "desc": "在准确率、延迟、成本之间进行帕累托前沿优化。",
            "tooltip": "在多个相互竞争的目标（准确率、延迟、token 成本）之间探索帕累托前沿。返回一组权衡最优的提示词，而非单一获胜者。",
            "bestFor": "平衡准确率与成本"
          },
          "ensemble": {
            "label": "集成（Ensemble）",
            "tier": "跨类别",
            "desc": "并行运行多个优化器，然后融合结果（锦标赛、合并或投票）。",
            "tooltip": "同时运行 2 个以上互补框架（例如 Reflexion + OPRO + TextGrad），然后组合其最佳候选结果。成本高于单一框架；当您需要稳健、多视角的提示词改进时最为适合。",
            "bestFor": "最大覆盖率与稳健性"
          }
        }
      },
      "promptVersion": {
        "sectionTitle": "提示词与版本",
        "projectLabel": "项目",
        "promptLabel": "提示词",
        "promptPlaceholder": "选择一个提示词...",
        "promptSearchPlaceholder": "按名称搜索...",
        "promptRequiredError": "必须选择提示词。",
        "versionLabel": "版本",
        "versionPlaceholder": "选择一个版本...",
        "versionRequiredError": "必须选择提示词版本。",
        "versionCurrentSuffix": "（当前）",
        "compilerTypeLabel": "编译器类型",
        "compilerTypeTitle": "运行哪种 DSPy teleprompter（MIPROv2 是默认的多路复用优化器）。",
        "compilerOptions": {
          "miprov2": "MIPROv2",
          "copro": "COPRO",
          "bootstrapFewShot": "Bootstrap Few-shot"
        },
        "promptTypeLabel": "提示词类型",
        "promptTypeTitle": "思维链优化器策略。",
        "promptTypeOptions": {
          "standard": "标准",
          "cot": "思维链",
          "fewShot": "Few-shot",
          "structuredOutput": "结构化输出（JSON/XML）"
        },
        "allProjectsLabel": "所有项目"
      },
      "model": {
        "sectionTitle": "模型配置",
        "responseModelLabel": "响应模型",
        "responseModelPlaceholder": "选择 LLM 模型...",
        "responseModelRequiredError": "需要响应模型（或启用多模型并选择 2 个以上目标）。",
        "judgeModelLabel": "评判模型",
        "judgeModelPlaceholder": "选择评判模型",
        "gepaMutationModelLabel": "GEPA 变异模型",
        "gepaMutationModelTitle": "用于 GEPA 反思和变异的 LLM（LiteLLM 模型 ID 或平台模型 UUID）。",
        "gepaMutationModelPlaceholder": "选择变异模型",
        "gepaMutationModelHint": "用于反思和变体生成；评估仍使用上方的评判/响应模型。",
        "multiModelLabel": "跨多个模型进行优化",
        "multiModelHint": "在 2 个以上模型上评估提示词并聚合（与模型无关的提示词）",
        "targetModelsLabel": "目标模型（选择 2 个以上）",
        "selectAtLeast2Hint": "请至少选择 2 个模型。",
        "modelsSelectedCount": "已选择 {{count}} 个模型。",
        "aggregationStrategyLabel": "聚合策略",
        "aggregationOptions": {
          "mean": "平均值 — 所有模型的平均",
          "min": "最小值 — 最差情况（不遗漏任何模型）",
          "pareto": "帕累托 — 在最小值与平均值之间平衡"
        },
        "aggregationHint": "最小值 = 针对最弱模型优化；平均值 = 取平均；帕累托 = 平衡两者。",
        "noModelsHint": "该项目未关联任何 LLM 模型。请在“项目 → 模型”中添加模型，否则优化可能会回退到后端默认值。",
        "selectPromptHint": "选择提示词以从该提示词所属项目加载响应模型和评判模型。"
      },
      "ensemble": {
        "sectionTitle": "集成配置",
        "subFrameworksLabel": "子框架（选择 2 个以上）",
        "subFrameworksHint": "每个选中的优化器都会并行运行；结果将按下方策略进行融合。",
        "fusionLabel": "融合策略",
        "fusionOptions": {
          "tournament": "锦标赛 — 在完整数据集上评估候选，选出最佳",
          "merge": "合并 — LLM 将顶尖候选综合为一个提示词",
          "voting": "投票 — 在测试集上对候选评分，加权组合"
        },
        "minTwoToast": "集成模式请至少选择两个子框架"
      },
      "metrics": {
        "sectionTitle": "评估指标",
        "autoDiscoverLabel": "从数据集和提示词自动发现指标（存在上下文时会推荐忠实度、相关性等指标）",
        "selectPromptHint": "选择提示词以加载其所属项目的指标目录。",
        "weightsTitle": "指标权重（可选 — 综合得分）",
        "weightsHint": "留空表示权重相等。权重会被归一化，使总和为 1。",
        "weightPlaceholder": "相等",
        "noMetricsWarning": "未选择任何指标——将默认使用 Answer Correctness。",
        "embeddingLabel": "嵌入模型（所选指标需要）",
        "embeddingPlaceholder": "选择嵌入模型…",
        "embeddingNoModelsHint": "该项目没有可用的嵌入模型。请在“项目 → 模型”中注册一个。",
        "sqlLabel": "执行数据库（Text2SQL EX/VES 所需）",
        "sqlPlaceholder": "选择数据库连接器…",
        "sqlNoConnectorsHint": "未注册任何数据库连接器。请在“Knowledge → Connectors”中添加一个。",
        "schemaLabel": "模式定义（JSON，模式合规性所需）",
        "schemaPlaceholder": "{\"tables\": [{\"name\": \"orders\", \"columns\": [\"id\", \"amount\"]}]}"
      },
      "dataset": {
        "sectionTitle": "基准数据集",
        "optionalGepaSuffix": "（GEPA 可选）",
        "selectPromptHint": "选择提示词以列出与该项目知识库关联的基准数据集。",
        "datasetPlaceholder": "选择已注册的表...",
        "datasetSearchPlaceholder": "按名称或表搜索数据集...",
        "datasetRowsSuffix": "（{{count}} 行）",
        "datasetRequiredError": "必须选择基准数据集。",
        "noDatasetsHint": "该项目没有映射的知识表。请在“项目 → 知识库”中映射表。",
        "inputColumnLabel": "输入列",
        "columnPlaceholder": "选择列...",
        "expectedOutputColumnLabel": "期望输出列",
        "expectedOutputRequiredError": "DSPy 需要期望输出列。",
        "contextColumnsLabel": "上下文列（可选）",
        "selectDatasetFirst": "请先选择数据集",
        "contextColumnsHint": "多个列会合并为评估上下文（RAGAS / DeepEval）。",
        "samplingStrategyLabel": "采样策略",
        "samplingOptions": {
          "random": "随机",
          "stratified": "分层（按期望输出）",
          "difficultyWeighted": "难度加权（聚焦困难样本）",
          "progressive": "渐进式（随优化收敛扩大子集）"
        },
        "samplingHint": "分层和难度加权可以在更少的行数下提升信号质量。"
      },
      "dspyContext": {
        "title": "DSPy 上下文集成",
        "modeLabel": "上下文传递模式",
        "modeOptions": {
          "auto": "自动 — 检测到时将上下文注入为 DSPy 输入",
          "injectField": "注入字段 — 始终将上下文添加为 DSPy 输入",
          "ragModule": "RAG 模块 — 在预测前从上下文语料库中检索"
        },
        "modeHints": {
          "auto": "即使提示词模板未引用上下文，也会自动将数据集中的上下文注入 DSPy 签名。",
          "injectField": "强制将上下文注入为 DSPy 输入字段。DSPy 会在编译期间学习如何使用上下文。",
          "ragModule": "构建一个由“检索 + 预测”组成的复合 DSPy 模块。MIPROv2 可以联合优化检索与预测。"
        },
        "demoStrategyLabel": "示例选择策略",
        "demoOptions": {
          "default": "默认 — 由 DSPy 编译器自行选择",
          "diverseContext": "多样化上下文 — 最大化示例间的上下文多样性",
          "maxCoverage": "最大覆盖 — 覆盖最广泛的上下文主题范围"
        },
        "demoHint": "多样化上下文和最大覆盖会选择上下文更丰富多样的示例，以提升 few-shot 质量。",
        "topKLabel": "检索 Top-K",
        "topKHint": "每次查询从黄金数据集中检索的上下文段落数量。",
        "truncateLabel": "截断过长的上下文",
        "truncateHint": "限制上下文段落长度以符合 token 预算",
        "maxTokensLabel": "最大上下文 token 数",
        "maxTokensHint": "每个段落的近似按词截断。"
      },
      "advanced": {
        "sectionTitle": "高级选项",
        "warmStartLabel": "元学习热启动",
        "warmStartHint": "从相似的历史运行中初始化",
        "adversarialLabel": "对抗鲁棒性测试",
        "adversarialHint": "在受扰动的输入上进行测试；与干净得分结合",
        "adversarialWeightLabel": "对抗权重（0–1）",
        "adversarialWeightHint": "robust_score = (1 − α)×干净得分 + α×对抗得分；α 越高，对抗部分权重越大。",
        "requireApprovalLabel": "保存前需要审批",
        "requireApprovalHint": "在优化后的提示词成为新版本之前进行审核",
        "driftGuardLabel": "语义漂移防护",
        "driftGuardHint": "拒绝偏离原始意图过多的候选",
        "maxDriftLabel": "最大漂移（0–1）",
        "maxDriftHint": "漂移超过此值的候选将被拒绝。数值越低越严格（例如 0.3）。",
        "driftMethodLabel": "漂移检测方法",
        "driftMethodOptions": {
          "jaccard": "Jaccard（基于 token）",
          "vector": "向量（嵌入余弦相似度）"
        },
        "driftMethodHint": "向量漂移使用下方的嵌入模型；Jaccard 仅基于词汇。",
        "embeddingModelLabel": "嵌入模型",
        "embeddingLoading": "正在加载模型…",
        "embeddingNoModelsHint": "该项目没有可用的嵌入模型。请使用 Jaccard 漂移检测，或在 Foundation Models 中注册模型。",
        "embeddingPlaceholder": "选择嵌入模型",
        "embeddingRequiredHint": "当漂移方法为“向量”时必需（以 drift_embedding_model_id 存储）。",
        "guardrailsLabel": "内容安全护栏",
        "guardrailsHint": "拒绝未通过毒性、个人信息、提示词注入或品牌安全检查的候选",
        "guardrailBackendLabel": "护栏后端",
        "guardrailBackendOptions": {
          "builtin": "内置（基于规则）",
          "azureContentSafety": "Azure Content Safety",
          "awsBedrock": "AWS Bedrock Guardrails",
          "custom": "自定义（HTTP 端点）"
        },
        "guardrailBackendHint": "内置后端无需外部 API 即可运行个人信息、毒性、越狱及可选的品牌安全检查。",
        "checksLabel": "要运行的检查项",
        "checksHint": "未通过所选检查的候选将在评估前被拒绝。",
        "checkLabels": {
          "piiCheck": "个人信息",
          "toxicity": "毒性",
          "promptInjection": "提示词注入",
          "jailbreak": "越狱",
          "brandSafety": "品牌安全",
          "lengthCheck": "长度检查"
        }
      },
      "parameters": {
        "sectionTitle": "参数",
        "maxIterationsLabel": "最大迭代次数",
        "maxIterationsEnsembleLabel": "最大迭代次数（每个子框架）",
        "maxIterationsHint": "数值越高，优化越精细，运行时间也越长",
        "maxIterationsEnsembleHint": "每个并行优化器最多运行此迭代次数（集成模式使用 sub_max_iterations）。",
        "timeBudgetLabel": "时间预算（秒）",
        "timeBudgetHint": "实际运行时间的硬性上限（60–14,400 秒）。达到预算后运行将停止。",
        "maxCostLabel": "最大成本（美元，可选）",
        "maxCostPlaceholder": "无限制",
        "maxCostHint": "预估支出上限；超过后会话将中止。留空表示无上限。",
        "targetScoreLabel": "目标得分（可选）",
        "targetScorePlaceholder": "无",
        "targetScoreHint": "当综合得分达到该值（0–1）时提前停止。留空则运行到达到迭代次数或其他限制为止。",
        "candidateCountHint": "该优化器每次迭代生成或评估的候选提示词数量。",
        "evalMaxRowsLabel": "评估数据集最大行数",
        "evalMaxRowsHint": "每次评估从基准数据集中获取的行数（基线使用完整上限；内部循环可能使用更少）。",
        "rowsPerIterationLabel": "每个候选评估的行数（可选）",
        "rowsPerIterationPlaceholder": "自动",
        "rowsPerIterationHint": "限制评估每个候选提示词时使用的行数；留空则自动（约为最大行数的一半，最少 5 行）。",
        "earlyStoppingLabel": "提前停止",
        "patienceHint": "耐心值（无改进的轮数）",
        "candidateLabels": {
          "gepa": "每次迭代的变体数",
          "ape": "每轮候选数",
          "opro": "每次迭代的提议数",
          "evoprompt": "种群规模",
          "rl_tuning": "每次迭代的展开数"
        }
      },
      "reward": {
        "sectionTitle": "奖励函数（Python）",
        "description": "定义您的自定义奖励函数。它接收每一行评估数据，并返回一个位于 [-1, 1] 区间的奖励信号。策略将最大化该奖励。"
      },
      "estimate": {
        "title": "预估资源",
        "summary": "约 {{calls}} 次 LLM 调用 · 约 ${{low}}–${{high}} 美元",
        "monthlyUsed": "本月已用：${{used}} / ${{limit}}",
        "acknowledge": "我确认预估成本（最高 ${{cost}} 美元），并希望启动此次运行"
      },
      "start": {
        "button": "开始 {{framework}} 优化",
        "confirmButton": "确认并开始",
        "changeParams": "更改参数"
      },
      "toast": {
        "selectPrompt": "请选择一个提示词",
        "selectVersion": "请选择一个提示词版本",
        "selectDataset": "请选择一个基准数据集",
        "selectResponseModel": "请选择响应模型，或启用多模型并至少选择 2 个模型",
        "multiModelMin2": "多模型优化至少需要 2 个目标模型",
        "dspyExpectedOutput": "使用 DSPy 时请选择期望输出列",
        "vectorDriftEmbedding": "向量漂移检测需要嵌入模型，或将漂移方法设置为 Jaccard。",
        "embeddingForMetrics": "请为所选指标选择一个嵌入模型。",
        "sqlForMetrics": "请为所选 Text2SQL 指标选择一个执行数据库。",
        "schemaForMetrics": "请为模式合规性指标提供有效的 JSON 模式定义。",
        "ensembleMin2": "集成模式至少需要两个子框架",
        "unsupportedSubframework": "不受支持的子框架：{{list}}",
        "maxCostInvalid": "最大成本（美元）必须是非负数",
        "targetScoreInvalid": "目标得分必须介于 0 和 1 之间",
        "llmCapExceeded": "预估 LLM 调用次数（{{calls}}）超过每次会话的限制（{{cap}}）。请减少迭代次数或种群规模。",
        "cancelRequested": "已请求取消优化运行",
        "cancelFailed": "取消优化运行失败"
      },
      "running": {
        "title": "正在优化“{{name}}”",
        "engineLabel": "引擎：",
        "jobLabel": "任务：",
        "progressLabel": "进度",
        "statusLabel": "状态：",
        "statusStarting": "启动中",
        "iterationSuffix": " · 迭代 {{current}}/{{max}}",
        "initializing": "正在初始化 {{engine}} 引擎...",
        "loadingDataset": "正在加载基准数据集",
        "completedIterations": "已完成 {{current}}/{{max}} 次迭代",
        "errorPrefix": "错误：{{message}}",
        "cancelButton": "取消运行"
      },
      "result": {
        "awaitingApproval": "等待审批",
        "complete": "优化完成",
        "cancelled": "优化已取消",
        "failed": "优化失败",
        "approvalHint": "优化后的提示词在保存为新版本之前需要人工审批。请在运行详情页面进行审核并批准。",
        "baseline": "基线",
        "optimized": "已优化",
        "iterationsSuffix": "迭代次数：{{count}}",
        "evaluationsSuffix": " · 评估次数：{{count}}",
        "reviewApprove": "审核并批准",
        "viewRunDetails": "查看运行详情",
        "viewOptimizedVersion": "查看优化后的版本"
      }
    },
    "runDetail": {
      "pageTitle": "提示词优化",
      "backToRuns": "返回运行列表",
      "backToOptimizationRuns": "返回优化运行列表",
      "notFound": "未找到优化运行",
      "loading": "正在加载优化详情...",
      "status": {
        "completed": "已完成",
        "failed": "失败",
        "cancelled": "已取消",
        "running": "运行中",
        "queued": "排队中",
        "pending_approval": "待审批"
      },
      "approvalBadge": {
        "pending": "待审批",
        "approved": "已批准",
        "rejected": "已拒绝"
      },
      "viewOptimizedPrompt": "查看优化后的提示词",
      "errorBanner": {
        "title": "优化失败"
      },
      "createdAt": "创建于 {{date}}",
      "approval": {
        "reviewTitle": "审核优化后的提示词",
        "reviewSubtitle": "此优化在将优化后的提示词保存为新版本之前需要审批。",
        "reasonPlaceholder": "批准/拒绝的原因（可选）...",
        "reject": "拒绝",
        "approve": "批准并保存为新版本",
        "approvedMessage": "提示词已批准并保存为新版本。",
        "rejectedMessage": "提示词已被拒绝。未创建新版本。",
        "promptApprovedTitle": "提示词已批准",
        "promptRejectedTitle": "提示词已拒绝",
        "approvedSubtitle": "此优化后的提示词已被批准并保存为新版本。",
        "rejectedSubtitle": "此优化后的提示词已被拒绝。未创建新版本。"
      },
      "diff": {
        "originalPrompt": "原始提示词",
        "optimizedPrompt": "优化后的提示词"
      },
      "tabs": {
        "overview": "概览",
        "insights": "洞察",
        "rowMetrics": "行指标",
        "candidates": "候选项",
        "trace": "跟踪记录",
        "abTest": "A/B 测试",
        "configuration": "配置"
      },
      "configView": {
        "formatted": "格式化",
        "raw": "原始",
        "copy": "复制",
        "copied": "已复制"
      },
      "metrics": {
        "baselineScore": "基线分数",
        "optimizedScore": "优化后分数",
        "improvement": "提升幅度",
        "holdoutScore": "留出集分数",
        "holdoutSubValue": "留出集上的真实分数",
        "iterations": "迭代次数",
        "iterationsSubValue": "共 {{max}} 次",
        "evaluations": "评估次数",
        "duration": "耗时",
        "totalTokens": "总令牌数",
        "tokensSubValue": "提示词 {{prompt}} / 补全 {{completion}}",
        "estimatedCost": "预估成本",
        "estimatedCostSubValue": "LLM 消耗"
      },
      "orchestrator": {
        "label": "编排器",
        "openRun": "打开工作流运行"
      },
      "earlyStopping": {
        "label": "提前停止",
        "completedOf": "已完成 {{max}} 次已配置迭代中的 {{completed}} 次。"
      },
      "perModelScores": {
        "title": "各模型分数（与模型无关的运行）",
        "desc": "上方的汇总分数由这些各模型分数得出。该提示词已在每个基础模型上进行了评估。"
      },
      "coproDescription": "COPRO：您的<strong>最大迭代次数</strong>设置即为优化深度（{{depth}}）。每个深度会评估多个建议的提示词（宽度 {{breadth}}），因此分数图列出了{{candidatesTracked}}——而不仅仅是每个深度步骤一个点。",
      "coproScoredCandidates": "{{count}} 个已评分候选项",
      "coproOneRowPerCandidate": "每个已评分候选项一行",
      "miproDescription": "MIPROv2：<strong>最大迭代次数</strong>（{{trials}}）是贝叶斯优化试验的次数。图表和候选项列表显示的是在<strong>完整</strong>验证集上评估的提示词（省略仅小批量的探测），因此行数（{{rows}}）可能与试验次数不同——尤其是在启用小批量处理时。",
      "scoreChartTitle": "分数变化趋势",
      "scoreChartXAxis": "迭代",
      "scoreChartYAxis": "聚合分数",
      "scoreChartYAxisAggregated": "聚合分数（{{strategy}}）",
      "scoreChartAggregation": {
        "mean": "平均值",
        "min": "最小值",
        "pareto": "帕累托"
      },
      "chartTooltip": "迭代 {{iteration}}：{{score}}",
      "chartTooltipBestSuffix": "（最佳）",
      "insights": {
        "title": "优化器洞察",
        "foundationModel": "基础模型",
        "judgeModel": "评判模型",
        "evalMetrics": "评估指标",
        "mutationModel": "变异模型",
        "targetScore": "目标分数",
        "timeBudget": "时间预算",
        "defaultModel": "默认（服务器默认值）"
      },
      "componentsTitle": "优化后的组件",
      "rowEvaluations": {
        "title": "逐行评估",
        "sourceLabel": "来源：",
        "source": {
          "optimization_trace": "优化器跟踪记录中最佳基准测试结果",
          "final_eval": "运行后对数据集上优化后提示词的评估",
          "none": "此运行未评估任何数据集行",
          "failed": "无法捕获行快照"
        },
        "metricsConfigured": "已配置指标：{{metrics}}。",
        "emptyFailed": "优化器已完成，但保存逐行分数失败。请检查服务器日志。",
        "emptyNoDataset": "此运行未生成逐行分数（无数据集或无评估行）。",
        "emptyDefault": "此会话未返回任何逐行数据。",
        "columns": {
          "index": "#",
          "input": "输入 / 问题",
          "generatedAnswer": "生成的答案",
          "metrics": "指标",
          "score": "分数",
          "reasoning": "推理"
        },
        "expectedOutput": "预期输出"
      },
      "candidates": {
        "title": "候选提示词（{{count}}）",
        "iteration": "迭代 {{iteration}}",
        "candidateLabel": "候选项 {{index}}",
        "best": "最佳",
        "driftRejected": "漂移已拒绝",
        "guardrails": "护栏",
        "rejectionReason": "拒绝原因："
      },
      "trace": {
        "title": "优化跟踪记录（{{count}} 条）",
        "iter": "迭代 {{iteration}}"
      },
      "abTest": {
        "dailyTrafficLabel": "预期每日流量（可选）：",
        "dailyTrafficPlaceholder": "例如 10000",
        "generateButton": "生成 A/B 测试",
        "generating": "生成中…",
        "variantsLabel": "变体",
        "sampleSizeLabel": "每个变体的样本量",
        "sampleSizeValue": "{{perVariant}}（共 {{total}}）",
        "improvementCiLabel": "提升幅度（置信区间）",
        "recommendedDurationLabel": "建议持续时间",
        "durationDays": "约 {{days}} 天",
        "durationHours": "约 {{hours}} 小时",
        "variantPromptsSummary": "变体提示词",
        "controlLabel": "对照组 (A)",
        "treatmentLabel": "实验组 (B)"
      },
      "metadataLabels": {
        "meta_model": "元模型",
        "reflection_model": "反思模型",
        "stale_rounds": "停滞轮数",
        "population_size": "种群规模",
        "gradient_model": "梯度模型",
        "mutation_model": "变异模型",
        "gen_model": "生成模型",
        "policy_model": "策略模型",
        "optimizer_model": "优化器模型",
        "compiler": "DSPy 编译器",
        "dspy_version": "DSPy 版本",
        "dspy_copro": "COPRO（深度 / 宽度）",
        "final_avg_reward": "最终平均奖励",
        "baseline_reward": "基线奖励",
        "reward_function": "奖励函数",
        "objectives": "目标",
        "pareto_size": "帕累托前沿规模",
        "early_stopping_reason": "提前停止",
        "ensemble_frameworks": "集成子框架",
        "fusion_strategy": "融合策略"
      },
      "frameworkTier": {
        "dspy": "声明式程序优化",
        "opro": "元提示 / LLM 作为优化器",
        "reflexion": "自我反思式优化",
        "gepa": "反思式进化搜索",
        "evoprompt": "进化 + LLM 搜索",
        "ape": "自动提示工程",
        "textgrad": "文本反向传播",
        "rl_tuning": "基于强化学习的策略优化",
        "rag_aware": "检索增强联合优化",
        "multi_obj": "多目标帕累托优化",
        "ensemble": "多框架融合",
        "cot": "推理结构化提示"
      }
    },
    "comparison": {
      "backAriaLabel": "返回",
      "title": "比较优化运行",
      "subtitle": "选择一个提示词，然后选择 2 个或更多已完成的运行以比较轨迹、框架和优化输出",
      "promptFieldLabel": "提示词",
      "promptPlaceholder": "选择提示词...",
      "runsFieldLabel": "优化运行",
      "runsFilterLabel": "优化运行",
      "selectPromptFirst": "请先选择提示词",
      "loadingRuns": "加载中…",
      "noCompletedRuns": "没有已完成的运行",
      "clearSelection": "清除选择",
      "compareButton": "比较（已选 {{count}} 项）",
      "selectAtLeastTwo": "请至少选择 2 个运行进行比较。",
      "genericCompareError": "比较会话失败",
      "scoreTrajectoriesTitle": "分数变化轨迹",
      "yAxisScore": "分数",
      "xAxisIteration": "迭代",
      "summaryTitle": "摘要",
      "exportCsvTitle": "导出 CSV",
      "columns": {
        "framework": "框架",
        "original": "原始",
        "optimized": "优化后",
        "improvement": "提升幅度",
        "holdout": "留出集",
        "duration": "耗时",
        "iterations": "迭代次数",
        "actions": "操作"
      },
      "view": "查看",
      "promptComparisonTitle": "提示词比较",
      "selectPromptVersion": "选择提示词版本...",
      "originalPromptLabel": "原始",
      "optimizedPromptLabel": "优化后",
      "originalPromptOption": "原始提示词",
      "noPromptContent": "（无可用的提示词内容）",
      "csv": {
        "sessionId": "会话 ID",
        "framework": "框架",
        "originalScore": "原始分数",
        "optimizedScore": "优化后分数",
        "improvementPct": "提升幅度 %",
        "holdoutScore": "留出集分数",
        "duration": "耗时",
        "iterations": "迭代次数",
        "evaluations": "评估次数"
      }
    },
    "editPage": {
      "backAriaLabel": "返回提示词列表",
      "backToPrompts": "返回提示词列表",
      "platformTooltip": "代码内置的系统提示词 — 只读",
      "platformBadge": "平台",
      "versionsCount": "{{count}} 个版本",
      "targetModelTooltip": "目标模型",
      "allModels": "所有模型",
      "changeModelTooltip": "更改模型或克隆",
      "changeModelHeader": "更改模型",
      "modelAgnostic": "与模型无关（所有模型）",
      "autoSavingAriaLabel": "正在自动保存描述",
      "autoSaving": "自动保存中...",
      "autoSaveTooltip": "仅描述会自动保存。提示词内容更改需要手动提交。",
      "loadingPrompt": "正在加载提示词...",
      "notFound": "未找到提示词",
      "contentPlaceholder": "输入提示词内容...使用 {{syntax}} 引用状态变量。",
      "comingSoon": "即将推出...",
      "targetModelLabel": "目标模型 *",
      "selectModelPlaceholder": "选择模型...",
      "cloning": "克隆中...",
      "tabs": {
        "text": "提示词文本",
        "diffs": "提示词差异",
        "testing": "提示词测试",
        "evals": "提示词评估",
        "metrics": "指标"
      },
      "testing": {
        "title": "提示词测试",
        "description": "使用不同的输入和模型测试您的提示词"
      },
      "evals": {
        "title": "提示词评估",
        "description": "评估提示词的性能和质量指标"
      },
      "metrics": {
        "title": "优化指标",
        "description": "此版本是通过 AI 优化创建的",
        "descriptionWithFramework": "此版本是通过 AI 优化（{{framework}}）创建的",
        "baselineScore": "基线分数",
        "optimizedScore": "优化后分数",
        "improvement": "提升幅度",
        "iterations": "迭代次数",
        "evaluations": "评估次数",
        "duration": "耗时",
        "viewAllRuns": "查看所有优化运行"
      },
      "toast": {
        "retagged": "已重新标记为 \"{{modelId}}\"",
        "setModelAgnostic": "已设置为与模型无关",
        "cloned": "已为 \"{{modelId}}\" 克隆提示词",
        "forkedSuccess": "版本分支创建成功",
        "noChangesToCommit": "没有可提交的更改",
        "enterCommitMessage": "请输入提交信息",
        "platformReadOnlyFork": "平台提示词为只读，无法分支",
        "platformReadOnlyModify": "平台提示词为只读，无法修改"
      }
    },
    "playground": {
      "loadingPlayground": "正在加载练习场...",
      "unableToLoad": "无法加载提示词，请重试。",
      "unableToLoadSessions": "无法加载聊天会话。",
      "headerTitle": "{{name}} — 练习场",
      "versionOption": "v{{version}}",
      "versionOptionCurrent": "v{{version}}（当前）",
      "selectModelOption": "选择模型...",
      "loadingSession": "正在加载会话...",
      "noModelSelected": "未选择模型",
      "typeMessage": "输入消息...",
      "emptyStateTitleFallback": "练习场",
      "emptyStateMessage": "开始测试您的提示词",
      "noResponseGenerated": "（未生成响应）",
      "toast": {
        "noModelsAvailable": "没有可用的模型",
        "promptNotLoaded": "提示词未加载",
        "noModelsAvailableAddOne": "没有可用的模型，请先添加一个模型。",
        "switchedModel": "已切换到 {{name}}",
        "stopBeforeSending": "请先停止当前响应，再发送新消息",
        "uploadAttachmentsFailed": "附件上传失败",
        "messageNotFoundForRetry": "未找到要重试的消息",
        "noUserMessageToRegenerate": "未找到可重新生成的用户消息",
        "cannotRegenerateEmptyContent": "无法重新生成：用户消息没有内容",
        "cannotRetryMessageType": "无法重试此类型的消息",
        "addAttachmentFailed": "添加附件失败：{{name}}"
      }
    },
    "runsPage": {
      "title": "提示词优化",
      "subtitle": "所有提示词优化运行的历史记录",
      "backToPrompts": "返回提示词",
      "compareRuns": "比较运行",
      "newOptimization": "新建优化",
      "loadingMessage": "正在加载优化运行...",
      "emptyMessage": "尚无优化运行。点击“新建优化”开始。",
      "status": {
        "queued": "排队中",
        "running": "运行中",
        "completed": "已完成",
        "failed": "失败",
        "cancelled": "已取消"
      },
      "columns": {
        "promptName": "提示词名称",
        "framework": "框架",
        "status": "状态",
        "metrics": "指标",
        "improvementPct": "改进百分比",
        "cost": "费用",
        "tokens": "令牌数",
        "createdBy": "创建者",
        "createdAt": "创建时间",
        "updatedAt": "更新时间",
        "actions": "操作"
      },
      "tokensTooltip": "提示词: {{prompt}} | 补全: {{completion}}",
      "actions": {
        "retry": "重试",
        "delete": "删除"
      },
      "retryConfirm": "是否为“{{label}}”使用与此次运行相同的框架和选项启动新的优化?",
      "retryDefaultLabel": "此提示词",
      "deleteConfirm": "删除“{{label}}”的优化会话?此操作无法撤销。",
      "deleteDefaultLabel": "此会话",
      "toast": {
        "newRunStarted": "已启动新的优化运行。",
        "retryFailed": "重试优化失败。",
        "sessionDeleted": "优化会话已删除。",
        "deleteSessionFailed": "删除会话失败。",
        "bulkDeleteWarning": "已删除 {{deleted}} 个运行；{{skipped}} 个无法删除。{{detail}}",
        "bulkDeleteSuccess_other": "已删除 {{count}} 个优化运行。",
        "bulkDeleteFailed": "删除所选优化运行失败。"
      },
      "bulkDelete": {
        "selectedLabel": "删除所选",
        "title": "删除所选运行",
        "message_other": "确定要删除 {{count}} 个优化运行吗?此操作无法撤销。",
        "confirmLabel_other": "删除 {{count}} 个运行"
      }
    },
    "optimizationLogModal": {
      "title": {
        "complete": "优化完成",
        "cancelled": "优化已取消",
        "failed": "优化失败",
        "running": "正在优化..."
      },
      "subtitleDefault": "提示词",
      "closeAriaLabel": "关闭",
      "progressLabel": "进度",
      "statusLabel": "状态:",
      "statusStarting": "启动中",
      "iterationSuffix": " · 迭代 {{iteration}}/{{max}}",
      "bestSuffix": " · 最佳: {{value}}",
      "runIdLabel": "运行ID:",
      "jobIdLabel": "任务ID:",
      "initializingEngine": "正在初始化 {{framework}} 引擎...",
      "loadingDataset": "正在加载基准数据集",
      "completedIterations": "已完成 {{completed}}/{{max}} 次迭代",
      "cancelRun": "取消运行",
      "viewResults": "查看结果"
    },
    "commitMessageModal": {
      "title": "提交版本",
      "closeAriaLabel": "关闭",
      "description": "输入提交信息以描述此版本中的更改。",
      "placeholder": "例如：修正提示词中的拼写错误、添加新示例...",
      "commit": "提交",
      "committing": "正在提交..."
    },
    "diffView": {
      "noVersionsTitle": "没有可比较的版本",
      "noVersionsDesc": "创建更多版本以查看它们之间的差异。",
      "baseLabel": "基准:",
      "compareLabel": "比较:",
      "swapTooltip": "交换基准和比较版本",
      "fileLabel": "prompt.txt",
      "collapseContextTooltip": "收起上下文",
      "expandContextTooltip": "展开上下文",
      "copyDiffTooltip": "复制差异",
      "loadingDiff": "正在加载差异...",
      "expandHiddenLines": "展开 {{count}} 行隐藏内容",
      "sameVersionTitle": "选择了相同的版本",
      "sameVersionDesc": "请选择不同的版本以查看差异。",
      "noDifferencesTitle": "没有差异",
      "noDifferencesDesc": "这些版本完全相同。",
      "toast": {
        "copied": "差异已复制到剪贴板"
      }
    },
    "versionList": {
      "title": "版本",
      "refreshTooltip": "刷新版本",
      "searchPlaceholder": "搜索版本...",
      "emptyMessage": "未找到版本"
    },
    "versionItem": {
      "commitTooltip": "提交版本",
      "commitLabel": "提交",
      "forkTooltip": "复刻版本 {{version}}",
      "forkLabel": "复刻",
      "createdByPrefix": "由 {{name}}",
      "wordCount_other": "{{count}} 个字"
    },
    "visibilitySelector": {
      "label": "可见性",
      "platformDescription": "在平台内的所有项目中可用",
      "projectDescription": "仅在所选项目中可用",
      "platformHint": "此提示词将在平台内的所有项目中可用。",
      "projectHint": "此提示词将仅在所选项目中可用。",
      "projectLabel": "项目",
      "selectProjectPlaceholder": "选择项目",
      "searchProjectsPlaceholder": "搜索项目..."
    }
  },
  "data": {
    "tabs": {
      "knowledge": "知识库",
      "graph": "图谱",
      "vector": "向量数据库",
      "storage": "存储"
    }
  },
  "knowledge": {
    "connections": {
      "tabs": {
        "databases": "数据库",
        "storage": "存储账户",
        "orchestrators": "编排器",
        "telephony": "电话",
        "service_connections": "服务连接"
      }
    },
    "serviceConnectionModal": {
      "titleCreate": "添加服务连接",
      "titleEdit": "编辑服务连接",
      "titleView": "查看服务连接",
      "loadingTypes": "正在加载服务类型…",
      "loadingQuota": "正在检查配额…",
      "groups": {
        "microsoft": "Microsoft",
        "developer_tools": "开发工具",
        "google": "Google",
        "business_apps": "业务应用",
        "messaging_and_events": "消息与事件",
        "http_and_webhooks": "HTTP 与 Webhook",
        "ai_search": "AI 搜索",
        "observability": "可观测性",
        "other": "其他"
      },
      "fields": {
        "name": "名称",
        "description": "描述",
        "iam": "IAM 条目",
        "iamPlaceholder": "选择 IAM 条目",
        "host": "已解析主机",
        "advanced": "高级（可选）"
      },
      "hints": {
        "iamEmpty": "没有与 {{subtypes}} 匹配的有效 IAM 条目。请在 IAM 中创建。",
        "iamLink": "打开 IAM",
        "inbound": "入站服务连接不使用 IAM 条目。",
        "testRequired": "保存前请先测试连接。",
        "secretsOnIam": "密钥保存在 IAM 条目中，不会存储在这里。",
        "missing": "必填：{{fields}}"
      },
      "buttons": {
        "back": "返回",
        "close": "关闭",
        "cancel": "取消",
        "create": "创建",
        "save": "保存"
      },
      "toasts": {
        "created": "已创建服务连接",
        "updated": "已更新服务连接"
      },
      "errors": {
        "testFailed": "连接测试失败",
        "selectTenant": "请选择租户",
        "selectProject": "请选择项目",
        "saveFailed": "无法保存服务连接"
      }
    },
    "connectorsTab": {
      "testErrorToast": "连接测试失败",
      "batchTestSuccessToast_one": "已导入的 {{count}} 个连接测试成功",
      "batchTestSuccessToast_other": "已导入的 {{count}} 个连接测试成功",
      "batchTestFailedToast_one": "已导入的 {{count}} 个连接测试失败",
      "batchTestFailedToast_other": "已导入的 {{count}} 个连接测试失败",
      "batchTestFinishedToast": "连接测试已完成：成功 {{success}} 个，失败 {{fail}} 个",
      "loadErrorToast": "加载连接器失败",
      "loadingMessage": "正在加载连接...",
      "filterResourceLabel": {
        "database": "数据库引擎",
        "storage": "存储类型",
        "orchestrator": "编排器类型",
        "telephony": "电话类型",
        "service": "服务类型"
      },
      "filterAllTypesPlaceholder": "所有类型",
      "filterCreatorLabel": "创建者",
      "filterAllCreatorsPlaceholder": "所有创建者",
      "filterStatusLabel": "状态",
      "filterAllStatusesPlaceholder": "所有状态",
      "filterStatusError": "错误",
      "deletePermissionDeniedToast": "您无权删除此连接器",
      "deleteErrorToast": "删除连接器失败",
      "bulkDeletePermissionDeniedToast": "您无权删除连接器",
      "bulkDeletePartialWarning": "已删除 {{deleted}} 个连接器，{{skipped}} 个失败：{{errors}}",
      "bulkDeleteSuccessToast_one": "已成功删除 {{count}} 个连接器",
      "bulkDeleteSuccessToast_other": "已成功删除 {{count}} 个连接器",
      "bulkDeleteErrorToast": "删除连接器失败",
      "unsetDefaultToast": "{{name}} 不再是默认{{category}}",
      "setDefaultToast": "{{name}} 现在是默认{{category}}",
      "unsetDefaultErrorToast": "取消默认{{category}}失败",
      "setDefaultErrorToast": "设置默认{{category}}失败",
      "status": {
        "active": "活跃",
        "failed": "失败",
        "notTested": "未测试",
        "unknown": "未知"
      },
      "statusTooltip": "状态：{{status}}",
      "authModeTooltip": "认证：{{mode}}",
      "columnName": "名称",
      "columnCloud": "云",
      "columnResource": "资源",
      "columnType": "类型",
      "columnHost": "主机",
      "columnStatus": "状态",
      "columnLastTested": "上次测试",
      "columnCreatedBy": "创建者",
      "columnUpdatedBy": "更新者",
      "columnActions": "操作",
      "actionView": "查看",
      "actionTestConnection": "测试连接",
      "actionRemoveAsDefault": "取消默认{{category}}",
      "actionSetAsDefault": "设为默认",
      "actionExport": "导出",
      "actionEdit": "编辑",
      "actionDelete": "删除",
      "entityFilterAllLabel": "全部",
      "entityFilterFavoritesLabel": "收藏",
      "bulkExportSelected": "导出所选",
      "bulkDeleteSelected": "删除所选",
      "emptyMessage": "未找到连接器。请添加连接以连接到数据库、存储或其他数据源。",
      "addConnection": "添加连接",
      "deleteDialogTitle": "删除连接器",
      "deleteDialogMessage": "确定要删除“{{name}}”吗？这也会删除此连接器中所有已注册的表。",
      "deleteDialogConfirmLabel": "删除",
      "bulkDeleteDialogTitle": "删除所选连接器",
      "bulkDeleteDialogMessage_one": "确定要删除 {{count}} 个连接器吗？这也会删除这些连接器中所有已注册的表。此操作无法撤销。",
      "bulkDeleteDialogMessage_other": "确定要删除 {{count}} 个连接器吗？这也会删除这些连接器中所有已注册的表。此操作无法撤销。",
      "bulkDeleteDialogConfirmLabel_one": "删除 {{count}} 个连接器",
      "bulkDeleteDialogConfirmLabel_other": "删除 {{count}} 个连接器"
    },
    "tab": {
      "unknownConnectorType": "未知",
      "filterEngineLabel": "数据库引擎",
      "filterAllEnginesPlaceholder": "所有引擎",
      "filterCreatorLabel": "创建者",
      "filterAllCreatorsPlaceholder": "所有创建者",
      "deleteErrorToast": "删除知识表失败",
      "bulkDeletePartialWarning": "已删除 {{deleted}} 个表，{{skipped}} 个失败：{{errors}}",
      "bulkDeleteSuccessToast_one": "已成功删除 {{count}} 个表",
      "bulkDeleteSuccessToast_other": "已成功删除 {{count}} 个表",
      "bulkDeleteErrorToast": "删除表失败",
      "deleteSchemaErrorToast": "删除架构失败",
      "deleteSchemaPartialWarning": "已跨 {{schemaCount}} 个架构删除 {{deleted}} 个表；{{skipped}} 个失败",
      "deleteSchemaSuccessToast_one": "已删除架构（{{count}} 个表）",
      "deleteSchemaSuccessToast_other": "已删除架构（{{count}} 个表）",
      "deleteSchemaSuccessToastNamed_one": "已删除架构“{{schema}}”（{{count}} 个表）",
      "deleteSchemaSuccessToastNamed_other": "已删除架构“{{schema}}”（{{count}} 个表）",
      "deleteSchemasSuccessToast_one": "已删除 {{schemaCount}} 个架构（{{count}} 个表）",
      "deleteSchemasSuccessToast_other": "已删除 {{schemaCount}} 个架构（{{count}} 个表）",
      "syncRequeuedToast": "已为“{{name}}”重新排队元数据同步（之前卡住）",
      "syncQueuedToast": "已为“{{name}}”排队元数据同步",
      "syncQueueErrorToast": "为“{{name}}”排队元数据同步失败",
      "bulkSyncStartedRequeuedToast_one": "已为 {{count}} 个表启动元数据同步（已重新排队任何卡住的内省）",
      "bulkSyncStartedRequeuedToast_other": "已为 {{count}} 个表启动元数据同步（已重新排队任何卡住的内省）",
      "bulkSyncStartedToast_one": "已为 {{count}} 个表启动元数据同步",
      "bulkSyncStartedToast_other": "已为 {{count}} 个表启动元数据同步",
      "bulkSyncStartErrorToast": "启动批量元数据同步失败",
      "columnName": "名称",
      "defaultBadgeTooltip": "默认",
      "schemaTooltip": "架构：{{schema}}",
      "columnDatabase": "数据库",
      "columnType": "类型",
      "columnRows": "行数",
      "columnIntrospection": "内省",
      "syncStatus": {
        "queued": "排队中",
        "running": "运行中",
        "synced": "已同步",
        "failed": "失败",
        "active": "活跃"
      },
      "viewSyncLogsTooltip": "查看同步日志",
      "columnStatus": "状态",
      "columnCreated": "创建时间",
      "columnUpdated": "更新时间",
      "columnCreator": "创建者",
      "unknownCreator": "未知",
      "columnLogs": "日志",
      "viewLink": "查看",
      "columnActions": "操作",
      "actionViewDetails": "查看详情",
      "actionPreviewData": "预览数据",
      "actionApprovals": "审批",
      "actionEvals": "评估",
      "actionEdit": "编辑",
      "actionRequeueSync": "重新排队元数据同步",
      "actionSyncMetadata": "同步元数据",
      "actionExport": "导出",
      "actionDelete": "删除",
      "databaseViewLabel": "数据库视图",
      "collectionViewLabel": "集合视图",
      "addGraphTable": "添加图表",
      "addKnowledgeTable": "添加知识表",
      "leafTitleTables": "表",
      "leafTitleGraphTables": "图表",
      "defaultSchemaLabel": "（默认）",
      "entityFilterAllLabel": "全部",
      "entityFilterFavoritesLabel": "收藏",
      "noGraphConnectorsEmptyMessage": "尚无图数据库连接器。",
      "noDataConnectorsEmptyMessage": "尚无数据连接器。",
      "schemasPaneTitle": "架构",
      "bulkExportSelected": "导出所选",
      "bulkSyncMetadata": "同步元数据",
      "bulkDeleteSelected": "删除所选",
      "graphDataExplorerAriaLabel": "图数据浏览器",
      "knowledgeDataExplorerAriaLabel": "知识数据浏览器",
      "deleteDialogTitle": "删除知识表",
      "deleteDialogMessage": "确定要删除“{{name}}”吗？此操作无法撤销。",
      "deleteDialogConfirmLabel": "删除",
      "deleteSchemaDialogTitle": "删除架构",
      "deleteSchemasDialogTitle": "删除架构",
      "deleteSchemaDialogMessage_one": "确定要删除架构“{{schema}}”及其中的 {{count}} 个已注册表吗？此操作仅删除 {{brand}} 元数据，且无法撤销。",
      "deleteSchemaDialogMessage_other": "确定要删除架构“{{schema}}”及其中的 {{count}} 个已注册表吗？此操作仅删除 {{brand}} 元数据，且无法撤销。",
      "deleteSchemasDialogMessage_one": "确定要删除 {{schemaCount}} 个架构及其中的 {{count}} 个已注册表吗？此操作仅删除 {{brand}} 元数据，且无法撤销。",
      "deleteSchemasDialogMessage_other": "确定要删除 {{schemaCount}} 个架构及其中的 {{count}} 个已注册表吗？此操作仅删除 {{brand}} 元数据，且无法撤销。",
      "deletingLabel": "正在删除…",
      "deleteSchemasDialogConfirmLabel": "删除 {{count}} 个架构",
      "andOthersLabel": "{{names}} 及其他 {{count}} 个",
      "bulkDeleteDialogTitle": "删除所选表",
      "bulkDeleteDialogMessage_one": "确定要删除 {{count}} 个表吗？此操作无法撤销。",
      "bulkDeleteDialogMessage_other": "确定要删除 {{count}} 个表吗？此操作无法撤销。",
      "bulkDeleteDialogConfirmLabel_one": "删除 {{count}} 个表",
      "bulkDeleteDialogConfirmLabel_other": "删除 {{count}} 个表",
      "emptyStatePermissionDenied": "您没有查看{{resource}}的权限。请联系管理员获取访问权限。",
      "emptyStateSearching": "未找到与您的搜索匹配的{{resource}}。",
      "emptyStateDefault": "未找到{{resource}}。创建您的第一个{{resourceSingular}}以开始使用。",
      "resourceGraphTables": "图表",
      "resourceGraphTable": "图表",
      "resourceKnowledgeTables": "知识表",
      "resourceKnowledgeTable": "知识表"
    },
    "addTableModal": {
      "title": "添加知识表",
      "closeDialogAriaLabel": "关闭对话框",
      "cancelButton": "取消",
      "loadConnectorsError": "加载连接器失败",
      "noDatabasesFoundWarning": "未找到数据库。该连接器可能无法访问任何数据库。",
      "loadTablesTimedOut": "加载表超时。请尝试缩小范围或检查您的连接。",
      "loadTablesForSchemaError": "加载该架构的表失败",
      "loadingTablesForSchema": "正在加载 {{schema}} 的表...",
      "schemaFallbackLabel": "架构",
      "inlineSearch": {
        "defaultPlaceholder": "搜索",
        "clearAriaLabel": "清除搜索"
      },
      "breadcrumb": {
        "backAriaLabel": "返回",
        "schemasCount_one": "{{count}} 个架构",
        "schemasCount_other": "{{count}} 个架构"
      },
      "connectorSelection": {
        "emptyTitle": "没有连接器",
        "emptyMessage": "请先创建一个连接器以添加知识表",
        "filterByTypeLabel": "按连接器类型筛选",
        "connectorTypeLabel": "连接器类型",
        "allConnectorTypesPlaceholder": "所有连接器类型 ({{count}})",
        "searchPlaceholder": "搜索连接器",
        "noMatchingConnections": "没有匹配的连接。请调整搜索条件或选择其他连接器类型。"
      },
      "databaseSelection": {
        "loadingCatalog": "正在加载目录…",
        "catalogUnavailableTitle": "目录不可用",
        "catalogUnavailableMessage": "无法加载目录。请检查连接器配置并重试。",
        "noDatabasesTitle": "未找到数据库",
        "noDatabasesMessage": "该连接器无法访问任何数据库，或内省失败。",
        "title": "选择数据库",
        "countLabel_one": "显示 {{shown}} / {{count}} 个数据库",
        "countLabel_other": "显示 {{shown}} / {{count}} 个数据库",
        "searchPlaceholder": "搜索数据库",
        "noMatchMessage": "没有与您的搜索匹配的数据库。",
        "schemaCount_one": "{{count}} 个架构",
        "schemaCount_other": "{{count}} 个架构"
      },
      "schemaSelection": {
        "title": "选择架构",
        "countLabel_one": "显示 {{shown}} / {{count}} 个架构",
        "countLabel_other": "显示 {{shown}} / {{count}} 个架构",
        "selectedCount": "已选择 {{count}} 个",
        "deselectAll": "取消全选",
        "selectAll": "全选",
        "continueWith_one": "使用 {{count}} 个架构继续",
        "continueWith_other": "使用 {{count}} 个架构继续",
        "searchPlaceholder": "搜索架构",
        "hint": "勾选架构并点击继续以逐个浏览，或点击卡片打开单个架构。",
        "noMatchMessage": "没有与您的搜索匹配的架构。",
        "selectSchemaAriaLabel": "选择架构 {{schema}}",
        "tableCount_one": "{{count}} 个表",
        "tableCount_other": "{{count}} 个表",
        "clickToLoadTables": "点击加载表"
      },
      "tableSelection": {
        "loadingTables": "正在加载表…",
        "noTablesFoundTitle": "未找到表",
        "noTablesInSchema": "此架构中没有可用的表",
        "noTablesInDatabase": "此数据库中没有可用的表",
        "hint": "表仅为当前打开的架构加载。点击行或使用表头复选框进行选择。",
        "searchPlaceholder": "搜索表",
        "showingCount": "显示 {{shown}} / {{count}}",
        "selectedAcrossSchemas": "跨架构已选择 {{count}} 个",
        "deselectAllAriaLabel": "取消选择所有表",
        "selectAllAriaLabel": "选择所有表",
        "columnTable": "表",
        "columnDatabase": "数据库",
        "columnRows": "行数",
        "columnCols": "列数",
        "noMatchMessage": "没有与您的搜索匹配的表。",
        "selectTableAriaLabel": "选择 {{label}}",
        "updateAvailableTooltip": "有新的节点/标签可用",
        "updateAvailableBadge": "有更新",
        "alreadyRegisteredTooltip": "您已注册此表",
        "registeredBadge": "已注册"
      },
      "registrationStep": {
        "loadingTables": "正在加载表…",
        "selectedSchemasAriaLabel": "已选择的架构",
        "multiGraphRegistrationLabel": "多图注册：",
        "multiGraphRegistrationTextPrefix": "每个选中的",
        "multiGraphRegistrationTextSuffix": "行都会作为该图的知识资产注册。",
        "graphSchemaRegistrationLabel": "图架构注册：",
        "graphSchemaRegistrationText": "所选的图表将注册为单个图架构条目。",
        "relationshipTypesDetected_one": "检测到 {{count}} 种关系类型。",
        "relationshipTypesDetected_other": "检测到 {{count}} 种关系类型。",
        "finalizeAndRegisterTitle": "完成并注册",
        "subtitleRegisterPrefix": "注册",
        "subtitleChoosePrefix": "选择如何使用此知识，然后注册",
        "subtitleGraphSchemaSuffix_one": "个图表，作为单个图架构条目。",
        "subtitleGraphSchemaSuffix_other": "个图表，作为单个图架构条目。",
        "subtitleGraphsSuffix_one": "个图，一步完成。",
        "subtitleGraphsSuffix_other": "个图，一步完成。",
        "subtitleGraphTablesSuffix_one": "个图表，一步完成。",
        "subtitleGraphTablesSuffix_other": "个图表，一步完成。",
        "subtitleTablesSuffix_one": "个表，一步完成。",
        "subtitleTablesSuffix_other": "个表，一步完成。",
        "selectGraphTablesAbove": "请在上方选择图表",
        "selectGraphsAbove": "请在上方选择图",
        "selectTablesAbove": "请在上方选择表",
        "registerGraphSchema_one": "注册图架构（{{count}} 个图表）",
        "registerGraphSchema_other": "注册图架构（{{count}} 个图表）",
        "registerGraphs_one": "注册 {{count}} 个图",
        "registerGraphs_other": "注册 {{count}} 个图",
        "registerGraphTables_one": "注册 {{count}} 个图表",
        "registerGraphTables_other": "注册 {{count}} 个图表",
        "registerTables_one": "注册 {{count}} 个表",
        "registerTables_other": "注册 {{count}} 个表"
      },
      "introspectionError": {
        "thisConnection": "此连接",
        "timedOut": "{{name}} 响应时间过长。",
        "forbidden": "您无权浏览 {{name}} — 请联系项目管理员。",
        "credentialsRejected": "{{name}} 拒绝了已保存的凭据。",
        "missingSecret": "{{name}} 缺少密码或密钥。",
        "databaseNotFound": "{{name}} 上保存的数据库或目录已不存在。",
        "hostUnreachable": "无法访问 {{name}} 上配置的主机。",
        "serviceBusy": "{{name}} 当前繁忙。",
        "notConnecting": "{{name}} 未能连接。",
        "genericFailure": "无法从 {{name}} 加载目录。",
        "validateInConnections": "在连接中验证",
        "tryAgain": "重试"
      }
    },
    "editModal": {
      "title": "编辑知识表",
      "closeDialogAriaLabel": "关闭对话框",
      "vectorDbBadge": "向量数据库",
      "displayNameLabel": "显示名称",
      "displayNamePlaceholder": "输入显示名称",
      "nameAlreadyExistsToast": "已存在同名的知识表",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "输入描述(可选)",
      "knowledgeTypeLabel": "知识类型",
      "knowledgeTypeData": "数据",
      "knowledgeTypeDataHint": "= 通用知识。",
      "knowledgeTypeBenchmarks": "基准测试",
      "knowledgeTypeBenchmarksFull": "基准测试(评估与仿真)",
      "knowledgeTypeBenchmarksHint": "= 显示在评估与仿真中。",
      "knowledgeTypePlaceholder": "选择知识类型...",
      "benchmarkTypeLabel": "基准测试类型",
      "benchmarkTypeHint": "显示在基准测试标签页中的工作负载类别(Text2SQL、RAG、工具使用等)。",
      "benchmarkTypePlaceholder": "选择基准测试类型…",
      "benchmarkIconLabel": "基准测试图标",
      "benchmarkIconHint": "显示在评估与仿真中的基准测试卡片上。未设置图片时将回退到连接器图标。",
      "embeddingModelLabel": "嵌入模型",
      "embeddingModelHint": "选择用于在此表中创建向量的嵌入模型。",
      "embeddingModelPlaceholder": "选择嵌入模型...",
      "searchModelsPlaceholder": "搜索模型...",
      "loadingModelsMessage": "正在加载嵌入模型...",
      "noModelsRegisteredMessage": "尚未注册任何嵌入模型。请先注册一个嵌入模型。",
      "noModelSelectedWarning": "未选择嵌入模型。向量搜索可能失败或返回错误结果。",
      "defaultBadge": "默认",
      "loadModelsErrorToast": "加载嵌入模型失败",
      "updateErrorToast": "知识表更新失败",
      "cancelButton": "取消",
      "savingButton": "正在保存...",
      "saveChangesButton": "保存更改"
    },
    "modal": {
      "title": "为知识库注册表",
      "closeDialogAriaLabel": "关闭对话框",
      "registeringTooltip_one": "正在从 {{name}} 注册 {{count}} 个表",
      "registeringTooltip_other": "正在从 {{name}} 注册 {{count}} 个表",
      "registeringText_one": "正在从 {{name}} 注册 {{count}} 个表",
      "registeringText_other": "正在从 {{name}} 注册 {{count}} 个表",
      "registerSubmitLabel_one": "注册 {{count}} 个表",
      "registerSubmitLabel_other": "注册 {{count}} 个表",
      "tablesToRegisterLabel": "要注册的表",
      "columnsCount_one": "{{count}} 列",
      "columnsCount_other": "{{count}} 列",
      "rowsCount_one": "{{formattedCount}} 行",
      "rowsCount_other": "{{formattedCount}} 行",
      "columnsHeader": "列",
      "notNullBadge": "NOT NULL",
      "cancelButton": "取消"
    },
    "viewModal": {
      "title": "知识表详情",
      "closeDialogAriaLabel": "关闭对话框",
      "closeButton": "关闭",
      "notAvailable": "不适用",
      "yesLabel": "是",
      "noLabel": "否",
      "noneDetectedMessage": "未检测到",
      "statusUnknown": "未知",
      "statusActive": "有效",
      "statusError": "错误",
      "statusSyncing": "同步中",
      "noErrorsMessage": "无错误",
      "noColumnInfoMessage": "没有可用的列信息",
      "basicInformationHeader": "基本信息",
      "tableInformationHeader": "表信息",
      "graphInformationHeader": "图信息",
      "embeddingModelHeader": "嵌入模型",
      "columnsHeader": "列",
      "errorInformationHeader": "错误信息",
      "metadataHeader": "元数据",
      "auditInformationHeader": "审计信息",
      "fieldId": "ID",
      "fieldConnector": "连接器",
      "fieldStatus": "状态",
      "fieldDatabase": "数据库",
      "fieldSchema": "模式",
      "fieldTableName": "表名",
      "fieldRowCountNodes": "行数(节点)",
      "fieldTotalNodes": "节点总数",
      "fieldTotalEdges": "边总数",
      "fieldRelationshipTypes": "关系类型",
      "fieldNodeLabels": "节点标签",
      "fieldModel": "模型",
      "fieldErrorMessage": "错误信息",
      "fieldCreatedAt": "创建时间",
      "fieldUpdatedAt": "更新时间",
      "fieldCreatedBy": "创建者",
      "fieldUpdatedBy": "更新者",
      "noEmbeddingModelConfiguredTitle": "未配置嵌入模型",
      "noEmbeddingModelConfiguredHint": "向量搜索可能失败或返回错误结果。请编辑此表以分配与创建存储向量时所用模型相匹配的嵌入模型。",
      "columnName": "名称",
      "columnType": "类型",
      "columnNullable": "可为空"
    },
    "registerFields": {
      "embeddingModelLabel": "嵌入模型",
      "embeddingModelHint": "用于对这些向量表进行语义搜索的模型。",
      "loadingModelsMessage": "正在加载嵌入模型…",
      "noModelsRegisteredMessage": "尚未注册任何嵌入模型。请先注册一个。",
      "selectEmbeddingModelOption": "— 选择嵌入模型 —",
      "defaultBadge": "默认",
      "managedVectorDbHint": "此连接器在内部管理索引和嵌入 — 无需列映射。所选的嵌入模型将在查询时用于嵌入您的搜索查询。",
      "columnMappingLabel": "列映射",
      "columnMappingHint": "为向量搜索映射 ID、内容和嵌入列。",
      "columnLabelId": "ID",
      "columnLabelContent": "内容",
      "columnLabelEmbedding": "嵌入",
      "columnFieldLabel": "{{column}} 列",
      "selectOption": "— 选择 —",
      "vectorSuffix": "向量",
      "knowledgePurposeLabel": "知识用途",
      "knowledgeTypeData": "数据",
      "knowledgeTypeDataHint": "用于通用 RAG。",
      "knowledgeTypeBenchmarks": "基准测试",
      "knowledgeTypeBenchmarksHint": "在评估与仿真中展示此数据。",
      "knowledgeTypeGroupAriaLabel": "知识类型",
      "encryptDataLabel": "为查看者加密静态表数据",
      "encryptDataHint": "只有您(创建者)可以看到明文值;其他人只能看到密文。使用与工具密钥相同的密钥。",
      "selectEmbeddingModelTooltip": "选择一个嵌入模型",
      "mapColumnsTooltip": "映射 ID、内容和嵌入列",
      "registeringButton": "正在注册…"
    },
    "groupedView": {
      "loadingMessage": "正在加载表...",
      "emptyMessage": "未找到知识表",
      "emptySearchHint": "请尝试调整搜索条件",
      "tableCount_one": "{{count}} 个表",
      "tableCount_other": "{{count}} 个表",
      "rowsCount_one": "{{formattedCount}} 行",
      "rowsCount_other": "{{formattedCount}} 行",
      "vectorDbTooltip": "向量数据库",
      "vectorDbBadge": "向量数据库",
      "createdTooltip": "创建时间",
      "updatedTooltip": "更新时间",
      "statusUnknown": "未知",
      "statusError": "错误",
      "statusActive": "有效",
      "statusSyncing": "同步中",
      "actionViewDetails": "查看详情",
      "actionPreviewData": "预览数据",
      "actionEdit": "编辑",
      "actionVectorSearch": "向量搜索",
      "actionSync": "同步",
      "actionManageAccess": "管理访问权限",
      "actionDelete": "删除"
    },
    "addStorageFolderModal": {
      "title": "添加存储文件夹",
      "closeDialogAriaLabel": "关闭对话框",
      "selectConnectorTitle": "选择存储连接器",
      "noConnectorsFoundMessage": "未找到存储连接器。请先创建一个存储连接器。",
      "searchConnectorsPlaceholder": "搜索连接器",
      "countOf": "{{count}} 中的 {{shown}}",
      "noConnectorsMatchFilters": "没有符合筛选条件的连接器。",
      "connectorTypeLabel": "连接器类型",
      "allConnectorTypesPlaceholder": "所有连接器类型 ({{count}})",
      "selectBucketTitle": "选择存储桶",
      "noBucketsFoundMessage": "未找到存储桶。",
      "searchBucketsPlaceholder": "搜索存储桶",
      "noBucketsMatchSearch": "没有符合搜索条件的存储桶。",
      "selectFoldersTitle": "选择文件夹",
      "selectAllButton": "全选",
      "deselectAllButton": "取消全选",
      "searchFoldersPlaceholder": "搜索文件夹",
      "fileCount_one": "{{count}} 个文件",
      "fileCount_other": "{{count}} 个文件",
      "openSubfolderTooltip": "打开子文件夹",
      "noFoldersMatchSearch": "没有符合搜索条件的文件夹。",
      "noSubfoldersMessage": "此处没有子文件夹。如果该文件夹路径包含文件，您可以注册它。",
      "noFoldersInBucketMessage": "此存储桶中未找到文件夹。",
      "selectFolderButton": "选择文件夹“{{name}}”",
      "selectedFoldersCount_one": "已选择 {{count}} 个文件夹",
      "selectedFoldersCount_other": "已选择 {{count}} 个文件夹",
      "cancelButton": "取消",
      "registeringButton": "正在注册...",
      "registerFoldersButton_one": "注册 {{count}} 个文件夹",
      "registerFoldersButton_other": "注册 {{count}} 个文件夹",
      "registerSuccessToast_one": "已成功注册 {{count}} 个存储文件夹",
      "registerSuccessToast_other": "已成功注册 {{count}} 个存储文件夹"
    },
    "splitView": {
      "storageBucketPane": {
        "title": "存储桶",
        "columnBucket": "存储桶",
        "columnFolders": "文件夹",
        "defaultBucketLabel": "（默认）",
        "searchPlaceholder": "搜索存储桶…",
        "emptyMessage": "没有已注册的存储桶。",
        "emptySearchMessage": "没有符合此搜索条件的存储桶。",
        "loadErrorMessage": "加载存储桶失败"
      },
      "connectorPane": {
        "columnCreatedAt": "创建时间",
        "columnDatabase": "类型",
        "columnName": "名称",
        "columnStatus": "状态",
        "columnUpdatedAt": "更新时间",
        "emptyMessage": "未找到连接器。",
        "emptySearchMessage": "没有与您的搜索匹配的连接器。",
        "loadErrorMessage": "加载连接器失败。",
        "searchPlaceholder": "搜索连接器…",
        "title": "连接器"
      },
      "schemaPane": {
        "ariaDeleteMany_one": "删除所选的 {{count}} 个架构",
        "ariaDeleteMany_other": "删除所选的 {{count}} 个架构",
        "ariaDeleteOne": "删除所选架构",
        "columnName": "名称",
        "columnObjects": "对象数",
        "defaultLabel": "默认",
        "deleteTitleEmpty": "删除架构",
        "deleteTitleMany_one": "删除 {{count}} 个架构",
        "deleteTitleMany_other": "删除 {{count}} 个架构",
        "deleteTitleOne": "删除架构",
        "deleteTitleOneNamed": "删除 {{schema}}",
        "emptyMessage": "未找到架构",
        "emptySearchMessage": "没有与搜索匹配的架构",
        "loadErrorMessage": "加载架构失败",
        "searchPlaceholder": "搜索{{title}}…",
        "title": "架构"
      }
    },
    "connectorFields": {
      "extraParamField": {
        "authApiKey": "API 密钥",
        "authBasic": "基本身份验证",
        "configured": "已配置",
        "engineMssql": "SQL Server",
        "engineMysql": "MySQL",
        "enginePostgres": "PostgreSQL",
        "payloadBase64Json": "Base64 JSON",
        "payloadBinary": "二进制",
        "provisioned": "已预置",
        "schemeBolt": "bolt",
        "schemeBoltS": "bolt+s",
        "schemeNeo4j": "neo4j",
        "schemeNeo4jS": "neo4j+s",
        "serverless": "无服务器"
      },
      "extraParams": {
        "advancedLabel": "高级选项"
      },
      "scopeSelector": {
        "currentScope": "当前范围：{{scope}}",
        "enableTenantNote": "开启后，范围将切换为租户模式。",
        "projectDescription": "仅在特定项目内可用",
        "projectFieldLabel": "项目",
        "projectHint": "此连接器仅在所选项目内可用。",
        "projectLabel": "项目",
        "projectPlaceholder": "选择一个项目",
        "projectSearchPlaceholder": "搜索项目…",
        "tenantDescription": "对该租户下的所有项目可用",
        "tenantHint": "此连接器将对该租户下的所有项目可用。",
        "tenantLabel": "租户",
        "tenantToggleLabel": "租户范围"
      },
      "shared": {
        "aihubSubscriptionKeySecretNameLabel": "AI Hub 订阅密钥的密钥名称",
        "authHelp": {
          "awsDefault": "请为此连接器提供 AWS 凭据。",
          "awsKeyBoto": "通过 boto3 使用的 AWS 访问密钥和秘密密钥。",
          "awsKeySql": "用于连接数据库的 AWS 访问密钥和秘密密钥。",
          "awsWif": "使用 AWS 工作负载身份联合，而不是长期有效的访问密钥。",
          "azureAiSearchKey": "使用管理员 API 密钥连接到 Azure AI Search。",
          "azureAihub": "使用 AI Hub 订阅密钥而非 Azure AD 凭据进行连接。",
          "azureBlobKey": "使用账户密钥连接到 Azure Blob 存储。",
          "azureDocIntelligenceKey": "使用 API 密钥连接到 Azure Document Intelligence。",
          "azureKeyDefault": "使用密钥或连接字符串进行连接。",
          "azureOboAiSearch": "代表已登录用户访问 Azure AI Search（委派身份验证）。",
          "azureOboBlob": "代表已登录用户访问 Azure Blob 存储（委派身份验证）。",
          "azureOboDefault": "代表已登录用户访问此资源（委派身份验证）。",
          "azureOboDocIntelligence": "代表已登录用户访问 Azure Document Intelligence（委派身份验证）。",
          "azureOboSharePoint": "代表已登录用户访问 SharePoint（委派身份验证）。",
          "azureSharePointKey": "使用客户端密钥连接到 SharePoint。",
          "azureSpAiSearch": "使用已注册的服务主体访问 {brand} 的 Azure AI Search。",
          "azureSpBlob": "使用已注册的服务主体访问 Azure Blob 存储。",
          "azureSpDefault": "使用已注册的服务主体访问 {brand} 中的此资源。",
          "azureSpDocIntelligence": "使用已注册的服务主体访问 {brand} 中的 Azure Document Intelligence。",
          "azureSpRlsDeprecated": "此服务主体模式已弃用，请切换到受支持的身份验证模式。",
          "azureSpSharePoint": "使用已注册的服务主体访问 SharePoint。",
          "gcpDefault": "请为此连接器提供 GCP 凭据。",
          "gcpKey": "使用 GCP 服务账号密钥进行连接。",
          "gcpSaDefault": "使用 GCP 服务账号进行连接。",
          "gcpSaGcs": "使用 GCP 服务账号访问 Google Cloud Storage。",
          "gcpSaRlsDeprecated": "此服务账号模式已弃用，请切换到受支持的身份验证模式。",
          "gcpWifDefault": "使用 GCP 工作负载身份联合进行连接。",
          "gcpWifGcs": "使用 GCP 工作负载身份联合访问 Google Cloud Storage。",
          "oracleIamRequired": "此 Oracle 身份验证模式需要一个 Cloud IAM 条目。",
          "oracleUsernamePassword": "使用 Oracle 数据库用户名和密码进行连接。",
          "oracleWallet": "使用 Oracle 钱包进行连接。"
        },
        "authModeLabel": "身份验证模式",
        "authModePlaceholder": "选择身份验证模式",
        "databaseEngineHelpText": "请为此 Azure 托管 SQL 连接选择底层数据库引擎。",
        "databaseEngineLabel": "数据库引擎",
        "databaseLabel": "数据库",
        "databaseUsernameEntraLabel": "Entra 显示名称",
        "descriptionLabel": "描述",
        "descriptionPlaceholder": "该连接器的可选描述",
        "displayNameLabel": "显示名称",
        "displayNamePlaceholder": "例如：生产数据库",
        "docIntelVerifySslHelpText": "仅在连接到使用自签名证书的 Document Intelligence 终结点时禁用此选项。",
        "engineMysql": "MySQL",
        "enginePostgresql": "PostgreSQL",
        "engineSqlServer": "SQL Server",
        "entraDisplayNamePlaceholder": "例如：john.doe@company.com",
        "entraUsernameHelpText": "请输入该数据库主体的 Entra ID 显示名称或 UPN。",
        "fromIamSuffix": "（来自 Cloud IAM）",
        "iamEmptyWarning": {
          "awsBasicAuth": "未找到 AWS 基本身份验证的 Cloud IAM 条目，请先添加一个再继续。",
          "awsIamUser": "未找到 AWS IAM 用户的 Cloud IAM 条目，请先添加一个再继续。",
          "awsWif": "未找到 AWS 工作负载身份联合的 Cloud IAM 条目，请先添加一个再继续。",
          "azureBasicAuth": "未找到 Azure 基本身份验证的 Cloud IAM 条目，请先添加一个再继续。",
          "azureBlobIamOnly": "未找到 Azure Blob 存储的 Cloud IAM 条目，请先添加一个再继续。",
          "azureBlobKey": "未找到 Azure Blob 存储密钥的 Cloud IAM 条目，请先添加一个再继续。",
          "azureServicePrincipal": "未找到 Azure 服务主体的 Cloud IAM 条目，请先添加一个再继续。",
          "databricks": "未找到 Databricks 的 Cloud IAM 条目，请先添加个人访问令牌再继续。",
          "default": "未找到 Cloud IAM 条目，请先添加一个再继续。",
          "gcp": "未找到 GCP 的 Cloud IAM 条目，请先添加一个再继续。",
          "gcpBasicAuth": "未找到 GCP 基本身份验证的 Cloud IAM 条目，请先添加一个再继续。",
          "gcpServiceAccount": "未找到 GCP 服务账号的 Cloud IAM 条目，请先添加一个再继续。",
          "tokenBasedOnprem": "未找到访问令牌的 Cloud IAM 条目，请先添加一个再继续。"
        },
        "iamHelp": {
          "awsAccessKeys": "请选择包含您的 AWS 访问密钥和秘密密钥的 Cloud IAM 条目。",
          "awsBasicAuth": "请选择包含您的 AWS 数据库凭据的 Cloud IAM 条目。",
          "awsWif": "请选择已配置用于 AWS 工作负载身份联合的 Cloud IAM 条目。",
          "azureBasicAuth": "请选择包含您的 Azure 基本身份验证凭据的 Cloud IAM 条目。",
          "azureBlobIamOnly": "请选择用于访问 Azure Blob 存储的 Cloud IAM 条目。",
          "azureBlobKey": "请选择包含您的 Azure Blob 存储账户密钥的 Cloud IAM 条目。",
          "azureServicePrincipal": "请选择 Azure 服务主体的 Cloud IAM 条目。",
          "databricks": "请选择包含您的 Databricks 个人访问令牌的 Cloud IAM 条目。",
          "default": "请为此连接器选择一个 Cloud IAM 条目。",
          "gcp": "请为此 GCP 连接器选择 Cloud IAM 条目。",
          "gcpBasicAuth": "请选择包含您的 GCP 基本身份验证凭据的 Cloud IAM 条目。",
          "gcpServiceAccount": "请选择包含您的 GCP 服务账号密钥的 Cloud IAM 条目。",
          "gcpTokenMode": "请选择用于生成访问令牌的 Cloud IAM 条目。",
          "gcpWif": "请选择已配置用于 GCP 工作负载身份联合的 Cloud IAM 条目。",
          "oracleOptional": "您可以选择一个 Cloud IAM 条目，而无需直接输入凭据（可选）。",
          "oracleRequired": "请选择此 Oracle 身份验证模式所需的 Cloud IAM 条目。",
          "tokenBasedOnprem": "请选择包含您的访问令牌的 Cloud IAM 条目。"
        },
        "iamLabel": {
          "accessToken": "访问令牌",
          "awsAccessKeys": "AWS 访问密钥",
          "awsBasicAuth": "AWS 基本身份验证",
          "awsWif": "AWS 工作负载身份联合",
          "azureBasicAuth": "Azure 基本身份验证",
          "azureBlobStorage": "Azure Blob 存储",
          "azureOrGraph": "Azure AD / Microsoft Graph",
          "azureServicePrincipal": "Azure 服务主体",
          "azureStorage": "Azure 存储",
          "cloudIam": "Cloud IAM",
          "cloudIamOptional": "Cloud IAM（可选）",
          "databricksIam": "Databricks IAM（PAT 或服务主体）",
          "databricksPat": "Databricks 个人访问令牌",
          "gcp": "GCP Cloud IAM",
          "gcpBasicAuth": "GCP 基本身份验证",
          "gcpServiceAccount": "GCP 服务账号",
          "gcpWif": "GCP 工作负载身份联合"
        },
        "iamPlaceholder": {
          "accessToken": "选择访问令牌",
          "awsAccessKeys": "选择 AWS 访问密钥",
          "awsBasicAuth": "选择 AWS 基本身份验证凭据",
          "awsWif": "选择 AWS 工作负载身份联合条目",
          "azureBasicAuth": "选择 Azure 基本身份验证凭据",
          "azureBlobIamOnly": "选择 Azure Blob 存储的 Cloud IAM 条目",
          "azureBlobKey": "选择 Azure Blob 存储密钥",
          "azureServicePrincipal": "选择 Azure 服务主体",
          "databricksIam": "选择 Databricks IAM 条目（PAT 或服务主体）",
          "databricksPat": "选择 Databricks 个人访问令牌",
          "default": "选择一个 Cloud IAM 条目",
          "gcp": "选择 GCP 的 Cloud IAM 条目",
          "gcpBasicAuth": "选择 GCP 基本身份验证凭据",
          "gcpServiceAccount": "选择 GCP 服务账号",
          "gcpWif": "选择 GCP 工作负载身份联合条目"
        },
        "loadingIamEntries": "正在加载 Cloud IAM 条目…",
        "passwordSecretKeyNameOptionalLabel": "密码密钥名称（可选）",
        "portLabel": "端口",
        "schemaLabel": "架构",
        "secretKeyNameLabel": "密钥名称",
        "secretKeyNamePlaceholder": "例如：my-connector-password",
        "serverHostHelpMssql": "请输入 SQL Server 主机名，例如 myserver.database.windows.net",
        "serverHostHelpMysql": "请输入 MySQL 主机名，例如 myserver.mysql.database.azure.com",
        "serverHostHelpPostgres": "请输入 PostgreSQL 主机名，例如 myserver.postgres.database.azure.com",
        "serverHostLabel": "服务器主机",
        "usernameLabel": "用户名"
      },
      "testSection": {
        "cancel": "取消",
        "connectionFailed": "连接失败",
        "connectionSuccessful": "连接成功",
        "latency": "延迟：{{ms}} 毫秒",
        "subtitle": "保存前请验证您的连接设置",
        "testConnection": "测试连接",
        "title": "测试连接",
        "version": "版本：{{version}}"
      }
    },
    "connectorModal": {
      "aria": {
        "backToSelection": "返回连接器选择",
        "closeDialog": "关闭对话框"
      },
      "buttons": {
        "addConnector": "添加连接器",
        "back": "返回",
        "cancel": "取消",
        "creating": "正在创建…",
        "updateConnector": "更新连接器",
        "updating": "正在更新…"
      },
      "connectorsLabel": "连接器",
      "errors": {
        "aiHubSecretRequired": "AI Hub 订阅密钥的密钥名称为必填项",
        "awsIamUserRequired": "请选择一个 AWS IAM 用户的 Cloud IAM 条目",
        "awsWifIamRequired": "请选择一个 AWS 工作负载身份联合的 Cloud IAM 条目",
        "azureBasicAuthIamRequired": "请为 Azure 基本身份验证选择一个 Cloud IAM 条目",
        "azureBlobIamRequired": "请为 Azure Blob 存储选择一个 Cloud IAM 条目",
        "azureBlobIamRequiredFull": "访问 Azure Blob 存储需要一个 Cloud IAM 条目",
        "azureSpIamRequiredObo": "请为代表 (On-Behalf-Of) 委派访问选择一个 Cloud IAM 条目",
        "azureSpIamRequiredSp": "请为 Azure 服务主体选择一个 Cloud IAM 条目",
        "cloudIamOrSecretRequired": "请提供 Cloud IAM 条目或密钥名称",
        "cloudIamRequired": "需要一个 Cloud IAM 条目",
        "cloudIamRequiredForMode": "此身份验证模式需要一个 Cloud IAM 条目",
        "displayNameRequired": "显示名称为必填项",
        "fieldRequired": "{{field}} 为必填项",
        "gcpBasicAuthIamRequired": "请为 GCP 基本身份验证选择一个 Cloud IAM 条目",
        "gcpServiceAccountIamRequired": "请为 GCP 服务账号选择一个 Cloud IAM 条目",
        "hostNoUnderscores": "主机名不能包含下划线",
        "nameAlreadyExists": "已存在同名的连接器",
        "oracleCloudIamRequired": "此 Oracle 身份验证模式需要一个 Cloud IAM 条目",
        "oracleSecretOrIamRequired": "需要提供 {{field}}，或选择一个 Cloud IAM 条目",
        "portRange": "端口号必须介于 1 到 65535 之间",
        "projectRequired": "请选择一个项目",
        "provideCloudIamOrSecret": "测试前请提供 Cloud IAM 条目或密钥",
        "schemaRequired": "架构为必填项",
        "sharepointCredentialsRequired": "SharePoint 凭据为必填项",
        "testFailedCheckConfig": "连接测试失败，请检查配置后重试。",
        "usernameRequired": "用户名为必填项",
        "walletLocationRequired": "钱包位置为必填项"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "AI Hub 订阅密钥的密钥名称",
        "awsIamUserCloudIamEntry": "AWS IAM 用户的 Cloud IAM 条目",
        "awsWifCloudIamEntry": "AWS 工作负载身份联合的 Cloud IAM 条目",
        "azureBasicAuthIamRequired": "Azure 基本身份验证的 Cloud IAM 条目",
        "azureBlobIamEntry": "Azure Blob 存储的 Cloud IAM 条目",
        "azureBlobIamRequiredForMode": "Azure Blob 存储的 Cloud IAM 条目",
        "azureSpIamObo": "Azure 服务主体（代表访问）的 Cloud IAM 条目",
        "azureSpIamSp": "Azure 服务主体的 Cloud IAM 条目",
        "cloudIamEntry": "Cloud IAM 条目",
        "cloudIamOrPasswordSecretKeyName": "Cloud IAM 条目或密码密钥名称",
        "connectorFallback": "连接器",
        "database": "数据库",
        "displayName": "显示名称",
        "gcpIamEntryBasicAuth": "GCP 基本身份验证的 Cloud IAM 条目",
        "gcpIamEntryServiceAccount": "GCP 服务账号的 Cloud IAM 条目",
        "host": "主机",
        "passwordSecretKeyName": "密码密钥名称",
        "project": "项目",
        "secretKeyName": "密钥名称",
        "sharepointCredentialsRequired": "SharePoint 凭据",
        "walletLocation": "钱包位置"
      },
      "loadingQuota": "正在加载配额…",
      "missingFieldsTitle": "缺少必填字段：{{fields}}",
      "requiredFieldsHint": "缺失：{{fields}}",
      "titles": {
        "configureConnector": "配置 {{name}}",
        "editConnector": "编辑连接器",
        "selectConnectorType": "选择连接器类型"
      },
      "toasts": {
        "createFailed": "创建连接器失败",
        "updateFailed": "更新连接器失败"
      }
    },
    "connectorSelectionGrid": {
      "categories": {
        "aws": "AWS",
        "azure": "Azure",
        "databricks": "Databricks",
        "gcp": "GCP",
        "onprem": "本地部署",
        "orchestrators": "编排器",
        "snowflake": "Snowflake",
        "storage": "存储",
        "telephony": "电话",
        "vectorDb": "向量数据库"
      },
      "loading": "正在加载连接器类型…"
    },
    "connectorViewModal": {
      "aria": {
        "backToSelection": "返回连接器选择",
        "closeDialog": "关闭对话框"
      },
      "buttons": {
        "addConnector": "添加连接器",
        "back": "返回",
        "cancel": "取消",
        "close": "关闭",
        "creating": "正在创建…",
        "updateConnector": "更新连接器",
        "updating": "正在更新…"
      },
      "connectorsLabel": "连接器",
      "errors": {
        "aiHubSecretRequired": "AI Hub 订阅密钥的密钥名称为必填项",
        "awsIamUserRequired": "请选择一个 AWS IAM 用户的 Cloud IAM 条目",
        "awsWifIamRequired": "请选择一个 AWS 工作负载身份联合的 Cloud IAM 条目",
        "azureBasicAuthIamRequired": "请为 Azure 基本身份验证选择一个 Cloud IAM 条目",
        "azureBlobIamRequired": "请为 Azure Blob 存储选择一个 Cloud IAM 条目",
        "azureBlobIamRequiredFull": "访问 Azure Blob 存储需要一个 Cloud IAM 条目",
        "azureSpIamRequiredObo": "请为代表 (On-Behalf-Of) 委派访问选择一个 Cloud IAM 条目",
        "azureSpIamRequiredSp": "请为 Azure 服务主体选择一个 Cloud IAM 条目",
        "cloudIamOrSecretRequired": "请提供 Cloud IAM 条目或密钥名称",
        "cloudIamRequired": "需要一个 Cloud IAM 条目",
        "cloudIamRequiredForMode": "此身份验证模式需要一个 Cloud IAM 条目",
        "displayNameRequired": "显示名称为必填项",
        "fieldRequired": "{{field}} 为必填项",
        "gcpBasicAuthIamRequired": "请为 GCP 基本身份验证选择一个 Cloud IAM 条目",
        "gcpServiceAccountIamRequired": "请为 GCP 服务账号选择一个 Cloud IAM 条目",
        "oracleCloudIamRequired": "此 Oracle 身份验证模式需要一个 Cloud IAM 条目",
        "oracleSecretOrIamRequired": "需要提供 {{field}}，或选择一个 Cloud IAM 条目",
        "portRange": "端口号必须介于 1 到 65535 之间",
        "provideCloudIamOrSecret": "测试前请提供 Cloud IAM 条目或密钥",
        "schemaRequired": "架构为必填项",
        "sharepointCredentialsRequired": "SharePoint 凭据为必填项",
        "testFailedCheckConfig": "连接测试失败，请检查配置后重试。",
        "usernameRequired": "用户名为必填项",
        "walletLocationRequired": "钱包位置为必填项"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "AI Hub 订阅密钥的密钥名称",
        "awsIamUserCloudIamEntry": "AWS IAM 用户的 Cloud IAM 条目",
        "awsWifCloudIamEntry": "AWS 工作负载身份联合的 Cloud IAM 条目",
        "azureBasicAuthIamRequired": "Azure 基本身份验证的 Cloud IAM 条目",
        "azureBlobIamEntry": "Azure Blob 存储的 Cloud IAM 条目",
        "azureBlobIamRequiredForMode": "Azure Blob 存储的 Cloud IAM 条目",
        "azureSpIamObo": "Azure 服务主体（代表访问）的 Cloud IAM 条目",
        "azureSpIamSp": "Azure 服务主体的 Cloud IAM 条目",
        "cloudIamEntry": "Cloud IAM 条目",
        "cloudIamOrPasswordSecretKeyName": "Cloud IAM 条目或密码密钥名称",
        "connectorFallback": "连接器",
        "database": "数据库",
        "displayName": "显示名称",
        "gcpIamEntryBasicAuth": "GCP 基本身份验证的 Cloud IAM 条目",
        "gcpIamEntryServiceAccount": "GCP 服务账号的 Cloud IAM 条目",
        "host": "主机",
        "passwordSecretKeyName": "密码密钥名称",
        "secretKeyName": "密钥名称",
        "sharepointCredentialsRequired": "SharePoint 凭据",
        "walletLocation": "钱包位置"
      },
      "loadingQuota": "正在加载配额…",
      "missingFieldsTitle": "缺少必填字段：{{fields}}",
      "requiredFieldsHint": "缺失：{{fields}}",
      "titles": {
        "configureConnector": "配置 {{name}}",
        "editConnector": "编辑连接器",
        "selectConnectorType": "选择连接器类型",
        "viewConnection": "查看连接"
      },
      "toasts": {
        "createFailed": "创建连接器失败",
        "updateFailed": "更新连接器失败"
      }
    },
    "graphEvals": {
      "backToGraphAriaLabel": "返回图谱",
      "cancel": "取消",
      "close": "关闭",
      "columnConfidence": "置信度",
      "columnDateTime": "日期/时间",
      "columnGrade": "评级",
      "columnReport": "报告",
      "columnSchema": "模式",
      "columnSemantic": "语义",
      "columnStatus": "状态",
      "columnStructural": "结构",
      "confidenceMeta": "置信度：{{value}}",
      "configModalAriaLabel": "评估运行配置",
      "derivationsDescFallback": "运行一次评估即可查看质量评级的计算方式。",
      "download": "下载",
      "downloadReportTooltip": "下载报告 PDF",
      "emptyRunsMessage": "尚未运行任何评估。",
      "entityCompletenessLabel": "实体完整性",
      "gradeConfidenceSummary": "评级 {{grade}} · 置信度 {{confidence}}",
      "gradeErrorAbbreviation": "错误",
      "hideFormulas": "隐藏计算公式",
      "howScoresCalculatedTitle": "评分如何计算",
      "latestScoresAriaLabel": "最新质量评分",
      "llmModelLabel": "LLM 模型",
      "llmModelTooltip": "用于判断语义一致性的模型",
      "loadingEvaluations": "正在加载评估…",
      "loadingModelsPlaceholder": "正在加载模型…",
      "loadingReport": "正在加载报告…",
      "missingGraphIdMessage": "未指定图谱表。",
      "modelDefaultLabel": "{{name}}（默认）",
      "noMatchingEvaluations": "没有与搜索条件匹配的评估。",
      "noReportAttachedMessage": "此次运行未附带报告。",
      "noStructuralBreakdown": "暂无结构细分数据。",
      "pageSubtitle": "{{name}} 的质量评估历史",
      "pageTitle": "图谱评估",
      "pdfFrameTitle": "验证报告",
      "qualityGradeHelp": "综合质量评级，由结构健康度、模式一致性和语义一致性的加权组合得出。",
      "qualityGradeLabel": "质量评级",
      "refresh": "刷新",
      "relationshipRichnessLabel": "关系丰富度",
      "reportDownloadFailedMessage": "下载报告失败。",
      "reportLoadFailedGeneric": "报告加载失败",
      "reportLoadFailedMessage": "报告文件加载失败。",
      "reportModalAriaLabel": "验证报告",
      "runEvaluationButton": "运行评估",
      "runEvaluationDescription": "选择要验证的内容以及要采样的图谱比例。",
      "runEvaluationTitle": "运行评估",
      "running": "正在运行…",
      "runningEvaluation": "评估正在运行…",
      "sampleSizeLabel": "样本大小",
      "schemaConformanceDerivationHelp": "模式一致性评分如何根据实体和关系的完整性计算得出。",
      "schemaConformanceHelp": "图谱中的实体和关系与已注册模式的匹配程度。",
      "schemaConformanceLabel": "模式一致性",
      "schemaFormulaFallback": "运行一次评估即可查看模式一致性的计算公式。",
      "schemaMetaFallback": "暂无模式数据",
      "schemaPartsFormula": "实体 {{entity}} × 关系 {{relationship}} = {{result}}",
      "scopeAll": "整个图谱",
      "scopeSample": "样本",
      "scoreDerivationsAriaLabel": "评分推导过程",
      "searchEvaluationsPlaceholder": "搜索评估…",
      "searchModelsPlaceholder": "搜索模型…",
      "selectAtLeastOneTargetError": "请至少选择一个验证目标。",
      "selectModelPlaceholder": "选择模型",
      "semanticCoherenceCaveat": "语义一致性基于样本判定，可能无法反映整个图谱的情况。",
      "semanticCoherenceDerivationHelp": "语义一致性评分如何根据采样的三元组计算得出。",
      "semanticCoherenceHelp": "图谱中的关系在逻辑和事实上是否合理。",
      "semanticCoherenceLabel": "语义一致性",
      "semanticFactScopeLegend": "待验证的事实",
      "semanticFormula": "一致 {{coherent}} / 采样 {{sampled}} = {{result}}",
      "semanticMetaCoherent": "{{coherent}} / {{sampled}} 一致",
      "semanticMetaFallback": "暂无语义数据",
      "semanticMetaSampled": "已采样 {{total}} 项中的 {{sampled}} 项",
      "semanticMetaTotal": "{{total}} 个三元组",
      "showFormulas": "显示计算公式",
      "startEvaluation": "开始评估",
      "structuralFormula": "节点/边完整性检查的加权平均值",
      "structuralHealthDerivationHelp": "结构健康度评分如何根据底层完整性检查计算得出。",
      "structuralHealthHelp": "图谱的结构完整性——悬空引用、孤立节点和格式错误的边。",
      "structuralHealthLabel": "结构健康度",
      "structuralMetaFallback": "暂无结构数据",
      "targetSchema": "模式一致性",
      "targetSemantic": "语义一致性",
      "targetStructural": "结构健康度",
      "validatingHint": "根据图谱大小，此过程可能需要几分钟。",
      "validationReportTitle": "验证报告",
      "validationTargetsLegend": "验证目标",
      "view": "查看",
      "weightBitSchema": "模式 {{value}}",
      "weightBitSemantic": "语义 {{value}}",
      "weightBitStructural": "结构 {{value}}",
      "weightedMixSummary": "{{bits}} 的加权组合 = 置信度 {{confidence}}"
    },
    "graphApprovalSession": {
      "addToQueue": "加入队列",
      "addTripletButton": "添加三元组",
      "addTripletDescription": "为此会话提议一个新的主语–关系–宾语三元组。",
      "addTripletTitle": "添加三元组",
      "approve": "批准",
      "approveAll": "全部批准",
      "backToApprovalsAriaLabel": "返回审批列表",
      "cancel": "取消",
      "collapse": "收起",
      "collapsePanelAriaLabel": "收起审核面板",
      "collapseSchemaPanelAriaLabel": "收起模式面板",
      "collapseSchemaTooltip": "收起模式面板",
      "columnConfidence": "置信度",
      "columnObject": "宾语",
      "columnRelation": "关系",
      "columnSubject": "主语",
      "commit": "提交",
      "commitSuccessApplied": "更改已应用",
      "commitSuccessCounted_one": "已提交 {{count}} 项决定",
      "commitSuccessCounted_other": "已提交 {{count}} 项决定",
      "committing": "正在提交…",
      "confidenceRangeLabel": "置信度（0～1）",
      "confidenceTooltip": "置信度：{{value}}",
      "decisionRecorded": "决定已记录。",
      "defaultSessionTitle": "审批会话",
      "emptyAllMessage": "此会话中没有提议的更改。",
      "emptyFilteredMessage": "没有与当前筛选条件匹配的{{kind}}。",
      "entityNamePlaceholder": "实体名称",
      "expandPanelAriaLabel": "展开审核面板",
      "expandSchemaPanelAriaLabel": "展开模式面板",
      "filterAll": "全部",
      "filterEntities": "实体",
      "filterProposedUpdatesAriaLabel": "筛选提议的更新",
      "filterTriplets": "三元组",
      "graphCanvasAriaLabel": "图谱画布",
      "legendConflict": "冲突",
      "legendExisting": "已有",
      "legendNew": "新增",
      "missingIdsMessage": "未指定表或会话。",
      "modify": "修改",
      "modifySnapshotTitle": "修改快照",
      "noChangesStaged": "没有待处理的更改",
      "noConfidenceScore": "无置信度评分",
      "pendingBadge_one": "{{count}} 项待处理",
      "pendingBadge_other": "{{count}} 项待处理",
      "proposedUpdatesAriaLabel": "提议的更新",
      "proposedUpdatesTitle": "提议的更新",
      "refresh": "刷新",
      "refreshSessionTooltip": "刷新会话",
      "reject": "拒绝",
      "rejectAll": "全部拒绝",
      "relationPlaceholder": "关系类型",
      "reviewerNotePlaceholder": "添加备注（可选）",
      "schemaLabel": "模式",
      "schemaSidebarAriaLabel": "图谱模式",
      "sessionContextAriaLabel": "会话上下文",
      "sessionSummary": "共 {{total}} 项 · 待处理 {{pending}} 项",
      "showSchemaPanelAriaLabel": "显示模式面板",
      "showSchemaTooltip": "显示模式面板",
      "stageAllApproveTooltip": "为所有待处理项暂存批准",
      "stageAllRejectTooltip": "为所有待处理项暂存拒绝",
      "stageFilteredApproveTooltip_one": "为当前可见的 {{count}} 项暂存批准",
      "stageFilteredApproveTooltip_other": "为当前可见的 {{count}} 项暂存批准",
      "stageFilteredRejectTooltip_one": "为当前可见的 {{count}} 项暂存拒绝",
      "stageFilteredRejectTooltip_other": "为当前可见的 {{count}} 项暂存拒绝",
      "stageModification": "暂存修改",
      "stagedApprove": "批准",
      "stagedCount_one": "已暂存 {{count}} 项更改",
      "stagedCount_other": "已暂存 {{count}} 项更改",
      "stagedModify": "修改",
      "stagedReject": "拒绝",
      "unappliedCount_one": "有 {{count}} 项已批准但尚未写入的更改",
      "unappliedCount_other": "有 {{count}} 项已批准但尚未写入的更改",
      "undo": "撤销",
      "undoAll": "全部撤销",
      "undoAllTooltip": "放弃所有暂存的决定"
    },
    "graphApprovals": {
      "auditLog": "审计日志",
      "auditTrailTitle": "审计追踪",
      "backToGraphAriaLabel": "返回图谱",
      "columnAction": "操作",
      "columnActions": "操作",
      "columnActor": "操作人",
      "columnChangeRun": "变更运行",
      "columnCommit": "提交",
      "columnCreatedAt": "创建时间",
      "columnCreatedBy": "创建者",
      "columnMessage": "消息",
      "columnMode": "模式",
      "columnPending": "待处理",
      "columnSource": "来源",
      "columnStatus": "状态",
      "columnTriplet": "三元组",
      "columnUpdatedAt": "更新时间",
      "columnVersion": "版本",
      "columnWhen": "时间",
      "commitHistoryTitle": "提交历史",
      "commits": "提交",
      "emptyAuditMessage": "暂无审计记录。",
      "emptyCommitsMessage": "暂无提交记录。",
      "emptyRunsMessage": "暂无变更运行。",
      "exportAuditAriaLabel": "将审计日志导出为 CSV",
      "exportCsv": "导出 CSV",
      "filterAll": "全部",
      "filterModeLabel": "模式",
      "filterStatusLabel": "状态",
      "footnoteText": "已批准的更改会写入实时图谱。 ",
      "hideAudit": "隐藏审计日志",
      "hideCommits": "隐藏提交记录",
      "missingTableIdMessage": "未指定图谱表。",
      "modeApprovalRequired": "需要审批",
      "modeBypassed": "已跳过审批",
      "openLivePreview": "打开实时预览",
      "openSession": "打开会话",
      "pageSubtitle": "{{name}} 的审核队列",
      "pageTitle": "图谱审批",
      "refresh": "刷新",
      "review": "审核",
      "runCount_one": "{{count}} 次运行",
      "runCount_other": "{{count}} 次运行",
      "searchAuditPlaceholder": "搜索审计日志…",
      "searchChangeRunsPlaceholder": "搜索变更运行…",
      "searchCommitsPlaceholder": "搜索提交…",
      "statusApplied": "已应用",
      "statusAutoApplied": "已自动应用",
      "statusPartiallyApplied": "部分应用",
      "statusPending": "待处理",
      "statusRejected": "已拒绝",
      "systemActor": "系统",
      "unknownUser": "未知用户",
      "wholeRun": "整个运行"
    },
    "graphTablePreview": {
      "addedInVersionLegend": "在 v{{version}} 中新增",
      "alreadyThereLegend": "已存在",
      "askTheGraphDescription": "用自然语言提问，问题会被转换为图谱查询。",
      "askTheGraphTitle": "向图谱提问",
      "back": "返回",
      "backToDataAriaLabel": "返回数据",
      "chatAssistantAriaLabel": "图谱聊天助手",
      "chatDisabledLabel": "聊天不可用",
      "chatDisabledTooltip": "此租户未配置任何 LLM 模型，因此图谱聊天不可用。",
      "chatInputPlaceholder": "针对此图谱提问…",
      "chatWelcomeMessage": "向我提问这个图谱的相关问题，我会为您查询。",
      "collapse": "收起",
      "collapseChatAriaLabel": "收起聊天",
      "commitLegendAriaLabel": "提交版本图例",
      "commitOptionPlain": "v{{version}}{{whenSuffix}}",
      "commitOptionWithMessage": "v{{version}} — {{message}}{{whenSuffix}}",
      "commitVersionPlaceholder": "选择版本",
      "couldNotBuildQueryMessage": "无法将其转换为图谱查询，请尝试换一种方式提问。",
      "defaultGraphTitle": "图谱预览",
      "expandChatAriaLabel": "展开聊天",
      "graphCanvasAriaLabel": "图谱画布",
      "graphContextAriaLabel": "图谱上下文",
      "graphSchemaAriaLabel": "图谱模式",
      "highlightingMatchesMessage": "正在高亮显示{{nodesPart}}和{{relsPart}}。",
      "latestLiveOption": "最新（实时）",
      "matchedNodesPart_one": "{{count}} 个匹配节点",
      "matchedNodesPart_other": "{{count}} 个匹配节点",
      "matchedRelationshipsPart_one": "{{count}} 个匹配关系",
      "matchedRelationshipsPart_other": "{{count}} 个匹配关系",
      "missingTableIdMessage": "未指定图谱表。",
      "modelLabel": "模型",
      "modelLabelLoading": "正在加载模型…",
      "newestCommitMatchesLatestNotice": "版本 {{version}} 是最新提交，因此此视图与实时图谱一致。",
      "noCommitStampsNotice": "此图谱没有提交版本标记，因此无法按版本筛选。",
      "noModelsConfiguredPlaceholder": "未配置模型",
      "noNodesMatchedMessage": "没有与您的问题匹配的节点。",
      "nothingToResetTooltip": "没有可重置的内容",
      "reset": "重置",
      "resetViewTooltip": "重置为完整图谱视图",
      "schemaLabel": "模式",
      "searchModelsPlaceholder": "搜索模型…",
      "selectModelPlaceholder": "选择模型",
      "send": "发送",
      "showSchemaPanelAriaLabel": "显示模式面板",
      "showSchemaTooltip": "显示模式面板",
      "statusAsOfVersion": "截至 v{{version}}",
      "statusHighlighted": "已高亮",
      "statusSample": "样本",
      "thinking": "思考中…",
      "unexpectedResponseMessage": "该查询未返回图谱数据，请尝试换一种方式提问。",
      "updatedGraphFallbackMessage": "这是更新后的图谱。",
      "viewCommitVersionTooltip": "查看特定的提交版本",
      "wrongTableTypeError": "此表不是图谱表。"
    },
    "graphSchemaPanel": {
      "collapseAriaLabel": "收起模式面板",
      "collapseTooltip": "收起模式面板",
      "defaultEngineName": "图数据库",
      "deselectAll": "取消全选",
      "edgesLabel": "边",
      "emptyLabelTooltip": "此版本中没有 {{label}} 节点",
      "engineLabel": "引擎",
      "graphDetailsTitle": "图谱详情",
      "labelCountTooltip_one": "{{count}} 个 {{label}} 节点",
      "labelCountTooltip_other": "{{count}} 个 {{label}} 节点",
      "labelsTitle": "标签",
      "nodesLabel": "节点",
      "notAvailable": "不可用",
      "relationshipsTitle_one": "关系（{{count}}）",
      "relationshipsTitle_other": "关系（{{count}}）",
      "schemaTitle": "模式",
      "selectAll": "全选",
      "selectLabelsEmptyState": "请至少选择一个标签以查看其关系。",
      "snapshotLabel": "快照"
    },
    "graphWebglCanvas": {
      "layingOutGraphAriaLabel": "正在布局图谱…"
    },
    "neo4jGraphView": {
      "canvasControlsAriaLabel": "画布控件",
      "clearSearchAriaLabel": "清除搜索",
      "closeDetailsAriaLabel": "关闭详情",
      "closeDetailsKeepHighlightTooltip": "关闭（保留高亮）",
      "closeDetailsTooltip": "关闭",
      "fitToViewTooltip": "适配视图",
      "focusHintAfter": "以重置焦点。",
      "focusHintBefore": "已聚焦于单个节点 — 使用",
      "genericNodeLabel": "节点",
      "hiddenPropertiesFoot_one": "还有 {{count}} 个属性未显示",
      "hiddenPropertiesFoot_other": "还有 {{count}} 个属性未显示",
      "lodHintDefault": "放大以查看详情",
      "noMatchingNodes": "没有匹配的节点",
      "nodeDetailsAriaLabel": "{{name}} 的详情",
      "relationshipDetailsAriaLabel": "关系详情",
      "resetFocusTooltip": "重置焦点",
      "searchAriaLabel": "搜索节点",
      "searchPlaceholder": "搜索节点…",
      "searchingEllipsis": "搜索中…",
      "zoomInTooltip": "放大",
      "zoomOutTooltip": "缩小"
    },
    "vectorTab": {
      "actionDelete": "删除",
      "actionEdit": "编辑",
      "actionPreviewData": "预览数据",
      "actionRemoveAsDefault": "取消默认",
      "actionSetAsDefault": "设为默认",
      "actionSync": "同步",
      "actionVectorSearch": "向量搜索",
      "actionViewDetails": "查看详情",
      "addVectorDbTableButton": "添加向量数据库表",
      "allLabel": "全部",
      "andOthersLabel_one": "{{names}} 及另外 {{count}} 个",
      "andOthersLabel_other": "{{names}} 及另外 {{count}} 个",
      "bulkActionDeleteSelected": "删除所选",
      "bulkActionSyncMetadata": "同步元数据",
      "bulkDeletePartialWarning": "已删除 {{deleted}} 个，跳过 {{skipped}} 个：{{errors}}",
      "bulkDeleteSuccessToast_one": "已删除 {{count}} 张表",
      "bulkDeleteSuccessToast_other": "已删除 {{count}} 张表",
      "bulkSyncStartedRequeuedToast_one": "已为 {{count}} 张表重新排队元数据同步",
      "bulkSyncStartedRequeuedToast_other": "已为 {{count}} 张表重新排队元数据同步",
      "bulkSyncStartedToast_one": "已为 {{count}} 张表启动元数据同步",
      "bulkSyncStartedToast_other": "已为 {{count}} 张表启动元数据同步",
      "clearDefaultErrorToast": "取消 {{name}} 的默认状态失败",
      "collectionViewTooltip": "集合视图",
      "columnActions": "操作",
      "columnCreator": "创建者",
      "columnDatabase": "数据库",
      "columnEmbeddingModel": "嵌入模型",
      "columnIntrospection": "内省",
      "columnLogs": "日志",
      "columnName": "名称",
      "columnStatus": "状态",
      "columnVectors": "向量数",
      "databaseViewTooltip": "数据库视图",
      "defaultBadgeTooltip": "默认表",
      "defaultSchemaLabel": "默认",
      "deleteConfirmLabel": "删除",
      "deleteNamespaceConfirmMessage_one": "确定要删除命名空间 {{schema}} 及其下已注册的 {{count}} 张表吗？此操作仅移除 {{brand}} 元数据，且无法撤销。",
      "deleteNamespaceConfirmMessage_other": "确定要删除命名空间 {{schema}} 及其下已注册的 {{count}} 张表吗？此操作仅移除 {{brand}} 元数据，且无法撤销。",
      "deleteNamespacePartialWarning": "已删除 {{schemaCount}} 个命名空间中的 {{deleted}} 个，跳过 {{skipped}} 个",
      "deleteNamespaceSuccessToast_one": "已删除命名空间（移除 {{count}} 张表）",
      "deleteNamespaceSuccessToast_other": "已删除命名空间（移除 {{count}} 张表）",
      "deleteNamespaceSuccessToastNamed_one": "已删除命名空间 {{schema}}（移除 {{count}} 张表）",
      "deleteNamespaceSuccessToastNamed_other": "已删除命名空间 {{schema}}（移除 {{count}} 张表）",
      "deleteNamespaceTitle": "删除命名空间",
      "deleteNamespacesConfirmMessage_one": "确定要删除 {{namespaceCount}} 个命名空间及其下已注册的 {{count}} 张表吗？此操作仅移除 {{brand}} 元数据，且无法撤销。",
      "deleteNamespacesConfirmMessage_other": "确定要删除 {{namespaceCount}} 个命名空间及其下已注册的 {{count}} 张表吗？此操作仅移除 {{brand}} 元数据，且无法撤销。",
      "deleteNamespacesCountLabel_one": "删除 {{count}} 个命名空间",
      "deleteNamespacesCountLabel_other": "删除 {{count}} 个命名空间",
      "deleteNamespacesSuccessToast_one": "已删除 {{schemaCount}} 个命名空间（移除 {{count}} 张表）",
      "deleteNamespacesSuccessToast_other": "已删除 {{schemaCount}} 个命名空间（移除 {{count}} 张表）",
      "deleteNamespacesTitle": "删除命名空间",
      "deleteSelectedTablesConfirmMessage_one": "确定要删除所选的 {{count}} 张表吗？此操作无法撤销。",
      "deleteSelectedTablesConfirmMessage_other": "确定要删除所选的 {{count}} 张表吗？此操作无法撤销。",
      "deleteSelectedTablesTitle": "删除所选表",
      "deleteTableConfirmMessage": "确定要删除 {{name}} 吗？此操作无法撤销。",
      "deleteTableConfirmTitle": "删除表",
      "deleteTablesCountLabel_one": "删除 {{count}} 张表",
      "deleteTablesCountLabel_other": "删除 {{count}} 张表",
      "deletingLabel": "正在删除…",
      "favoritesLabel": "收藏",
      "filterAllCreatorsPlaceholder": "所有创建者",
      "filterAllEnginesPlaceholder": "所有引擎",
      "filterCreatorLabel": "创建者",
      "filterEngineLabel": "引擎",
      "namespacesTitle": "命名空间",
      "noConnectorsYet": "暂无连接器",
      "notConfigured": "未配置",
      "setDefaultErrorToast": "将 {{name}} 设为默认失败",
      "syncMetadataErrorToast": "同步 {{name}} 的元数据失败",
      "syncStatus": {
        "active": "已启用",
        "failed": "失败",
        "inactive": "未启用",
        "queued": "排队中",
        "running": "运行中",
        "synced": "已同步"
      },
      "unknownConnectorType": "未知",
      "unknownCreator": "未知",
      "vectorDbExplorerAriaLabel": "向量数据库浏览器",
      "vectorTablesLeafTitle": "向量表",
      "vectorTablesLeafTitleWithSchema": "向量表 — {{schema}}",
      "viewLink": "查看",
      "viewSyncLogsTooltip": "查看同步日志",
      "resourceVectorDatabases": "向量数据库",
      "resourceVectorDatabase": "向量数据库"
    },
    "vectorSearchModal": {
      "advancedRagLabel": "高级 RAG",
      "closeDialogAriaLabel": "关闭",
      "contentLabel": "内容",
      "coverageLabel": "覆盖率",
      "embeddingModelLabel": "嵌入模型",
      "enhancementsLabel": "增强功能",
      "foundResultsPrefix": "找到",
      "hideButton": "隐藏",
      "hydeEnhancementLabel": "HyDE（假设文档嵌入）",
      "idFallbackLabel": "结果 {{id}}",
      "latencyMs": "{{ms}} 毫秒",
      "loadingOption": "加载中…",
      "metadataLabel": "元数据",
      "missingAspectsLabel": "缺失的方面：{{aspects}}",
      "modelDefaultLabel": "{{name}}（默认）",
      "modelLabel": "模型：{{name}}",
      "modelsWordBold": "模型",
      "multiQueryExpansionLabel": "多查询扩展",
      "noEmbeddingModelsOption": "没有可用的嵌入模型",
      "noModelRegisteredBody": "要在此表上运行向量搜索，请注册一个或多个",
      "noModelRegisteredBold": "尚未注册嵌入模型。",
      "noModelRegisteredSuffix": "用于嵌入，或切换到高级 RAG。",
      "noResultsBasicHint": "请尝试其他搜索查询或检查您的嵌入模型。",
      "noResultsFoundTitle": "未找到结果",
      "noResultsRagHint": "请尝试改写查询或调整 RAG 策略。",
      "qualityLabel": "质量：",
      "ragSearchButton": "RAG 搜索",
      "ragSearchingButton": "搜索中…",
      "ragStrategyConfigTitle": "RAG 策略配置",
      "registerModelFirstTooltip": "请先注册一个嵌入模型",
      "relevanceLabel": "相关性：",
      "rerankingLabel": "重排序",
      "resultFallbackLabel": "结果 {{index}}",
      "resultsInLatencyMiddle": "个结果，耗时",
      "resultsLabel": "结果数：",
      "resultsSuffix": "个结果",
      "searchButton": "搜索",
      "searchFailedTitle": "搜索失败",
      "searchModelsPlaceholder": "搜索模型…",
      "searchPlaceholder": "输入您的搜索查询…",
      "searchingButton": "搜索中…",
      "selfCorrectedBadge_one": "已自我修正（{{count}} 次尝试）",
      "selfCorrectedBadge_other": "已自我修正（{{count}} 次尝试）",
      "selfRagCorrectionLabel": "Self-RAG 校正",
      "semanticSearchBody": "在上方输入查询以搜索此表的向量嵌入。",
      "semanticSearchTitle": "语义搜索",
      "settingsButton": "设置",
      "strategyAutoOption": "自动",
      "strategyDecompositionOption": "分解",
      "strategyDescriptionAuto": "自动为您的查询选择最佳检索策略。",
      "strategyDescriptionDecomposition": "将复杂查询拆解为子问题，并分别进行检索。",
      "strategyDescriptionDirect": "直接使用原始查询文本进行搜索。",
      "strategyDescriptionHyde": "先生成一个假设性答案，再使用其嵌入进行搜索。",
      "strategyDescriptionMultiQuery": "生成多个查询变体以扩大检索覆盖范围。",
      "strategyDirectOption": "直接",
      "strategyHydeOption": "HyDE",
      "strategyLabel": "策略",
      "strategyMultiQueryOption": "多查询",
      "title": "向量搜索",
      "useDefaultOption": "使用默认值"
    },
    "storageTab": {
      "actionDelete": "删除",
      "actionExport": "导出",
      "actionPreviewFiles": "预览文件",
      "actionSetAsDefault": "设为默认",
      "actionSync": "同步",
      "actionSyncing": "同步中…",
      "actionViewDetails": "查看详情",
      "addStorageButton": "添加存储",
      "allLabel": "全部",
      "columnActions": "操作",
      "columnConnector": "连接器",
      "columnContainer": "容器",
      "columnCreated": "创建时间",
      "columnFolder": "文件夹",
      "columnLogs": "日志",
      "columnStatus": "状态",
      "columnUpdated": "更新时间",
      "defaultBadgeTooltip": "默认文件夹",
      "defaultBucketLabel": "默认",
      "defaultConnectorName": "未知连接器",
      "deleteConfirmLabel": "删除",
      "deleteConfirmMessage": "确定要删除 {{name}} 吗？此操作无法撤销。",
      "deleteConfirmTitle": "删除存储文件夹",
      "emptyMessage": "未找到存储文件夹",
      "exportSelectedAction": "导出所选",
      "favoritesLabel": "收藏",
      "filterAllCreatorsPlaceholder": "所有创建者",
      "filterAllTypesPlaceholder": "所有类型",
      "filterCreatorLabel": "创建者",
      "filterStorageTypeLabel": "存储类型",
      "foldersLeafTitle": "文件夹",
      "foldersLeafTitleWithBucket": "文件夹 — {{bucket}}",
      "listViewTooltip": "列表视图",
      "noConnectorsYet": "暂无连接器",
      "pendingBadge": "待处理",
      "setDefaultErrorToast": "将 {{name}} 设为默认失败",
      "setDefaultSuccessToast": "已将 {{name}} 设为默认",
      "splitViewTooltip": "分栏视图",
      "statusActive": "已启用",
      "statusApproved": "已批准",
      "statusRequested": "已申请",
      "statusUnknown": "未知",
      "storageExplorerAriaLabel": "存储浏览器",
      "unknownConnectorType": "未知",
      "viewLink": "查看",
      "viewSyncLogsTooltip": "查看同步日志"
    },
    "storageViewModal": {
      "auditInformationSectionTitle": "审计信息",
      "basicInformationSectionTitle": "基本信息",
      "closeButton": "关闭",
      "closeDialogAriaLabel": "关闭",
      "errorInformationSectionTitle": "错误信息",
      "fieldBucketName": "存储桶名称",
      "fieldConnector": "连接器",
      "fieldCreatedAt": "创建时间",
      "fieldCreatedBy": "创建者",
      "fieldErrorMessage": "错误信息",
      "fieldFileCount": "文件数量",
      "fieldFolderPath": "文件夹路径",
      "fieldId": "ID",
      "fieldStatus": "状态",
      "fieldTotalSize": "总大小",
      "fieldUpdatedAt": "更新时间",
      "fieldUpdatedBy": "更新者",
      "metadataSectionTitle": "元数据",
      "noErrors": "没有错误",
      "notAvailable": "不适用",
      "status": {
        "active": "已启用",
        "error": "错误",
        "syncing": "同步中",
        "unknown": "未知"
      },
      "storageInformationSectionTitle": "存储信息",
      "title": "存储文件夹详情"
    },
    "storageFolderPreview": {
      "actionsTooltip": "操作",
      "cancelButton": "取消",
      "clearSearchAriaLabel": "清除搜索",
      "clearSelectionAriaLabel": "清除选择",
      "closeDialogAriaLabel": "关闭",
      "columnActions": "操作",
      "columnModified": "修改时间",
      "columnName": "名称",
      "columnSize": "大小",
      "columnType": "类型",
      "downloadErrorToast": "文件下载失败",
      "downloadResultAllFailed": "所选文件均未能下载。",
      "downloadResultAllSuccess": "全部 {{count}} 个文件已成功下载。",
      "downloadResultOk": "确定",
      "downloadResultPartial": "已成功下载 {{total}} 个中的 {{successCount}} 个文件。失败：{{failedNames}}",
      "downloadResultTitleFailed": "下载失败",
      "downloadResultTitlePartial": "下载未完成",
      "downloadResultTitleSuccess": "下载完成",
      "downloadSelectedButton": "下载所选",
      "downloadSelectedTooltip": "下载所选文件",
      "downloadingSelectedButton": "正在下载…",
      "emptySearchState": "没有与搜索匹配的文件",
      "emptyState": "此文件夹中没有文件",
      "exportAction": "下载",
      "firstPageTooltip": "首页",
      "lastPageTooltip": "末页",
      "nextPageTooltip": "下一页",
      "openingFileLabel": "正在打开文件…",
      "paginationInfo": "显示第 {{from}}–{{to}} 条，共 {{total}} 条",
      "previousPageTooltip": "上一页",
      "searchPlaceholder": "搜索文件…",
      "selectAllAriaLabel": "全选文件",
      "selectFileAriaLabel": "选择 {{name}}",
      "selectedCount": "已选择 {{count}} 个",
      "selectionLimitWarning": "一次最多只能选择 10 个文件。",
      "syncButtonLabel": "同步",
      "syncButtonTooltip": "同步此文件夹中的文件",
      "syncingButtonLabel": "同步中…",
      "viewAction": "预览"
    },
    "storageFilePreview": {
      "closeDialogAriaLabel": "关闭",
      "downloadButton": "下载",
      "downloadErrorToast": "文件下载失败",
      "emptyTable": "没有可显示的行",
      "imagePreviewAlt": "图片预览",
      "loadErrorToast": "文件预览失败",
      "loadingDocument": "正在加载文档…",
      "loadingPresentation": "正在加载演示文稿…",
      "nullValueLabel": "NULL",
      "pdfPreviewTitle": "PDF 预览",
      "pptxPreviewTitle": "PowerPoint 预览",
      "rowsUnit": "行",
      "textPreviewAriaLabel": "文件内容",
      "tryAgainButton": "重试",
      "unableToLoadTitle": "无法预览文件",
      "unsupportedHint": "此文件类型无法在浏览器中预览。请下载后打开。",
      "unsupportedTitle": "无法预览"
    },
    "groupedStorageView": {
      "bucketPathTooltip": "{{bucket}}/{{path}}",
      "createdTooltip": "创建时间",
      "emptyState": "未找到存储文件夹",
      "emptyStateHint": "请尝试其他搜索词",
      "fileCount_one": "{{count}} 个文件",
      "fileCount_other": "{{count}} 个文件",
      "folderCount_one": "{{count}} 个文件夹",
      "folderCount_other": "{{count}} 个文件夹",
      "loadingFolders": "正在加载文件夹…",
      "unknownConnectorName": "未知连接器",
      "updatedTooltip": "更新时间"
    },
    "metadataSyncLogsModal": {
      "bulkJobLabel": "批量任务",
      "closeAriaLabel": "关闭",
      "collapseDetailAriaLabel": "收起详情",
      "columnMessage": "消息",
      "columnStatus": "状态",
      "columnWhen": "时间",
      "emptyState": "未找到同步日志",
      "entryCount_one": "{{count}} 条记录",
      "entryCount_other": "{{count}} 条记录",
      "expandDetailAriaLabel": "展开详情",
      "loadingLogs": "正在加载日志…",
      "title": "元数据同步日志",
      "triggerLabel": "触发方式："
    },
    "bulkMetadataSyncModal": {
      "closeAriaLabel": "关闭",
      "columnDetail": "详情",
      "columnStatus": "状态",
      "columnTable": "表",
      "jobLabel": "任务",
      "loadingStatus": "正在加载同步状态…",
      "noJobData": "没有可用的任务数据",
      "requeuedToast_one": "已将 {{count}} 个项目重新排队以重试",
      "requeuedToast_other": "已将 {{count}} 个项目重新排队以重试",
      "retryFailedButton_one": "重试 {{count}} 个失败项",
      "retryFailedButton_other": "重试 {{count}} 个失败项",
      "title": "批量元数据同步"
    },
    "tableDataPreview": {
      "loadErrorToast": "加载表数据失败",
      "nullValueLabel": "NULL",
      "columnEdit": "编辑",
      "editGoldenAnswerAriaLabel": "编辑标准答案",
      "csvExportedToast_other": "已将 {{count}} 行导出为 CSV",
      "jsonExportedToast_other": "已将 {{count}} 行导出为 JSON",
      "previewNotAvailable": "此数据源不支持预览",
      "vertexAiDataStoreHint": "此表基于 Vertex AI Search 数据存储区。请直接查询该数据存储区以查看预览。",
      "vertexAiVectorSearchHint": "此表基于 Vertex AI Vector Search 索引。请运行向量搜索查询以查看预览。",
      "closeDialogAriaLabel": "关闭",
      "unableToLoadTitle": "无法加载数据",
      "dataUnavailableTitle": "数据不可用",
      "syncingButton": "同步中…",
      "refreshMetadataButton": "刷新元数据",
      "tryAgainButton": "重试",
      "documentsUnit": "文档",
      "rowsUnit": "行",
      "elasticsearchSearchPlaceholder": "使用 Lucene 查询语法搜索…",
      "searchPlaceholder": "搜索…",
      "clearSearchAriaLabel": "清除搜索",
      "luceneQueryHintTitle": "支持 Lucene 查询语法，例如 field:value AND other:value",
      "paginationFullTextSearchHint": "全文搜索会应用于所有列",
      "tableViewTitle": "表格视图",
      "tableTab": "表格",
      "graphViewTitle": "图谱视图",
      "graphTab": "图谱",
      "documentViewJsonTitle": "文档视图（JSON）",
      "documentsTab": "文档",
      "tabularViewTitle": "表格视图",
      "exportJsonButton": "导出 JSON",
      "exportingButton": "导出中…",
      "exportCsvButton": "导出 CSV",
      "documentFallbackLabel": "文档 {{index}}",
      "statusLabel": "状态：{{status}}",
      "hideJsonButton": "隐藏 JSON",
      "showJsonButton": "显示 JSON",
      "noPreviewFieldsHint": "此文档未配置预览字段。",
      "pageOfLabel": "第 {{page}} 页，共 {{totalPages}} 页",
      "pageSizeLabel": "每页行数",
      "previousButton": "上一页",
      "nextButton": "下一页",
      "noDataFoundEmptyMessage": "未找到数据"
    },
    "ontology": {
      "retrievalConfigPanel": {
        "strategyAuto": "自动",
        "strategyAutoDescription": "根据查询自动选择最佳检索策略",
        "strategyVector": "向量搜索",
        "strategyVectorDescription": "通过对嵌入向量进行语义相似度搜索来检索结果",
        "strategySql": "SQL",
        "strategySqlDescription": "通过生成并对该表执行 SQL 查询来检索结果",
        "strategyHybrid": "混合",
        "strategyHybridDescription": "结合向量搜索与关键词/SQL 搜索以获得更准确的结果",
        "fusionMethodRrf": "倒数排名融合（RRF）",
        "fusionMethodRrfDescription": "使用倒数排名融合方法合并排序后的结果列表",
        "fusionMethodWeighted": "加权求和",
        "fusionMethodWeightedDescription": "通过对向量结果和关键词结果加权求和来合并分数",
        "fusionMethodCascade": "级联",
        "fusionMethodCascadeDescription": "先执行关键词搜索，再用向量搜索重新排序",
        "distanceMetricCosine": "余弦",
        "distanceMetricEuclidean": "欧几里得",
        "distanceMetricDotProduct": "点积",
        "title": "检索配置",
        "resetToDefaultsTitle": "恢复默认设置",
        "resetButton": "重置",
        "defaultStrategyLabel": "默认检索策略",
        "vectorSearchSettingsLabel": "向量搜索设置",
        "idColumnLabel": "ID 列",
        "autoDetectOption": "自动检测",
        "contentColumnLabel": "内容列",
        "embeddingColumnLabel": "嵌入列",
        "distanceMetricLabel": "距离度量",
        "hybridFusionSettingsLabel": "混合融合设置",
        "fusionMethodLabel": "融合方法",
        "weightDistributionLabel": "权重分配",
        "vectorSliderLabel": "向量权重",
        "keywordSliderLabel": "关键词权重",
        "sqlSettingsLabel": "SQL 设置",
        "maxRowsLabel": "返回的最大行数",
        "enableFullTextSearchLabel": "启用全文搜索",
        "rerankingLabel": "重排序",
        "enableCrossEncoderRerankingLabel": "启用交叉编码器重排序",
        "rerankingModelLabel": "重排序模型",
        "loadingModelsOption": "正在加载模型…",
        "noRegisteredModelsOption": "没有已注册的模型",
        "rerankTopKLabel": "重排序 Top K",
        "infoCardText": "这些设置控制在 RAG 查询期间如何检索此表。更改将在下次查询此表时生效。"
      },
      "columnEditor": {
        "semanticTypeId": "标识符",
        "semanticTypeIdDescription": "唯一标识一条记录（例如主键）",
        "semanticTypeEntity": "实体",
        "semanticTypeEntityDescription": "指代具名的人物、地点或事物",
        "semanticTypeMetric": "指标",
        "semanticTypeMetricDescription": "用于聚合或度量的数值",
        "semanticTypeDimension": "维度",
        "semanticTypeDimensionDescription": "用于分组或筛选的分类属性",
        "semanticTypeTimestamp": "时间戳",
        "semanticTypeTimestampDescription": "日期或时间值",
        "semanticTypeText": "文本",
        "semanticTypeTextDescription": "自由格式的文本内容",
        "closeEditorTitle": "关闭编辑器",
        "businessNameLabel": "业务名称",
        "businessNameHint": "该列的易懂名称",
        "businessNamePlaceholder": "例如：客户姓名",
        "descriptionLabel": "描述",
        "descriptionHint": "说明该列代表的含义",
        "descriptionPlaceholder": "例如：客户的完整法定姓名",
        "semanticTypeLabel": "语义类型",
        "semanticTypeHint": "对该列所包含的数据类型进行分类",
        "exampleValuesLabel": "示例值",
        "exampleValuesHint": "有助于他人理解该列的示例值",
        "addExamplePlaceholder": "添加示例值",
        "constraintsLabel": "约束",
        "constraintsHint": "该列的业务规则或验证约束",
        "constraintsPlaceholder": "例如：不能为空",
        "relationshipsLabel": "关系",
        "relationshipsHint": "与该列相关的其他表或列",
        "tableNamePlaceholder": "表名",
        "columnNamePlaceholder": "列名",
        "relationshipTypeForeignKey": "外键",
        "relationshipTypeReference": "引用",
        "addRelationshipButton": "添加关系",
        "searchSettingsLabel": "搜索设置",
        "searchSettingsHint": "控制该列在搜索和检索中的使用方式",
        "searchableLabel": "可搜索",
        "searchableHint": "在全文和关键词搜索中包含该列",
        "embedForVectorSearchLabel": "为向量搜索生成嵌入",
        "embedForVectorSearchHint": "为该列生成嵌入向量以支持语义搜索"
      },
      "tableDescriptionEditor": {
        "tablePurposeLabel": "表用途",
        "tablePurposeHelp": "描述此表的用途",
        "tablePurposePlaceholder": "例如：存储客户订单历史以供报表使用",
        "businessContextLabel": "业务背景",
        "businessContextHelp": "说明业务背景以及此表在整体数据模型中的作用",
        "businessContextPlaceholder": "例如：供销售团队跟踪订单履行情况",
        "sampleQuestionsLabel": "示例问题",
        "sampleQuestionsHelp": "此表可以帮助回答的示例问题",
        "removeQuestionTitle": "移除问题",
        "addQuestionPlaceholder": "添加示例问题",
        "addQuestionTitle": "添加问题",
        "addButton": "添加",
        "tipsTitle": "提示",
        "tip1": "明确说明该表包含的内容以及使用者。",
        "tip2": "包含用户可能搜索的业务术语。",
        "tip3": "添加示例问题以帮助检索模型匹配相关查询。",
        "tip4": "描述应简洁但信息充分。"
      },
      "schemaVisualizer": {
        "semanticTypeId": "标识符",
        "semanticTypeTimestamp": "时间戳",
        "semanticTypeMetric": "指标",
        "semanticTypeDimension": "维度",
        "semanticTypeEntity": "实体",
        "semanticTypeText": "文本",
        "groupPrimaryKeys": "主键",
        "groupForeignKeys": "外键",
        "groupTimestamps": "时间戳",
        "groupMetrics": "指标",
        "groupDimensions": "维度",
        "groupOther": "其他",
        "subtitle": "表列及其关系的可视化概览",
        "columnCount": "{{count}} 列",
        "columnCount_other": "{{count}} 列",
        "hasOntologyLegend": "已定义本体",
        "foreignKeyLegend": "外键"
      }
    },
    "tableOntologyPage": {
      "noTableIdError": "未提供表 ID",
      "saveSuccessToast": "本体保存成功",
      "saveErrorToast": "本体保存失败：{{message}}",
      "unsavedChangesConfirm": "您有尚未保存的更改，确定要离开吗？",
      "loadingMessage": "正在加载表本体…",
      "schemaEditorUnavailableTitle": "架构编辑器不可用",
      "schemaEditorUnavailableMessage": "此表的连接器类型不支持架构编辑器。",
      "failedToLoadTitle": "加载表失败",
      "tableNotFoundMessage": "找不到请求的表。",
      "goBack": "返回",
      "backToKnowledgeTooltip": "返回 Knowledge",
      "breadcrumbKnowledge": "Knowledge",
      "breadcrumbTables": "表",
      "breadcrumbOntology": "本体",
      "vectorBadge": "向量",
      "unsavedChangesBadge": "有未保存的更改",
      "resetToSavedTooltip": "恢复到最后保存的版本",
      "reset": "重置",
      "saving": "保存中…",
      "saveChanges": "保存更改",
      "schemaPanelTitle": "架构",
      "databaseLabel": "数据库",
      "schemaLabel": "架构",
      "tableLabel": "表",
      "rowsLabel": "行数",
      "embeddingModelTitle": "嵌入模型",
      "loadingModels": "正在加载模型…",
      "noEmbeddingModelsWarning": "未注册任何嵌入模型。请注册一个以便为该表启用向量搜索。",
      "selectModelOption": "选择模型",
      "modelOptionDefaultLabel": "{{name}}（默认）",
      "modelOptionLabel": "{{name}}",
      "noModelSelectedWarning": "未选择嵌入模型。该表将无法使用向量搜索。",
      "columnsHeader": "列",
      "hasOntologyDefinedTooltip": "此列已定义本体",
      "tabDescription": "描述",
      "tabRetrieval": "检索",
      "tabTest": "测试",
      "queryTestingTitle": "查询测试",
      "queryTestingDescription": "测试根据该表的配置如何检索查询。",
      "comingSoon": "即将推出"
    },
    "mongoCompassDocumentView": {
      "documentViewTitle": "文档视图",
      "documentsTab": "文档",
      "tabularViewTitle": "表格视图",
      "tableTab": "表格",
      "exportDataButton": "导出数据",
      "closeAriaLabel": "关闭",
      "filterLabel": "筛选",
      "filterPlaceholder": "例如：{ status: \"active\" }",
      "filterInputAriaLabel": "筛选查询",
      "clearFilterAriaLabel": "清除筛选",
      "applyFilterTitle": "应用筛选",
      "findButton": "查找",
      "queryHint": "以 JSON 格式输入 MongoDB 查询过滤条件",
      "documentCountLabel": "{{count}} 个文档",
      "documentCountLabel_other": "{{count}} 个文档",
      "zeroResults": "无结果",
      "pageRangeHint": "第 {{from}}–{{to}} 项，共 {{total}} 项",
      "documentFallbackLabel": "文档 {{index}}",
      "hideDocumentAriaLabel": "隐藏文档",
      "showDocumentAriaLabel": "显示文档",
      "skipLimitLabel": "跳过：{{skip}}，限制：{{limit}}",
      "pageSizeLabel": "每页大小",
      "pageSizeSelectAriaLabel": "选择每页大小",
      "previousButton": "上一页",
      "nextButton": "下一页"
    }
  },
  "accessRequests": {
    "manageAccessTitle": "管理{{assetLabel}}访问权限",
    "assetTypeLabels": {
      "models": "模型",
      "tools": "工具",
      "knowledge": "知识",
      "storage": "存储",
      "skills": "技能",
      "orchestrators": "编排器",
      "default": "资产"
    },
    "statusLabels": {
      "requested": "待处理",
      "approved": "已批准",
      "open": "已撤销"
    },
    "loadingRequests": "正在加载访问请求...",
    "clearSearch": "清除搜索",
    "emptyStateAll": "没有{{assetType}}的访问请求。",
    "emptyStateFiltered": "没有{{assetType}}的{{status}}访问请求。",
    "selectedCount": "已选择{{count}}项",
    "selectAll": "全选",
    "deselectAll": "取消全选",
    "approveSelected": "批准所选项 ({{count}})",
    "rejectSelected": "拒绝所选项 ({{count}})",
    "columnAssetName": "资产名称",
    "columnProject": "项目",
    "columnRequestedBy": "请求人",
    "columnStatus": "状态",
    "columnCreated": "创建时间",
    "columnLastUpdated": "最后更新",
    "columnActions": "操作",
    "approve": "批准",
    "reject": "拒绝",
    "reApprove": "重新批准",
    "revokeAccess": "撤销访问权限",
    "rowsPerPage": "每页行数：",
    "showingRange": "显示第{{start}}-{{end}}项，共{{total}}项",
    "goToFirstPage": "转到第一页",
    "goToPreviousPage": "转到上一页",
    "goToPage": "转到第{{page}}页",
    "goToNextPage": "转到下一页",
    "goToLastPage": "转到最后一页",
    "firstPage": "第一页",
    "previousPage": "上一页",
    "nextPage": "下一页",
    "lastPage": "最后一页",
    "endOfTableReached": "已到达表格末尾",
    "statusFilterLabel": "状态",
    "statusFilterPlaceholder": "状态",
    "projectFilterLabel": "项目",
    "projectFilterPlaceholder": "项目",
    "requestedByFilterLabel": "请求人",
    "requestedByFilterPlaceholder": "请求人",
    "bulkApprovePartial": "已批准{{processed}}个；{{skipped}}个失败：{{errors}}",
    "bulkRejectPartial": "已拒绝{{processed}}个；{{skipped}}个失败：{{errors}}"
  },
  "skills": {
    "title": "技能 (Skills)",
    "subtitle": "技能是增强代理能力的模块化指令包。",
    "list": {
      "columns": {
        "name": "技能名称",
        "category": "类别",
        "type": "类型",
        "model": "模型",
        "visibility": "可见性",
        "version": "版本",
        "access": "访问权限",
        "updated": "更新时间",
        "actions": "操作"
      },
      "actions": {
        "view": "查看",
        "edit": "编辑",
        "delete": "删除",
        "export": "导出",
        "clone": "克隆到项目",
        "manageAccess": "管理访问权限",
        "exportSelected": "导出所选",
        "deleteSelected": "删除所选"
      },
      "badges": {
        "builtin": "内置",
        "platform": "平台",
        "allModels": "所有模型"
      },
      "bulkDelete": {
        "title": "删除选定的技能",
        "noSelection": "未选择任何技能",
        "cannotDeleteBuiltin": "无法删除内置平台技能",
        "skippedBuiltin": "将跳过 {{count}} 个内置技能。",
        "success": "成功删除 {{count}} 个技能",
        "partial": "删除了 {{deleted}} 个技能，{{skipped}} 个失败：{{errors}}",
        "error": "删除技能失败"
      }
    },
    "categories": {
      "data_processing": "数据处理",
      "data_analysis": "数据分析",
      "reasoning": "推理",
      "code_generation": "代码生成",
      "document_analysis": "文档分析",
      "web_interaction": "Web 交互",
      "communication": "沟通",
      "research": "研究",
      "automation": "自动化",
      "custom": "自定义"
    },
    "types": {
      "behavioral": "行为",
      "procedural": "程序",
      "knowledge": "知识",
      "guardrail": "护栏",
      "custom": "自定义"
    },
    "visibility": {
      "project": "项目",
      "tenant": "组织",
      "public": "平台"
    },
    "filters": {
      "category": "类别",
      "type": "类型",
      "visibility": "可见性",
      "project": "项目",
      "all": "全部",
      "favorites": "收藏"
    },
    "newSkill": "新技能",
    "loading": "正在加载技能...",
    "empty": {
      "message": "未找到技能。创建您的第一个技能以增强代理能力。"
    },
    "delete": {
      "title": "删除技能",
      "message": "您确定要删除“{{name}}”吗？此操作无法撤销。",
      "bulkMessage": "您确定要删除 {{count}} 个技能吗？此操作无法撤销。",
      "bulkConfirm": "删除 {{count}} 个技能",
      "bulkDepsOthers": "{{names}} 和其他 {{count}} 个"
    },
    "messages": {
      "dependencyCheckFailed": "检查技能依赖项失败",
      "deleteFailed": "删除技能失败"
    },
    "edit": {
      "subtitle": {
        "new": "创建模块化功能",
        "readonly": "技能配置（只读）",
        "edit": "编辑技能配置"
      },
      "sidebar": {
        "settings": "技能设置",
        "tags": "标签",
        "loadingQuota": "正在加载配额..."
      },
      "placeholders": {
        "name": "技能名称",
        "description": "简要描述此技能的功能",
        "instructions": "# 技能指令\n描述此技能提供的特定功能。\n\n## 核心规则\n1. 定义代理应如何表现\n2. 列出分步流程\n3. 指定任何约束\n\n## 示例\n提供预期输出的示例...",
        "project": "选择项目",
        "modelAgnostic": "模型无关（所有模型）"
      },
      "hints": {
        "targetModel": "可选择为此技能添加特定模型标签。未标记的技能兼容所有模型。",
        "visibilityProject": "技能将仅对选定的项目可用。",
        "visibilityPlatform": "技能将通过审批流程对所有项目可用。"
      },
      "editor": {
        "instructions": "指令 (SKILL.md)",
        "markdownSupported": "支持 Markdown",
        "noInstructions": "暂无可预览的指令。"
      },
      "header": {
        "quotaExceeded": "技能配额已超限",
        "createSkill": "创建技能",
        "saveChanges": "保存更改"
      }
    }
  },
  "agentAutoTune": {
    "meta": {
      "breadcrumb": "面包屑导航",
      "agentStudio": "智能体工作室",
      "autoTuneRunsList": "自动调优运行列表",
      "metaDashboard": "元仪表板"
    },
    "compare": {
      "phaseStep": "阶段 / 步骤",
      "score": "分数",
      "metric": "指标",
      "baselineScore": "基线分数",
      "optimizedScore": "优化分数",
      "improvementPct": "提升百分比 %",
      "holdoutScore": "保留分数",
      "costUsd": "成本 (美元)",
      "iterations": "迭代次数",
      "nodesOptimized": "优化的节点",
      "nodesTotal": "总节点",
      "version": "版本",
      "node": "节点",
      "loadingSessions": "正在加载要比较的会话...",
      "selectSessions": "请至少选择2个会话进行比较。",
      "backToRuns": "返回自动调优运行",
      "runComparisonTitle": "运行比较",
      "comparingSessions": "正在比较 {{count}} 个自动调优会话",
      "summaryComparison": "概要比较",
      "noDataToCompare": "没有可比较的数据",
      "scoreTrajectoryOverlay": "分数轨迹叠加",
      "comparingRuns": "比较运行",
      "chartExplainer1": "不用于节点级别的归因。由于不平等的轨迹长度通过索引对齐，",
      "chartExplainer2": "系列中填充了空白。",
      "labelsMatch": "标签匹配最长会话的",
      "phasesBaseline": "阶段，因此如果结构相似，基线 /",
      "validationLinesUp": "验证在各次运行中一致。",
      "notEnoughTrajectory": "没有足够的轨迹数据来绘制图表（在一个会话中至少需要两点）。",
      "nodeLevelScore": "节点级别的分数比较",
      "noNodeDataToCompare": "没有可比较的节点数据",
      "overlayExplainer": "覆盖每次选定运行的综合得分曲线。X轴跟随最长的运行阶段；较短的运行会提前停止。"
    },
    "runs": {
      "title": "智能体自动微调",
      "subtitle": "针对您的智能体进行端到端优化运行",
      "newAutoTune": "新建自动微调",
      "newAutoTuneButton": "新建自动微调",
      "selectProjectAgent": "选择项目和智能体以启动优化",
      "project": "项目",
      "agent": "智能体",
      "proceed": "继续",
      "proceedButton": "继续",
      "startAutoTune": "启动自动微调",
      "metaDashboard": "度量仪表盘",
      "metaDashboardButton": "度量仪表盘",
      "compareSelected": "比较选中项",
      "status": "状态",
      "approval": "审批",
      "optimizer": "优化器",
      "searchPlaceholder": "搜索会话...",
      "backToAgentsAria": "返回智能体列表",
      "loadingMessage": "正在加载自动微调运行...",
      "emptyMessage": "暂无自动微调运行。点击“新建自动微调”开始运行。",
      "statuses": {
        "all": "所有状态",
        "queued": "排队中",
        "running": "运行中",
        "baseline_running": "基线运行",
        "optimizing": "优化中",
        "validating": "验证中",
        "completed": "已完成",
        "completed_partial": "部分完成",
        "failed": "已失败",
        "cancelled": "已取消"
      },
      "approvals": {
        "all": "所有审批",
        "pending": "待审批",
        "approved": "已批准",
        "rejected": "已拒绝"
      },
      "optimizers": {
        "all": "所有优化器"
      },
      "picker": {
        "loadingProjects": "正在加载项目…",
        "selectProject": "选择项目…",
        "selectAgent": "选择智能体…",
        "selectProjectFirst": "请先选择项目…",
        "loadingAgents": "正在加载智能体…",
        "noAgents": "该项目内暂无智能体"
      },
      "columns": {
        "agentName": "智能体名称",
        "dataset": "数据集",
        "optimizer": "优化器",
        "version": "版本",
        "status": "状态",
        "approval": "审批",
        "baselineScore": "基线评分",
        "postTuneScore": "微调后评分",
        "holdout": "留出集评分",
        "improvement": "提升率",
        "trajectory": "轨迹",
        "cost": "花费",
        "nodes": "节点",
        "healing": "自我修复",
        "duration": "时长",
        "createdBy": "创建人",
        "createdAt": "创建时间",
        "actions": "操作",
        "optimizedNodes": "已优化 {{optimized}}/{{total}} 个节点"
      },
      "actions": {
        "compareSelected": "比较选中项",
        "retry": "重试",
        "stopRun": "停止运行",
        "delete": "删除",
        "stopConfirm": "确定要取消“{{label}}”的自动微调吗？这将立即停止管道（Temporal工作流）。",
        "cancelSuccess": "自动微调已取消。",
        "cancelError": "取消自动微调失败。请重试。",
        "deleteConfirm": "确定要删除“{{label}}”的自动微调会话吗？此操作无法撤销。",
        "deleteSuccess": "自动微调会话已删除。",
        "deleteError": "删除会话失败。"
      },
      "retryDialog": {
        "title": "重试自动微调",
        "message": "为此智能体启动新的自动微调：",
        "messageSuffix": "（将使用与本次运行相同的数据集和配置选项）",
        "confirmLabel": "重试",
        "successToast": "新的自动微调运行已启动。",
        "errorToast": "重试自动微调失败。"
      }
    },
    "detail": {
      "agentStudio": "智能体工作室",
      "autoTuneRunsList": "自动调优运行列表",
      "backToList": "返回列表",
      "sessionOverview": "会话概述",
      "configuration": "配置",
      "evaluationDetail": "评估详细信息",
      "nodeFeedback": "节点反馈",
      "nodeComparison": "节点比较",
      "iterationHistory": "迭代历史",
      "approveDeploy": "批准并部署",
      "applyChanges": "将更改应用于草稿",
      "rejectOptimization": "拒绝优化",
      "sessionStatus": "会话状态",
      "optimizerConfig": "优化器配置",
      "evaluation": "评估",
      "originalSystemPrompt": "原始系统提示",
      "optimizedSystemPrompt": "优化系统提示",
      "loading": {
        "opening": "正在打开自动微调运行…",
        "session": "正在加载优化会话..."
      },
      "notFound": {
        "message": "未找到自动微调会话",
        "backButton": "返回自动微调运行"
      },
      "header": {
        "defaultTitle": "优化智能中心",
        "workflow": "工作流",
        "created": "已创建",
        "backToRunsAria": "返回运行列表"
      },
      "banner": {
        "failedTitle": "优化失败",
        "rejectedTitle": "优化后的提示词被拒绝",
        "noReason": "未提供拒绝原因。"
      },
      "tabs": {
        "overview": "概述",
        "objectives": "目标函数",
        "nodes": "节点分析",
        "prompts": "提示词实验室",
        "regression": "回归分析",
        "execution": "执行追踪",
        "audit": "审计与修复"
      },
      "applyPanel": {
        "title": "应用策略",
        "applyCurrent": "应用到当前智能体",
        "newVersion": "保存为新版本",
        "previewOnly": "仅预览",
        "versionBump": "版本升级：",
        "saveAsNewProject": "保存为新项目",
        "projectName": "项目名称",
        "placeholderReason": "可选原因...",
        "reject": "拒绝",
        "approveApply": "批准并应用",
        "noPermission": "您没有权限创建项目。",
        "previewUnavailable": "“仅预览”模式不可用 — 请先选择一个应用策略。"
      },
      "overview": {
        "pairedBaseline": "配对基线（训练）",
        "pairedPostMean": "配对后均值",
        "evalAccuracyImprovement": "评估准确率提升",
        "baselineTrain": "基线（训练）",
        "baselineHoldout": "基线（留出）",
        "optimizedScoreTrain": "优化后评分（训练）",
        "optimizedScoreHoldout": "优化后评分（留出）",
        "improvementTrain": "提升率（训练）",
        "improvementHoldout": "提升率（留出）",
        "estimatedCost": "估计花费",
        "duration": "时长",
        "totalIterations": "总迭代次数",
        "optimizer": "优化器",
        "nodesTotal": "节点总数",
        "tokensSession": "标记数量（会话）",
        "metricsUsed": "使用的度量指标",
        "orchestrator": "调度器",
        "openWorkflowRun": "打开工作流运行",
        "lightningRuns": "智能体 Lightning 图运行",
        "runId": "运行 ID",
        "start": "开始",
        "end": "结束",
        "optimizedScore": "优化评分",
        "improvement": "提升率",
        "iterations": "迭代次数",
        "holdoutPostTune": "留出集（微调后）",
        "cost": "花费",
        "version": "版本",
        "configurationSummary": "配置摘要",
        "runTimeline": "运行时间线",
        "timeline": {
          "created": "已创建",
          "started": "已开始",
          "completed": "已完成",
          "approvedBy": "已由 {{user}} 批准"
        },
        "noMetricBreakdown": "该会话没有按度量的明细数据（例如，得分未按度量保存）。打开评分详细信息（信息图标）以了解如何定义总体评分。",
        "metricBreakdownTitle": "度量明细",
        "columnMetric": "度量指标",
        "columnBaseline": "基线",
        "columnOptimized": "优化后",
        "columnDelta": "变化量",
        "columnChange": "变化",
        "explainerLead": "得分是由您的评估指标构建的0-1范围内的单个综合值，然后在整个基准行上进行聚合。",
        "explainerStep1Title": "单行综合（目标）",
        "explainerStep1Desc": "对于每个数据集行，系统运行配置的评估器（见下方指标），每个指标产生一个得分。较低的原始值更好（例如毒性）的指标在混合前会被映射为较高的值，以确保更高总是意味着更好。",
        "explainerWeightedSumPrefix": "行得分是",
        "explainerWeightedSum": "加权和",
        "explainerWeightedSumMid": "这些调整后的得分：",
        "explainerWeightedSumSuffix1": "，使用",
        "explainerWeightedSumSuffix2": "来自此会话（归一化为和为1）。",
        "explainerUnweightedPrefix": "没有",
        "explainerUnweightedMid": "被设置，因此行得分是",
        "explainerUnweighted": "未加权平均值",
        "explainerUnweightedSuffix": "该行的调整后指标得分的。",
        "explainerStep2Title": "基线得分（训练拆分）",
        "explainerStep2Desc": "总体基线是训练拆分（不包括留出集行）上单行综合得分的算术平均值，仅使用配置的会话指标，在未出现执行错误的完成行上计算：",
        "explainerStep3Title": "优化评分与轨迹",
        "explainerStep3Desc": "在提示词更改后对智能体进行评分时使用相同的综合定义；总体优化得分和迭代曲线使用相同的缩放比例。",
        "explainerMultiObjEnabled": "多目标模式已启用。",
        "explainerMultiObjMid": "（下方）可以指导多目标优化；基线和单行综合仍遵循",
        "explainerMultiObjSuffix": "（当设置时），否则如上所述等权重计算。",
        "explainerMetricsEvaluated": "本次会话中评估的度量",
        "explainerRowWeights": "行综合权重",
        "explainerMultiObjWeights": "多目标权重",
        "columnRawWeight": "原始权重",
        "columnNormalized": "归一化",
        "columnMetricObjective": "度量指标 / 目标",
        "explainerThisSession": "本次会话：",
        "explainerBaselineTrain": "基线（训练）=",
        "explainerOptimizedEquals": "优化后 ="
      },
      "objectives": {
        "noObjectives": "未定义目标函数",
        "columnName": "目标函数名称",
        "columnWeight": "权重",
        "columnFormula": "公式",
        "columnDescription": "描述"
      },
      "nodes": {
        "noNodes": "暂无节点结果数据",
        "columnId": "节点 ID",
        "columnOptimizer": "优化器",
        "columnBaseline": "基线评分",
        "columnOptimized": "优化评分",
        "columnImprovement": "提升率",
        "columnTrajectory": "轨迹",
        "columnHoldout": "留出集评分",
        "columnHoldoutImp": "留出集提升",
        "customPrompt": "自定义系统提示词",
        "modelOverride": "模型重写",
        "instructionsOverride": "DSPy 指令重写",
        "columnNode": "节点",
        "columnIter": "迭代",
        "columnBlame": "归因",
        "columnOriginalTrain": "原始（训练）",
        "columnOptimizedTrain": "优化后（训练）",
        "columnHealing": "自我修复",
        "columnCost": "成本",
        "collapse": "折叠",
        "showConfig": "显示配置 / 优化器详细信息",
        "noNodeAnalysisData": "该会话暂无节点分析数据。"
      },
      "prompts": {
        "nodeLabel": "节点：",
        "selectNode": "选择节点以查看其提示词...",
        "originalSystemPrompt": "原始系统提示词",
        "optimizedSystemPrompt": "优化后的系统提示词",
        "originalInstructions": "原始指令（DSPy）",
        "optimizedInstructions": "优化指令（DSPy）",
        "versionBase": "基础",
        "versionLatest": "最新优化",
        "selectVersion": "选择版本",
        "fallbackLeft": "左",
        "fallbackRight": "右",
        "noData": "该会话暂无提示词或参数数据。"
      },
      "regression": {
        "noData": "暂无回归分析数据。",
        "columnRowIndex": "行索引",
        "columnBaseline": "基线",
        "columnOptimized": "优化后",
        "columnChange": "变化",
        "columnInput": "输入预览",
        "columnError": "错误",
        "columnOutput": "输出预览",
        "improvedRows": "已改善的行",
        "degradedRows": "已恶化的行",
        "quarantinedRows": "被隔离的行",
        "columnRowNumber": "行 #",
        "columnQuestionInput": "问题 / 输入",
        "columnDelta": "变化量",
        "columnWhatChanged": "改变了什么",
        "columnInputPreview": "输入预览",
        "columnOutputPreview": "输出预览",
        "metricNetImprovement": "净提升率",
        "metricImprovedRows": "已改善的行",
        "metricDegradedRows": "已恶化的行",
        "metricUnchangedRows": "未改变的行",
        "metricTotalRows": "总行数",
        "metricHoldoutEvaluated": "已评估的留出集行数",
        "noDegradedRows": "没有恶化的行",
        "noImprovedRows": "没有改善的行",
        "noQuarantinedRows": "没有被隔离的行",
        "noReport": "该会话没有回归报告或被隔离的行。"
      },
      "execution": {
        "title": "管道执行时间线",
        "noData": "暂无执行时间线数据。",
        "columnTask": "任务 / 阶段",
        "columnDuration": "时长",
        "columnStatus": "状态",
        "columnDetails": "详情 / 输出",
        "activeRun": "活动的运行",
        "currentProcess": "当前进程",
        "activeNode": "活动节点",
        "optimizingNode": "正在优化节点：{{node}}",
        "nodeId": "节点 ID",
        "lastProcess": "最后一个进程",
        "phaseDurationWaterfall": "阶段持续时间瀑布图",
        "phaseDurationDesc": "已完成的运行阶段时长（按时间顺序，单位为秒）。",
        "phaseDurationExplainer": "每个条形图代表一个已完成的工作流阶段（基线、联合/Lightning、每节点优化、验证）。高度表示以秒为单位的时长；最终的总计条形图汇总了所有已完成的阶段。",
        "phaseDurationsPending": "随着阶段完成，这里将显示阶段持续时间。",
        "phaseDurationsEmpty": "此运行未记录阶段持续时间历史。",
        "phaseLog": "阶段日志",
        "fallbackPhase": "阶段 {{num}}"
      },
      "audit": {
        "healingEvents": "自我修复事件",
        "auditTrail": "审计追踪",
        "noData": "该会话暂无审计或自我修复数据。",
        "auditTrailCount": "审计追踪"
      },
      "charts": {
        "scoreTrajectory": "得分轨迹",
        "baselineObjective": "基线与目标评分",
        "metricComparison": "度量比较：基线 vs 优化后",
        "convergenceAnalysis": "收敛分析",
        "blameWaterfall": "归因瀑布图",
        "costTokenBreakdown": "每个节点的成本与标记明细",
        "scatterBaselineOpt": "基线 vs 优化散点图（训练行）",
        "phaseDuration": "阶段持续时间瀑布图",
        "howToRead": "如何阅读此图表",
        "xAxisPhase": "阶段",
        "yAxisDuration": "时长（秒）",
        "summaryScoreTrajectory": "每个运行里程碑（基线、可选的Lightning、优化迭代、验证）的综合评分，在第二个轴上显示步与步之间的增量。",
        "summaryBaselineObjective": "根据您的度量得出的0-1综合评分；成功行的基线平均值。使用信息图标查看公式、权重和此会话的值。",
        "summaryMetricComparison": "分组条形图比较配置的每个度量的基线与微调后平均值。",
        "summaryConvergenceAnalysis": "连续轨迹点之间的|Δ 评分|—帮助发现改进何时减缓或停滞。",
        "summaryBlameWaterfall": "每个画布节点的相对归因评分—较高的条形表示对糟糕基线结果造成更多影响的节点，通常优先进行优化。",
        "summaryCostTokenBreakdown": "所有评估中归因于每个节点的总提示和完成标记（左轴）以及估计成本（右轴）。",
        "summaryScatterBaselineOpt": "每个点是验证后的一个训练行：x = 微调前的综合评分，y = 带有微调提示词的综合评分。虚线对角线是未变化线 (y = x)。"
      }
    }
  },
  "aiTransparency": {
    "title": "AI 透明度",
    "loadingInventory": "正在加载 AI 透明度库存...",
    "allSystemAgents": "所有系统代理",
    "systemAgent": "系统代理",
    "registeredBy": "注册者",
    "project": "项目",
    "agentSubAgent": "代理 / 子代理",
    "env": "环境",
    "subAgentCount": "子代理数量",
    "actions": "操作",
    "viewMetadata": "查看元数据",
    "searchAgents": "搜索代理...",
    "emptyMessage": "暂无注册的代理。从智能体工作室注册已发布的代理即可在此处查看。",
    "unknown": "未知",
    "status": "状态",
    "metadata": "元数据",
    "expandAgent": "展开 {{name}}",
    "collapseAgent": "折叠 {{name}}",
    "subAgentFallback": "子代理 {{index}}",
    "subAgentTypes": {
      "agent": "子代理",
      "supervisor": "监督者",
      "intent_classifier": "意图分类器",
      "disambiguation": "消歧",
      "external_agent": "外部代理",
      "rlm": "RLM",
      "router": "路由器",
      "hitl": "人工审批",
      "sub_agent": "子代理"
    }
  },
  "registry": {
    "agents": {
      "columnAgentName": "代理名称",
      "registerAgent": "注册代理",
      "searchRegisteredAgents": "搜索已注册代理...",
      "searchArchivedAgents": "搜索已归档代理...",
      "emptyActiveAgentsDesc": "暂无已注册的代理。从智能体工作室注册已发布的代理后将在此处显示。",
      "emptyArchivedAgentsDesc": "暂无已归档代理。从注册表中归档的代理将显示在此处。",
      "registeredAgentsTitle": "已注册的代理",
      "archivedAgentsTitle": "已归档的代理",
      "agentsLabel": "代理",
      "agentRegistryTitle": "代理注册表",
      "filterSystemAgent": "系统代理",
      "filterAllSystemAgents": "所有系统代理",
      "loadingAgents": "正在加载代理...",
      "searchAgents": "搜索代理...",
      "dynamicFilter_agent_type": "类型",
      "columnAgent": "代理",
      "editAgentTitle": "编辑代理",
      "configureAgentTitle": "配置 {{platformName}}",
      "registerAgentBtn": "注册代理",
      "selectAgentPlatformDesc": "选择创建代理的平台",
      "importAgentsTitle": "从CSV导入代理",
      "importAgentsDesc": "仅创建外部代理。与项目中现有名称+版本匹配的行将被跳过，永远不会被覆盖。凭据永远不会从CSV读取——请随后通过编辑附加它们。",
      "agentEntity": "代理"
    },
    "workflows": {
      "columnWorkflow": "工作流名称",
      "workflowsLabel": "工作流",
      "searchRegisteredWorkflows": "搜索已注册工作流...",
      "searchArchivedWorkflows": "搜索已归档工作流...",
      "loadingRegisteredWorkflows": "正在加载已注册工作流...",
      "loadingArchivedWorkflows": "正在加载已归档工作流...",
      "emptyRegisteredWorkflows": "暂无已注册工作流。",
      "emptyArchivedWorkflows": "暂无已归档工作流。",
      "bulkArchiveWorkflows": "归档所选",
      "bulkRestoreWorkflows": "恢复所选",
      "workflowRegistryTitle": "工作流注册表",
      "registeredWorkflowsTitle": "已注册的工作流",
      "archivedWorkflowsTitle": "已归档的工作流",
      "registerExternalWorkflowTitle": "注册外部工作流",
      "selectWorkflowPlatformDesc": "选择构建工作流的平台。此注册仅为目录（无TAGP执行）。",
      "importWorkflowsTitle": "从CSV导入工作流",
      "importWorkflowsDesc": "仅创建存根草稿工作流。匹配键是项目中的名称+版本。现有的工作流将被跳过且永远不会被覆盖。新的存根在发布和注册之前将保持为草稿/未注册状态。",
      "workflowEntity": "工作流",
      "loading": "正在加载工作流..."
    },
    "guardrails": {
      "guardrailsLabel": "护栏",
      "actionGuardrails": "护栏",
      "guardrailsRepository": "护栏存储库",
      "agentGuardrails": "代理护栏",
      "guardrailsCoverage": "覆盖范围",
      "searchProfiles": "搜索配置文件...",
      "newProfile": "新配置文件",
      "noGuardrailsAccess": "您无权访问任何护栏子功能。",
      "loadingProfiles": "正在加载配置文件...",
      "columnAttachedProfiles": "附加的配置文件",
      "coverageBanner": "仅配置覆盖范围 — 不改变强制执行。差距是库存信号。",
      "exportCoverageCsv": "导出 CSV",
      "loadingCoverage": "正在加载覆盖图...",
      "coverageCovered": "已覆盖",
      "coverageGap": "差距",
      "coverageNA": "N/A",
      "coverageUnknown": "未知",
      "createProfileBtn": "创建配置文件",
      "savingProfileBtn": "保存中...",
      "updateProfileBtn": "更新配置文件",
      "editProfileTitle": "编辑配置文件",
      "newGuardrailProfileTitle": "新的 Guardrail 配置文件",
      "profileNameLabel": "配置文件名称 *",
      "profileNamePlaceholder": "例如：PII保护标准",
      "profileNameHint": "仅限字母、数字、空格、连字符和下划线",
      "profileDescLabel": "描述",
      "profileDescPlaceholder": "描述此 Guardrail 配置文件...",
      "profileDescHint": "仅限纯文本 — 无表情符号或特殊字符",
      "guardrailsEnabled": "Guardrails 已启用",
      "guardrailsDisabled": "Guardrails 已禁用",
      "noEnginesConfigured": "未配置 Guardrail 引擎",
      "enginesActive": "{{enabledCount}}/{{totalCount}} 个引擎已激活",
      "inactiveDeploymentBanner": "此代理的部署处于非活动状态。配置受到限制。",
      "devFrozenBanner": "此代理已发布。DEV 护栏已冻结 — 请改为编辑 QA/UAT/PROD 部署护栏。",
      "adminOnlyBanner": "只有管理员才能修改部署护栏。",
      "recentViolations": "最近的违规记录",
      "metricsSummaryTitle": "指标摘要",
      "metricTotalChecks": "总检查数",
      "metricBlocked": "已拦截",
      "metricWarned": "警告",
      "metricPassed": "已通过",
      "metricErrors": "错误",
      "metricLatency": "延迟",
      "searchViolationsPlaceholder": "搜索违规...",
      "noRecentViolations": "最近没有违规",
      "violationTimestamp": "时间戳",
      "violationUser": "用户",
      "violationEngine": "引擎",
      "violationStatus": "状态",
      "violationDetails": "详细信息",
      "violationAction": "操作",
      "violationRule": "规则",
      "columnEngines": "引擎",
      "loading": "正在加载护栏...",
      "configMode": "模式",
      "configExecution": "执行",
      "configTimeout": "默认超时 (秒)",
      "configSafeMessage": "安全消息",
      "configCircuitBreaker": "断路器",
      "configFailureThreshold": "故障阈值",
      "configCooldown": "冷却时间 (秒)",
      "modeBlock": "拦截 — 拦截标记的内容",
      "modeObserve": "观察 — 仅记录，不拦截",
      "execSequential": "顺序",
      "execParallel": "并行",
      "safeMessagePlaceholder": "由于内容政策限制，我无法处理此请求。",
      "mode_block": "拦截 — 拦截标记的内容",
      "mode_warn": "警告 — 记录警告，允许内容",
      "mode_shadow": "观察 — 仅记录，不拦截",
      "exec_sequential": "顺序",
      "exec_parallel": "并行"
    },
    "common": {
      "columnProject": "项目",
      "columnVersion": "版本",
      "exportCsvTitle": "导出 CSV (包含配置列)",
      "exportCsvAria": "导出 CSV",
      "importCsvTitle": "导入 CSV",
      "importCsvAria": "导入 CSV",
      "columnEnv": "环境",
      "columnOrchestrator": "编排器",
      "columnFramework": "框架",
      "columnRegisteredBy": "注册者",
      "columnRegisteredAt": "注册时间",
      "columnArchivedAt": "归档时间",
      "columnActions": "操作",
      "columnStatus": "状态",
      "filterBarTitle": "筛选",
      "filterAll": "全部",
      "filterFavorites": "收藏",
      "filterFramework": "框架",
      "filterProject": "项目",
      "filterRegisteredBy": "注册者",
      "filterType": "类型",
      "filterStatus": "状态",
      "loadingRegistered": "正在加载已注册代理...",
      "loadingArchived": "正在加载已归档代理...",
      "bulkArchive": "归档所选",
      "bulkRestore": "恢复所选",
      "bulkDelete": "删除所选",
      "deleteSelected": "删除所选",
      "showLess": "收起",
      "actionTest": "测试",
      "actionExecute": "执行",
      "actionEdit": "编辑",
      "actionViewMetadata": "查看元数据",
      "actionEditMetadata": "编辑元数据",
      "actionEvaluate": "评估",
      "actionViewEvalRuns": "查看评估运行",
      "actionTraces": "追踪",
      "actionLogs": "日志",
      "actionApiDocs": "API 文档",
      "actionClone": "克隆",
      "actionDeploy": "部署",
      "actionDelete": "删除",
      "actionArchive": "从注册表归档",
      "actionRestore": "恢复到注册表",
      "actionOpen": "打开",
      "actionPromoteToStore": "推广到商店",
      "actionRuns": "运行",
      "actionOpenCanvas": "打开画布",
      "registerExternal": "注册外部",
      "allCreators": "所有创建者",
      "searchCreators": "搜索创建者...",
      "creatorLabel": "创建者",
      "tableRows": "行数：",
      "tableShowing": "显示第 {{startItem}}-{{endItem}} 项，共 {{totalItems}} 项",
      "filterResultsOf": "{{resultCount}} / {{totalCount}}",
      "filterResultsCount": "{{count}} 个结果",
      "filterLess": "收起",
      "filterMore": "更多",
      "filterClearAll": "清除所有筛选条件",
      "filterClear": "清除",
      "filterSavePreset": "保存筛选预设",
      "noDataAvailable": "没有可用数据",
      "actionView": "查看",
      "filterAllEnvironments": "所有环境",
      "dynamicFilter_status": "状态",
      "dynamicFilter_catalog_status": "状态",
      "dynamicFilter_type": "类型",
      "columnEnvShort": "环境",
      "columnChat": "聊天",
      "columnAPI": "API",
      "columnVoice": "语音",
      "columnRAG": "RAG",
      "columnTools": "工具",
      "columnEnabled": "已启用",
      "columnMode": "模式",
      "columnContentSafety": "内容安全",
      "columnJailbreak": "越狱 / Prompt Shields",
      "columnDLP": "DLP / PII",
      "columnProfileAttached": "已附加配置",
      "columnWorkflowChannel": "工作流",
      "cancelBtn": "取消",
      "globalSettings": "全局设置",
      "architectureTitle": "架构",
      "reviewSaveTitle": "检查并保存",
      "reviewRegisterTitle": "检查并注册",
      "stepReview": "检查",
      "stepPlatform": "平台",
      "stepConfigure": "配置",
      "stepArchitecture": "架构",
      "savingBtn": "保存中...",
      "registeringBtn": "注册中...",
      "saveChangesBtn": "保存更改",
      "statusActive": "活跃",
      "statusInactive": "非活跃",
      "statusPublished": "已发布",
      "actionDeleteSelected": "删除所选",
      "columnName": "名称",
      "columnDescription": "描述",
      "expectedColumns": "预期列",
      "platformAdminConfigureFields": "平台管理员配置字段",
      "downloadTemplate": "下载模板",
      "chooseCsv": "选择CSV",
      "importBtn": "导入",
      "importingBtn": "导入中...",
      "registerWorkflowBtn": "注册工作流",
      "dynamicOption_agent": "代理",
      "dynamicOption_sub-agent": "子代理",
      "closeBtn": "关闭",
      "statRows": "行",
      "statCreated": "已创建",
      "statDuplicates": "重复",
      "statErrors": "错误",
      "viewDuplicates": "查看重复项",
      "dupTitle": "导入重复项已跳过",
      "dupRowsProcessed": "已处理的行",
      "dupCreated": "已创建",
      "dupSkipped": "已跳过的重复项",
      "dupHint2": "数据库中已存在该名称，但未在注册表中显示；请重命名或增加版本号",
      "dupNoMatch": "没有匹配此过滤器的重复项。",
      "dupSearchPlaceholder": "搜索重复项...",
      "dupRowsPerPage": "每页行数:",
      "hideAll": "隐藏全部",
      "showAll": "显示全部",
      "loading": "加载中..."
    }
  },
  "exportImport": {
    "import": {
      "dialogTitle": "导入 YAML",
      "bulkDialogTitle": "批量导入",
      "filesCount": "{{count}} 个文件",
      "filesCount_plural": "{{count}} 个文件",
      "validFilesCount": "{{count}} 个有效文件",
      "validFilesCount_plural": "{{count}} 个有效文件",
      "withErrorsCount": "{{count}} 个包含错误",
      "withErrorsCount_plural": "{{count}} 个包含错误",
      "switchToSingle": "切换至单文件",
      "switchToBulk": "切换至批量导入",
      "targetProject": "目标项目",
      "optional": "(可选)",
      "selectTargetProject": "选择目标项目...",
      "selectProjectOptional": "选择项目 (可选)...",
      "selectProjectWarning": "请选择一个项目以导入 {{entity}}",
      "thisEntity": "此实体",
      "dropzoneBulk": "拖放 YAML 文件或点击浏览 (支持多选)",
      "dropzoneSingle": "拖放 YAML 文件或点击浏览",
      "fileTypes": ".yaml, .yml",
      "importingProgress": "正在导入 {{total}} 个中的第 {{current}} 个...",
      "yamlContentLabel": "YAML 内容",
      "yamlPlaceholderComment": "在此处粘贴或编辑 YAML 内容",
      "importBehavior": "导入行为",
      "matchOrCreate": "匹配或新建",
      "matchOrCreateDesc": "关联至已有实体，若不存在则新建",
      "matchOnly": "仅匹配",
      "matchOnlyDesc": "仅关联至已有实体，若不存在则跳过",
      "createNew": "新建",
      "createNewDesc": "始终新建，若已存在则失败",
      "previewResults": "预览结果",
      "newBadge": "+{{count}} 个新建",
      "skippedBadge": "{{count}} 个跳过",
      "failedBadge": "{{count}} 个失败",
      "createdBadge": "+{{count}} 个已创建",
      "moreEntities": "+{{count}} 个其他实体",
      "moreErrors": "+{{count}} 个其他错误",
      "moreWarnings": "+{{count}} 个更多",
      "importSuccessful": "导入成功",
      "bulkImportComplete": "批量导入完成",
      "importFailed": "导入失败",
      "bulkImportCompletedWithErrors": "批量导入完成 (存在错误)",
      "notes": "备注：",
      "errors": "错误：",
      "done": "完成",
      "cancel": "取消",
      "preview": "预览",
      "import": "导入",
      "importing": "正在导入...",
      "importAll": "全部导入 ({{count}})",
      "removeFile": "移除文件",
      "buttonTitle": "导入 YAML",
      "buttonAria": "导入 YAML",
      "buttonLabel": "导入",
      "failedToReadFile": "读取文件失败",
      "invalidYaml": "无效的 YAML",
      "importFailedGeneric": "导入失败",
      "typeMismatchError": "该文件包含 {{detectedName}}，但您当前位于 {{expectedName}} 页面。请从正确的页面导入该文件。"
    },
    "configWarnings": {
      "title": "需要配置",
      "subtitle": "在配置以下项目之前，导入的实体可能无法正常工作：",
      "actionRequired": "需要操作：",
      "actionRequiredDesc": "发现 {{criticalCount}} 个严重{{criticalLabel}}和 {{warningCount}} 个{{warningLabel}}。如果不解决严重问题，智能体可能无法正常工作。",
      "actionRequiredOnlyCritical": "发现 {{criticalCount}} 个严重{{criticalLabel}}。如果不解决严重问题，智能体可能无法正常工作。",
      "issue": "问题",
      "issues": "问题",
      "warning": "警告",
      "warnings": "警告",
      "critical": "严重",
      "categories": {
        "model": "AI 模型",
        "models": "AI 模型",
        "prompt": "提示词",
        "prompts": "提示词",
        "tool": "工具",
        "tools": "工具",
        "knowledge": "知识源",
        "skill": "技能",
        "skills": "技能",
        "connector": "连接器",
        "connectors": "连接器",
        "iam": "IAM 配置",
        "other": "其他"
      }
    },
    "export": {
      "export": "导出",
      "exportSelected": "导出所选",
      "exportYaml": "导出 YAML",
      "exportAgent": "导出智能体",
      "agentAlwaysIncluded": "智能体 (始终包含)",
      "included": "已包含",
      "dependencies": "依赖项",
      "selectedOf": "已选 {{selected}} / {{total}}",
      "selectAll": "全选",
      "deselectAll": "取消全选",
      "loadingDeps": "正在加载依赖项...",
      "noDeps": "未找到依赖项。将仅导出智能体。",
      "permissionDenied": "您没有权限导出此智能体。请联系管理员。",
      "failedToLoadDeps": "加载依赖项失败",
      "filesWillBeExported": "将导出 {{count}} 个 YAML 文件",
      "filesWillBeExported_plural": "将导出 {{count}} 个 YAML 文件",
      "cancel": "取消",
      "confirmExport": "确认导出",
      "exporting": "正在导出..."
    },
    "entityTypes": {
      "model": "模型",
      "tool": "工具",
      "prompt": "提示词",
      "skill": "技能",
      "agent": "智能体",
      "knowledge": "知识源",
      "storage_folder": "存储文件夹",
      "connector": "连接器",
      "iam": "IAM 配置",
      "bundle": "捆绑包",
      "workflow": "工作流"
    }
  }
}